import {
  Injectable,
  PLATFORM_ID,
  NgZone,
  ViewChild,
  Injector,
  forwardRef,
  Inject,
} from '@angular/core';
import {
  AngularfirestoreCoolStoreService,
  AngularfirestoreVideoStoreService,
} from './angularfirestore-extension.service';
import { AngularFirestore, AngularFirestoreModule, CollectionReference } from '@angular/fire/firestore';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import { FirebaseConstants } from '../shared/FirebaseConstants';
import { buildApplicantImportDoc } from '../upload/applicant-import.util';
import { BehaviorSubject, Observable, from, of } from 'rxjs';
import {
  AngularFireStorage,
  AngularFireStorageReference
} from '@angular/fire/storage';
import { AngularFireAuth } from '@angular/fire/auth';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { RouterOutlet, Router } from '@angular/router';
import { AlertController, ToastController } from '@ionic/angular';
import { MenuService } from './menu-service';
import { AuthService } from './auth.service';
import { isPartnerLaunch } from '../ars-embed/partner-launch-sandbox';
import { FirebaseService } from './firebase.service';
import { cfRegionLinks } from '../core/helper/cfRegionLinks';
import { resolvePlatformLanguage } from '../core/helper/platform-language.helper';
import { isHybridPlan } from '../core/helper/plan-routing.helper';
import { stripUndefinedDeep } from '../core/helper/firestore-sanitize.helper';
import { DEFAULT_TASK_SHARING_MODE, normalizeSharingMode, TaskSharingMode } from '../core/helper/task-ownership';
import { AGENT_CALENDAR_PREFERENCE_KEYS, ConnectedCalendar, agentPreferenceDocId, pickOwnCalendar, preferenceNeedsUpdate } from './calendar-agent-sync';
import { PARTNER_SERVER_FIELDS, getOnboardingPartner } from '../partner-onboarding/partner-onboarding';
import { environment } from 'src/environments/environment';
import { Packages } from '../pricing/packages';
import { switchMap, take, timeout } from 'rxjs/operators';
export interface FILE {
  name: string;
  filepath: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerdatabaseService {
  public bewerber;
  public bewerbervertraege: firebase.firestore.CollectionReference;
  coolClctn$: Observable<any>;
  perfectClctn$: Observable<any>;
  app2 = null;
  secondApp = null;
  auth: AngularFireAuth;
  customerStorage: AngularFireStorage;
  private isConnected = false;
  public customerStorageReady: boolean = false;
  isPremium = false;
  isCustomer = false;
  isFreemium = false;
  customerNumber;
  isAgentsCustomer = false;
  private customerAddons: string[] = [];
  private userHybridAccess: boolean = false;
  newContractId = '';
  userId = '';
  static joinJobOffers = [];
  // userStorage;
  joinApiKey = '';
  JoinBewerber = [];
  HostingURL = '';
  teammemberId = '';
  db;
  calendar = '';
  cloudFunctionURL = '';
  cloudFunctionWaitingVideoURL = '';
  userEmail = '';
  public applicantProfile: firebase.firestore.CollectionReference;
  public monaactivities: firebase.firestore.CollectionReference;
  public applicantProfileImport: firebase.firestore.CollectionReference;
  public jobs: firebase.firestore.CollectionReference;
  public agentFolders: firebase.firestore.CollectionReference;
  customerAdminEmailAdress = '';
  subscription: Subscription;
  InternetStatus = 'green';
  assessmentTests: any[] = [];
  businessName = '';
  businessLogo = '';
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  unsubscribe: Subscription;
  jobOfferSubscription: any;
  thirtyDaysAgo: Date = new Date();
  createdQuery: any;
  localApiKey = '';
  // AI disclaimers
  seenDisclaimer = false;
  confirmedDisclaimer = false;
  currentPlan = '';

  accountId = "";
  lastEmail: any = null;
  blackListItems: any[] = [];
  loading = false;
  lastDoc: any;
  public hasMoreDataBlacklist: boolean = true;

  salesEmailsData: any;
  salesEmailDataHistory: any;
  companiesData: any;

  platformLanguageObject = {
    isCode: "de",
    lang: "Deutsch",
    language: "deutsch",
  };
  bucketName = "";

  private firebaseService;

  private _isAuthenticatedOnCustDb = new BehaviorSubject<boolean>(false);
  public isAuthenticatedOnCustDb$ = this._isAuthenticatedOnCustDb.asObservable();

  private _locations: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public locations$ = this._locations.asObservable();


  licenses = 0;

  private _collectionsInitialized = false;

  user: any;

  constructor(
    private coolStore: AngularfirestoreCoolStoreService,
    private videoStore: AngularfirestoreVideoStoreService,
    private zone: NgZone,
    private toastService: ToastController,
    private storage: AngularFireStorage,
    private http: HttpClient,
    private menuService: MenuService,
    private alertCtrl: AlertController,
    private router: Router,
    private authService: AuthService,
    private injector: Injector,
  ) {
    console.log('init customerDB');
    this.thirtyDaysAgo.setDate(this.thirtyDaysAgo.getDate() - 30);
  }

  private ensureCollections() {
    if (this._collectionsInitialized) return;
    this._collectionsInitialized = true;
    this.applicantProfile = firebase.firestore().collection('applicantProfile');
    this.applicantProfileImport = firebase.firestore().collection('applicants');
    this.monaactivities = firebase.firestore().collection('activities');
    this.jobs = firebase.firestore().collection('JobsToCallApplicants');
    this.agentFolders = firebase.firestore().collection('agentFolders');
  }

  setEnterprisePlanLimits() {
    if (this.customerNumber === undefined || this.customerNumber === null || this.customerNumber === '') {
      return;
    }
    this.coolStore.firestore.collection(FirebaseConstants.companies).where("kundennummer", "==", this.customerNumber).get().then((snap) => {
      if (snap.docs && snap.docs.length > 0) {
        let doc = snap.docs[0];
        if (doc.exists) {
          const data = doc.data();
          let currentPlan = data.planLimits;
          this.app2.firestore.collection(FirebaseConstants.branding).get().then((snap) => {
            if (snap.docs && snap.docs.length > 0) {
              let doc = snap.docs[0];
              if (doc.exists) {
                const data = doc.data();
                let brandingPlan = data.planLimits;
                if (!brandingPlan || brandingPlan.planName == undefined) {
                  doc.ref.update({
                    planLimits: currentPlan,
                  });
                }
              }
            }
          });
        }
      }
    });
  }

  setSelfServicePlan() {
    this.coolStore.firestore.collection(FirebaseConstants.customers).doc(this.authService.returnUserId()).get().then((snap) => {
      if (snap.exists) {
        const data = snap.data();
        let currentPlan = data.planLimits;
        //return early if no plan limits
        //right now (09.01.2026) plan limits is only for recruiting plans (including enterprise)
        //for agents, no plan limits are set
        if (!currentPlan) return;
        this.app2.firestore.collection(FirebaseConstants.branding).get().then((snap) => {
          if (snap.docs && snap.docs.length > 0) {
            let doc = snap.docs[0];
            if (doc.exists) {
              const data = doc.data();
              let brandingPlan = data.planLimits;
              if (!brandingPlan || brandingPlan.planName == undefined) {
                doc.ref.update({
                  planLimits: currentPlan,
                });
              }
            }
          }
        });
      }
    });
  }

  sendContacting(testMail, testMobil, testFirstName, testLastName, filePath, selectedJobId, userEmail) {
    this.app2.firestore.collection('emailapplicants').add({
      created: new Date(),
      createdEmailZapier: new Date(),
      email: testMail || '',
      mobilnummer: testMobil || '',
      vorname: testFirstName || '',
      nachname: testLastName || '',
      cv: filePath || '',
      emailTextHTML: 'test',
      emailTextPlain: 'test',
      senderEmail: userEmail || '',
      jobId: selectedJobId || '',
      quelle: 'singleContacting'
    });
  }

  isSelfServiceMode(): boolean {
    // Self-service when plan name contains 'self-service' (e.g. recruiting-and-sales-25-self-service)
    const plan = this.currentPlan || this.authService.getUserPlan() || '';
    return plan.includes('self-service');
  }

  getLicenses() {
    return this.licenses;
  }

  setLicenses(licenses: number) {
    this.licenses = licenses;
  }

  getPlatformLanguage() {
    return this.platformLanguageObject.language;
  }

  getPlatformLanguageObject() {
    return this.platformLanguageObject;
  }

  getCvPublicUrl() { }

  setcurrentPlan(plan) {
    this.currentPlan = plan || '';
    this.menuService.userRole$.next(plan);
    console.log('currentPlan', this.currentPlan);
  }

  returnCurrentPlan() {
    // If currentPlan is not set, try to get it from auth service
    if (!this.currentPlan) {
      this.currentPlan = this.authService.getUserPlan() || '';
    }
    return this.currentPlan;
  }

  getAccountId() {
    return this.accountId;
  }

  getLocalApiKey() {
    return this.localApiKey;
  }

  setLocalApiKey(apiKey: string) {
    this.localApiKey = apiKey;
  }

  clearCachedApiKey() {
    this.localApiKey = null;
    // Delegate so the stored expiry goes with the key; removing 'apiKey' alone would strand its
    // stamp and let the next key inherit it.
    this.authService.clearApiKey();
    console.log('[CustomerDB] Cleared cached API key');
  }

  uploadContextCache(userId: string, agentId: string, fileUrl: string) {
    console.log("uploadContextCache", userId, agentId, fileUrl);
    const rootFirestore = this.getRootFirestore();
    const docRef = rootFirestore
      .collection('users')
      .doc(userId)
      .collection('agentDocuments')
      .doc(agentId);
    console.log("docRef", docRef);
    return docRef.set(
      {
        files: firebase.firestore.FieldValue.arrayUnion(fileUrl),
        updated: new Date(),
      },
      { merge: true }
    );
  }


  // The inverse of uploadContextCache, and it takes the userId for the same reason that one does:
  // deleteFileCache below addresses users/{this.userId}, a field that is only assigned inside
  // setUserStorage and is blank on /organigram - so a caller there would write to the wrong document,
  // or to doc('') which Firestore rejects outright. This one is also awaitable: a rejected index write
  // is the difference between "removed" and a message that is not true.
  //
  // arrayRemove, not a read-filter-write set(): six frontend writers plus the monari backend append to
  // this array, and replacing it whole would silently drop anything added between the read and the
  // write. update() rather than set() so a missing record surfaces instead of being created empty.
  removeContextCacheFile(userId: string, agentId: string, fileUrl: string): Promise<void> {
    const rootFirestore = this.getRootFirestore();
    return rootFirestore
      .collection('users')
      .doc(userId)
      .collection('agentDocuments')
      .doc(agentId)
      .update({
        files: firebase.firestore.FieldValue.arrayRemove(fileUrl),
        updated: new Date(),
      });
  }

  deleteFileCache(agentId: string, fileUrl: string) {
    if (!agentId)
      return;
    const rootFirestore = this.getRootFirestore();
    rootFirestore.collection("users").doc(this.userId).collection("agentDocuments").doc(agentId).update({
      files: firebase.firestore.FieldValue.arrayRemove(fileUrl)
    })
  }

  getVideos() {
    this.videoStore.firestore
      .collection('videos')
      .get()
      .then((snap) => {
        console.log(snap);
      });
  }

  speedtest() {
    console.log('runnin');
    if (this.app2 == undefined) {
      // window.open("https://mona-ai-pwa-firebase.web.app")
    }
  }

  getUserData(email) {
    return this.coolStore.firestore.collection('customers');
  }

  getCustomerNumber() {
    return this.customerNumber;
  }

  hasHybridAddon(): boolean {
    return this.customerAddons.some(addon => 
      addon.toLowerCase().includes('hybrid')
    );
  }

  hasHybridAccess(): boolean {
    return this.userHybridAccess;
  }

  setHybridAccess(value: boolean) {
    this.userHybridAccess = value;
  }

  isTeamMember(): boolean {
    const userId = this.authService.returnUserId();
    return !!this.accountId && this.accountId !== userId;
  }

  canAccessHybridFeatures(): boolean {
    if (this.isTeamMember()) {
      return this.userHybridAccess;
    }
    return this.hasHybridAddon() || this.userHybridAccess;
  }

  setAddons(addons: string[]) {
    this.customerAddons = addons || [];
  }

  getAddons(): string[] {
    return this.customerAddons;
  }

  // Persist an ARS Starter trial conversion (signed up + paid) for the A/B experiment.
  async logArsStarterTrialConversion(data: { plan: string; currentPlan: string; trialGroup: string; trialDays: number }): Promise<void> {
    try {
      const userId = this.authService.returnUserId() || '';
      const email = this.authService.returnUser() || '';
      await firebase.firestore().collection('arsStarterTrialConversions').add({
        userId,
        email,
        plan: data.plan,
        currentPlan: data.currentPlan,
        trialGroup: data.trialGroup,
        trialDays: data.trialDays,
        converted: true,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        createdISO: new Date().toISOString()
      });
    } catch (e) {
      console.error('[ARS Trial] Failed to persist trial conversion:', e);
    }
  }

  recontactApplicants() {
    const date = new Date("2025-04-06");
    this.app2.firestore.collection("applicants").where("created", ">=", date).get().then(snapshot => {
      snapshot.forEach(doc => {
        if (doc.exists) {
          const data = doc.data();
          const jobOfferId = data.jobOfferId;
          if (jobOfferId == undefined || jobOfferId == "") {
            const applicantApp = data.applicant;
            if (applicantApp) {
              const applicantMandantId = applicantApp.niederlassung;
              if (applicantMandantId) {
                this.getProfile().get().then((snap) => {
                  const docs = snap.docs;
                  const docLength = docs.length;
                  if (docLength > 0) {
                    const docData = docs[0].data();
                    const locations = docData.standorte;
                    if (locations) {
                      for (const loc of locations) {
                        if (loc && loc.locationId) {
                          if (loc.locationId == applicantMandantId) {
                            const name = loc.name;
                            this.app2.firestore.collection("applicants").doc(doc.id).update({
                              jobOfferId: "DhUawKZkUTARVBFfJaCo",
                              jobOfferWorkflow: name
                            }).then(() => {
                              console.log("updated");
                            }).catch((error) => {
                              console.error("Error updating document: ", error);
                            });
                            break;
                          }
                        }
                      }
                    }
                  }
                })
              } else {
                this.app2.firestore.collection("applicants").doc(doc.id).update({
                  jobOfferId: "DhUawKZkUTARVBFfJaCo",
                }).then(() => {
                  console.log("updated");
                }).catch((error) => {
                  console.error("Error updating document: ", error);
                });
              }
            } else {
              this.app2.firestore.collection("applicants").doc(doc.id).update({
                jobOfferId: "DhUawKZkUTARVBFfJaCo",
              }).then(() => {
                console.log("updated");
              }).catch((error) => {
                console.error("Error updating document: ", error);
              });
            }
          }
        }
      });
    });
  }

  saveCustomerNumber(customerNumber) {
    this.customerNumber = customerNumber;
  }

  getCloudFunctionURL() {
    return this.cloudFunctionURL;
  }

  getCloudFunctionWaitingVideoURL() {
    return this.cloudFunctionWaitingVideoURL;
  }

  saveSalesEmailsData(data, history, companies) {
    console.log('data', data);
    console.log('history', history);
    console.log('companies', companies);
    this.salesEmailsData = data;
    this.salesEmailDataHistory = history;
    this.companiesData = companies;
  }

  returnSalesEmailsData() {
    return this.salesEmailsData;
  }

  returnSalesEmailDataHistory() {
    return this.salesEmailDataHistory;
  }

  returnCompaniesData() {
    return this.companiesData;
  }

  returnSalesEmails() {
    return this.app2.firestore.collection('emailsToBeSent');
  }

  sendSalesEmails(id) {
    return this.app2.firestore.collection('emailsToBeSent').doc(id).update({
      sent: true,
    });
  }

  //Ray added this code
  async storeAssessmentTest(doc: any) {
    const collectionRef = this.app2.firestore.collection('assessmentTests');

    try {
      // Write a document to the 'assessmentTests' collection
      await collectionRef.add(doc);
      console.log(
        'Document added to assessmentTests collection in mona-ai-intern database',
      );
    } catch (error) {
      console.error('Error writing document: ', error);
    }
  }

  async updateAssessmentTest(docId: any, doc: any) {
    const collectionRef = this.app2.firestore.collection('assessmentTests');
    const docRef = collectionRef.doc(docId); // Reference to the specific document

    try {
      // Write a document to the 'assessmentTests' collection
      await docRef.update(doc);
      console.log(
        `Document with ID ${docId} updated in assessmentTests collection`,
      );
    } catch (error) {
      console.error('Error writing document: ', error);
    }
  }

  getAssessmentTests(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('assessmentTests');
  }

  getAssessmentTestDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection('assessmentTests').doc(id);
  }

  getDocumentById(docId: string) {
    return this.app2.doc(`assessmentTests/${docId}`).valueChanges();
  }

  getActivities(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('activities');
  }

  getCalendar() {
    if (this.calendar != '') {
      return this.calendar;
    } else {
      return 'no calendar';
    }
  }

  getProjectId() {
    return this.db?.projectId || '';
  }

  async getProjectsMappingByIds(projectIds: string[]): Promise<{ project_id: string; company_name: string; company_short_name?: string }[]> {
    const ids = [...new Set((projectIds || []).map(id => String(id || '').trim()).filter(Boolean))];
    if (ids.length === 0) return [];
    try {
      const results: { project_id: string; company_name: string; company_short_name?: string }[] = [];
      await Promise.all(ids.map(async (projectId) => {
        const snap = await this.coolStore.firestore.collection('projects_mapping').doc(projectId).get();
        if (!snap?.exists) {
          results.push({ project_id: projectId, company_name: projectId });
          return;
        }
        const data = snap.data() || {};
        results.push({
          project_id: String(data.project_id || projectId).trim(),
          company_name: String(data.company_name || data.company_short_name || projectId).trim(),
          company_short_name: data.company_short_name ? String(data.company_short_name).trim() : undefined
        });
      }));
      return results.sort((a, b) => a.company_name.localeCompare(b.company_name));
    } catch (e) {
      console.warn('[CustomerDB] getProjectsMappingByIds failed:', e);
      return ids.map(project_id => ({ project_id, company_name: project_id }));
    }
  }

  getIsAgentsCustomer() {
    return this.isAgentsCustomer;
  }

  private setIsAgentsCustomer(isAgentsCustomerBool: boolean) {
    this.isAgentsCustomer = isAgentsCustomerBool;
  }

  saveCompanyLogo(logo) {
    this.businessLogo = logo;
  }

  baseApp2;

  isDBConnected(): boolean {
    return this.isConnected && this.app2 !== null;
  }

  getBucketName() {
    console.log("bucketName", this.bucketName)
    return this.bucketName;
  }

  private getRootFirestore() {
    return this.app2.firestore;
  }

  /**
   * Ensures database connection is established.
   * This method should be called by pages that need database access
   * but may be accessed directly without going through the login flow.
   */
  async ensureConnection(): Promise<boolean> {
    try {
      // If already connected, return immediately
      if (this.app2 && this.isConnected) {
        return true;
      }

      console.log('[CustomerdatabaseService] Attempting to restore database connection...');

      // Try to get user data from localStorage
      const userDataString = localStorage.getItem('userData');
      if (!userDataString) {
        console.warn('[CustomerdatabaseService] No userData found in localStorage');
        return false;
      }

      const userData = JSON.parse(userDataString);
      if (!userData.database || !userData.kundennummer) {
        console.warn('[CustomerdatabaseService] Invalid userData structure');
        return false;
      }

      // Connect to database
      console.log('[CustomerdatabaseService] Connecting to database...');
      const result = await this.connectDB(userData);

      // Also ensure user storage is ready
      const uid = this.authService?.returnUserId() || localStorage.getItem('uid');
      if (uid && !this.customerStorageReady) {
        console.log('[CustomerdatabaseService] Setting up user storage...');
        await this.setUserStorage(uid);
      }

      console.log('[CustomerdatabaseService] Database connection restored successfully');
      return result === true;
    } catch (error) {
      console.error('[CustomerdatabaseService] Error ensuring connection:', error);
      return false;
    }
  }

  async connectDB(data, skipProfileLoad: boolean = false) {
    this.ensureCollections();
    if (data) {
      this.db = data.database;
      if (!this.firebaseService) {
        this.firebaseService = this.injector.get(FirebaseService);
      }
      this.secondApp = await this.firebaseService.initSecondApp(data.database);
      if (this.secondApp) {
        const customToken = this.authService.getCustomToken();
        console.log('[connectDB] Retrieved custom token type:', typeof customToken, 'length:', customToken ? customToken.length : 0);
        // Only sign in with custom token if we have one
        if (customToken && customToken !== '' && typeof customToken === 'string') {
          try {
            await this.authService.singInWithCustomeToken(customToken, this.secondApp);
            console.log('[connectDB] Successfully authenticated second app with custom token');
          } catch (error) {
            console.warn('[connectDB] Could not sign in with custom token to second app:', error);
            // Continue anyway - we're already authenticated in main app
          }
        } else {
          console.log('[connectDB] No valid custom token available, skipping second app auth');
        }
      }
      console.log('this.db', data);

      const isSelfServiceCustomer = !!data.isSelfServiceCustomer;
      // data.plan can lag behind (the backend reads customers/{uid} while the plan
      // may still be propagating), so fall back to the plan we already resolved
      // and to the persisted one before classifying this as an agents customer.
      const connectPlan = String(data.plan || this.currentPlan || localStorage.getItem('userPlan') || '').toLowerCase();
      const hasHybridPlan = isHybridPlan(connectPlan) || !!data.hybridAccess;
      if (data.kundennummer == 100001 && !isSelfServiceCustomer && !hasHybridPlan) {
        this.setIsAgentsCustomer(true);
      } else {
        this.setIsAgentsCustomer(false);
      }
      if (data.licenses != undefined && data.licenses >= 1) {
        this.setLicenses(data.licenses);
      }
      this.HostingURL = 'https://' + this.db.projectId + '.firebaseapp.com';
      this.joinApiKey = data.joinapikey;
      this.calendar = data.calendar;
      this.customerAdminEmailAdress = data.email;
      this.cloudFunctionURL = data.cloudFunctionURL || '';
      this.cloudFunctionWaitingVideoURL =
        data.cloudFunctionWaitingVideoURL || '';
      this.customerNumber = data.kundennummer;
      this.accountId = data.account_id;
      this.customerAddons = data.addons || [];
      this.userHybridAccess = data.hybridAccess || false;

      if ((this.isSelfServiceMode() || this.customerNumber === 100001) && (!this.accountId || this.accountId === '')) {
        try {
          const pendingLink = localStorage.getItem('pendingAgentEnterpriseLink');
          if (pendingLink) {
            const parsed = JSON.parse(pendingLink);
            if (parsed.agentEnterpriseAccountId) {
              this.accountId = parsed.agentEnterpriseAccountId;
              console.log('[Enterprise TeamMember] Using accountId from pending link:', this.accountId);
            }
          }
        } catch (e) {}

        if (!this.accountId || this.accountId === '') {
          const userId = this.authService.returnUserId();
          if (userId) {
            this.accountId = userId;
            console.log('[Self-Service] accountId was empty, using userId as fallback:', this.accountId);
          }
        }
      }
      console.log('this.accountId', this.accountId);
      const platformId = PLATFORM_ID;
      const settings = {};

      this.app2 = new AngularFirestore(
        this.db,
        'CustomerDatabase',
        false,
        null,
        platformId,
        this.zone,
        settings,
        null,
        null
      );

      // Initialize secondApp with the same configuration
      this.secondApp = new AngularFirestore(
        this.db,
        'CustomerDatabase',
        false,
        null,
        platformId,
        this.zone,
        settings,
        null,
        null
      );

      this.baseApp2 = new AngularFirestore(
        this.db,
        'baseApp2',
        false,
        null,
        platformId,
        this.zone,
        settings,
        null,
        null
      );
      // this.app2.firestore.useEmulator('localhost', 8082);
      // Sign into the named customer app with the provided custom token to avoid default-app audience mismatch
      try {
        const customToken = this.authService.getCustomToken();
        if (customToken) {
          const appName = 'CustomerDatabase';
          let customerApp: firebase.app.App;
          try {
            customerApp = firebase.app(appName);
          } catch {
            customerApp = firebase.initializeApp(this.db as any, appName);
          }
          this.user = await customerApp.auth().signInWithCustomToken(customToken);
          console.log('Signed into customer Firebase app with custom token');
        }
      } catch (err) {
        console.error('Failed to sign into customer Firebase app with custom token', err);
        return false;
      }
      if (this.app2 != undefined) {
        console.log(this.accountId)
        if (this.accountId != '' && this.accountId != undefined) {
          // Scope app2 to account for all customers when accountId is present
          this.app2.firestore = this.app2.firestore
            .collection('accounts')
            .doc(this.accountId);
          // Keep secondApp at root level for videos/videosInProgress
          console.log('app2 scoped to accounts/' + this.accountId + ' ; secondApp kept at root for videos');
        }
        console.log('app2 and secondApp initialized');

        this._isAuthenticatedOnCustDb.next(true);
        this.createdQuery = this.getApplicants()
          .where('created', '>=', this.thirtyDaysAgo)
          .orderBy('created', 'desc')
          .limit(500);
        // .limit(727);
        // .limit(50)
      }
      if (!skipProfileLoad) {
        this.getProfile().get().then((snap) => {
          const docs = snap.docs;
          const docLength = docs.length;
          if (docLength > 0) {
            this.businessName = docs[0].data().businessName || '';
            this.businessLogo = docs[0].data().companyLogo || '';
            const profilePlatformLanguage = docs[0].data().platformLanguage;
            if (profilePlatformLanguage != undefined) {
              this.platformLanguageObject = profilePlatformLanguage;
              if (this.platformLanguageObject?.language) {
                localStorage.setItem('platformLanguage', this.platformLanguageObject.language);
              }
            } else {
              // No language stored on the profile yet: keep the language the user
              // chose during signup/pricing (mirrored into localStorage) instead of
              // forcing the German default.
              this.platformLanguageObject = resolvePlatformLanguage(localStorage.getItem('platformLanguage'));
            }
            this.menuService.setCompanyLogo(this.businessLogo);
          }
        })
      } else {
        console.log('[connectDB] Skipping profile load for minimal setup');
      }

      this.isConnected = true;

      await this.loadUserHybridAccess();

      return true;
    } else {
      this.isConnected = false;
      return false;
    }
  }

  // Hybrid access is granted if any source says so. This must never downgrade the
  // value that connectDB already took from the backend response, and it must not
  // depend on which of several duplicate customer documents Firestore returns
  // first, so every matching document is inspected.
  private async loadUserHybridAccess(): Promise<void> {
    try {
      const userEmail = this.authService.returnUser();
      console.log('[loadUserHybridAccess] Starting for email:', userEmail);
      if (!userEmail || userEmail === '') {
        console.log('[loadUserHybridAccess] No email, returning');
        return;
      }

      if (!this.coolStore || !this.coolStore.firestore) {
        console.warn('[loadUserHybridAccess] coolStore not initialized');
        return;
      }

      const uid = this.authService.returnUserId();
      if (!this.userHybridAccess && uid) {
        const ownDoc = await this.coolStore.firestore
          .collection(FirebaseConstants.customers)
          .doc(uid)
          .get();
        if (ownDoc.exists && ownDoc.data()?.hybridAccess === true) {
          this.userHybridAccess = true;
          console.log('[loadUserHybridAccess] Granted from own customer document');
        }
      }

      if (!this.userHybridAccess) {
        console.log('[loadUserHybridAccess] Querying customers collection...');
        const customerSnap = await this.coolStore.firestore
          .collection(FirebaseConstants.customers)
          .where('email', '==', userEmail)
          .get();

        console.log('[loadUserHybridAccess] Matching customer documents:', customerSnap.docs.length);
        if (customerSnap.docs.some(doc => doc.data()?.hybridAccess === true)) {
          this.userHybridAccess = true;
          console.log('[loadUserHybridAccess] Granted from a customer document matched by email');
        }
      }

      if (!this.userHybridAccess && this.app2?.firestore) {
        console.log('[loadUserHybridAccess] Checking teammembers collection for hybridAccess...');
        try {
          const teammemberSnap = await this.app2.firestore
            .collection(FirebaseConstants.teammembers)
            .where('email', '==', userEmail)
            .get();

          if (teammemberSnap.docs.some(doc => doc.data()?.hybridAccess === true)) {
            this.userHybridAccess = true;
            console.log('[loadUserHybridAccess] Granted from teammembers collection');
          }
        } catch (teamErr) {
          console.warn('[loadUserHybridAccess] Could not check teammembers collection:', teamErr);
        }
      }

      if (!this.userHybridAccess && this.isTeamMember() && this.hasHybridAddon()) {
        console.log('[loadUserHybridAccess] Team member inherits hybrid access from account addons');
        this.userHybridAccess = true;
      }
    } catch (error) {
      console.error('[loadUserHybridAccess] Error loading user hybrid access:', error);
    }
  }

  async checkIfUsersExists(userId) {
    try {
      const rootFirestore = this.getRootFirestore();
      const userRef = await rootFirestore
        .collection('users')
        .doc(userId)
        .get();
      if (userRef.exists) {
        console.log('exists');
        return true;
      } else {
        console.log('Nope');
        return false;
      }
    } catch (err) {
      console.log('err', err);
    }
  }

  createuserInsideUsers(uid) {
    const rootFirestore = this.getRootFirestore();
    const userData: any = {
      credits: 999999,
    };
    const email = this.authService.returnUser();
    if (email) {
      userData.email = email;
    }
    rootFirestore.collection('users').doc(uid).set(userData, { merge: true });
  }

  retreiveUserCreditsAllTheTimeUpToDate(callback: (credits: number) => void) {
    if (this.app2 == undefined) {
      console.log('app2 is undefined');
      return;
    }

    const userId = this.authService.returnUserId();
    console.log('this.authservice accountId:', this.authService.returnAccountId());
    console.log('this.authservice userId:', userId);

    if (!userId) {
      console.error('Cannot retrieve credits: userId is empty');
      callback(0);
      return;
    }

    const rootFirestore = this.getRootFirestore();

    return rootFirestore
      .collection('users')
      .doc(userId)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            const userData = doc.data();
            const credits = userData?.credits ?? 0;
            callback(credits);
          } else {
            callback(0);
            console.error('No such document for user:', userId);
          }
        },
        (error) => {
          console.error('Error retrieving user credits: ', error);
          callback(0);
        },
      );
  }

  retreiveCvFilterCreditsAllTheTimeUpToDate(callback: (credits: number) => void) {
    if (this.app2 == undefined) {
      console.log('app2 is undefined');
      return;
    }

    const userId = this.authService.returnUserId();

    if (!userId) {
      console.error('Cannot retrieve cvFilter credits: userId is empty');
      callback(0);
      return;
    }

    const rootFirestore = this.getRootFirestore();

    return rootFirestore
      .collection('users')
      .doc(userId)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            const userData = doc.data();
            const cvFilterCredits = userData?.cvFilterCredits ?? 0;
            callback(cvFilterCredits);
          } else {
            callback(0);
            console.error('No such document for user:', userId);
          }
        },
        (error) => {
          console.error('Error retrieving cvFilter credits: ', error);
          callback(0);
        },
      );
  }

  returnCustomerDB() {
    return this.app2;
  }

  getApplicantMailings() {
    return this.app2.firestore.collection('applicantmailing');
  }

  returnBusinessLogo() {
    return this.businessLogo;
  }

  returnBusinessName() {
    return this.businessName || '';
  }

  returnCustomerAdminEmailAdress() {
    return this.customerAdminEmailAdress;
  }

  ApplicantEmailCorrespondence(item, email, vorlage, url, anrede) {
    return this.app2.firestore.collection('applicantmailing').add({
      customer: item,
      email: email,
      vorlage: vorlage,
      url: url,
      anrede: anrede,
      created: new Date(),
      createdGerman: new Date().toLocaleDateString('de-DE'),
      createdISO: new Date().toISOString(),
      createdISODate: new Date().toISOString().split('T')[0],
    });
  }

  CustomerEmailCorrespondence(email, candidate) {
    return this.app2.firestore.collection('customermailing').add({
      email: email,
      candidate: candidate,
      created: new Date(),
      createdGerman: new Date().toLocaleDateString('de-DE'),
      createdISO: new Date().toISOString(),
      createdISODate: new Date().toISOString().split('T')[0],
    });
  }

  getWorkflows(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('workflows');
  }

  getWorkflowDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection('workflows').doc(id);
  }

  updateWorkflow(id, form) {
    console.log(form);
    console.log(id);
    return this.app2.firestore
      .collection('workflows')
      .doc(id)
      .update({
        name: form.name?.trim() || '',
        appliesto: form.appliesto || '',
        whenthishappens: form.whenthishappens || '',
        dothis: form.dothis || '',
        id: form.id || '',
        receiver: form.receiver || '',
        calendlyLink: form.calendlyLink || '',
        when: form.when || '',
        receivers: form.receivers || [],
        updated: new Date() || '',
        updatedGerman: new Date().toLocaleDateString('de-DE') || '',
        updatedISO: new Date().toISOString() || '',
        workflowSendEmailSubject: form.workflowSendEmailSubject,
        workflowSendEmailMessage: form.workflowSendEmailMessage || '',
        workflowSendEmailTitle: form.workflowSendEmailTitle || '',
        emails: form.emails || [],
        emailText: form.emailText || '',
        smsCountryCode: form.smsCountryCode || '',
        smsPhoneNumbers: form.smsPhoneNumbers || [],
        callPhoneNumbers: form.callPhoneNumbers || [],
        whatsAppPhoneNumbers: form.whatsAppPhoneNumbers || [],
        smsText: form.smsText || '',
        information: form.information || [],
        dynamicAttachment: form.dynamicAttachment || [],
        customTime: form.customTime || {},
        attachment: form.attachment || '',
        attachmentURL: form.attachmentURL || '',
        document: form.document || '',
        documentURL: form.documentURL || '',
        documentName: form.documentName || '',
        prompt: form.prompt || '',
        agent: form.agent || {},
        lastChosenWorkflow: form.lastChosenWorkflow || '',
        priorityOfWorkflow: form.priorityOfWorkflow || '',
        subWorkflows: form.subWorkflows || [],
        lastChosenWorkflowMatching: form.lastChosenWorkflowMatching || '',
        reminder: form.reminder || {},
        steps: form.steps || form.tasks || [],
        trigger: form.trigger || {},
        errorHandling: form.errorHandling || 'stop',
        maxRetries: form.maxRetries || 2,
        retryDelay: form.retryDelay || 1000,
        isActive: typeof form.isActive === 'boolean' ? form.isActive : false,
        description: form.description || '',
        version: form.version || '1.0',
        workflowType: form.workflowType || ""
      });
  }

  getJoinApiKey() {
    if (this.joinApiKey) {
      return this.joinApiKey;
    } else {
      return 'noApiKey';
    }
  }

  getHostingURL() {
    if (this.HostingURL) {
      return this.HostingURL;
    } else {
      return 'noHostingURL';
    }
  }

  getUserDB() {
    return this.app2;
  }

  getFlowchartsFromSubCollection(jobOfferId, collectionName: string = FirebaseConstants.jobOffers) {
    const flowcharts = [];
    return this.app2.firestore
      .collection(collectionName)
      .doc(jobOfferId)
      .collection(FirebaseConstants.flowcharts)
      .get()
      .then((snap) => {
        if (snap.empty) {
          console.log('No flowcharts found');
          return [];
        }
        snap.forEach((doc) => {
          const docId = doc.id;
          const data = doc.data();
          flowcharts.push({ docId, ...data });
        });
        return flowcharts;
      })
      .catch((error) => {
        console.error('Error fetching flowcharts:', error);
        return [];
      });
  }

  getJobOffers(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.jobOffers);
  }

  // getJobOffersProcessed(): Promise<any> {
  //   console.log('getJobOffersProcessed');
  //   const start = performance.now();
  //   return new Promise(async (resolve, reject) => {
  //     const allJobOffers = [];
  //     this.jobOfferSubscription = this.app2.firestore
  //       .collection(FirebaseConstants.jobOffers)
  //       .onSnapshot(
  //         async (snap: { docs: any }) => {
  //           console.log('getJobOffersProcessed inside snapshot');
  //           const docs = snap.docs;
  //           const docLength = docs.length;
  //           if (docLength > 0) {
  //             docs.forEach((doc) => {
  //               const data = doc.data();
  //               data.id = doc.id;
  //               allJobOffers.push(data);
  //             });
  //             const end = performance.now();
  //             console.log(
  //               'Time taken to fetch jobOffers: ',
  //               (end - start) / 1000,
  //               ' seconds',
  //             );
  //             console.log('--- Fetched jobOffers:: ', allJobOffers);
  //             //removing snapshot
  //             this.jobOfferSubscription();
  //             resolve(allJobOffers);
  //           } else {
  //             //removing snapshot
  //             this.jobOfferSubscription();
  //             resolve([]);
  //           }
  //         },
  //         (error) => {
  //           console.log(error);
  //           reject(error);
  //         },
  //       );
  //   });
  // }

  getDeletedJobOffers(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.deletedJobOffers);
  }
  getDeletedJobOffersDetail(id): firebase.firestore.DocumentReference {
    //todo maybe add some logging here, because id should always be present
    if (!id)
      return;


    return this.app2.firestore
      .collection(FirebaseConstants.deletedJobOffers)
      .doc(id);
  }

  getJobOffersDetail(id): firebase.firestore.DocumentReference {
    //todo maybe add some logging here, because id should always be present
    if (!id)
      return;
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id);
  }

  getJOINJobOffers() {
    return CustomerdatabaseService.joinJobOffers;
  }

  setJOINJobOffer(jobOffer) {
    let isSet = false;
    const id = jobOffer.id;
    CustomerdatabaseService.joinJobOffers.forEach((snap) => {
      const snapId = snap.id;
      if (id == snapId) {
        isSet = true;
      }
    });
    console.log(isSet);
    if (!isSet) {
      CustomerdatabaseService.joinJobOffers.push(jobOffer);
    }
  }

  getCodingApplicants(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.codingapplicants);
  }

  getCoderbyteApplicants(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(
      FirebaseConstants.coderbyteapplicants,
    );
  }

  getApplicantDetail(id): firebase.firestore.DocumentReference {
    if (!this.app2 || !this.app2.firestore) {
      console.error('[getApplicantDetail] Database not connected (app2.firestore is null)');
      return null;
    }
    return this.app2.firestore.collection(FirebaseConstants.applicants).doc(id);
  }

  updateAvitea(applicantId, workflowId) {
    return this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId).update({
      workflowArray: [workflowId]
    });
  }

  getApplicantFiles(id) {
    return this.getApplicantDetail(id)
      .get()
      .then((snap) => {
        const data = snap.data();
        if (data) {
          if (data.files) {
            if (data.files.length > 0) {
              return data.files;
            }
          }
        }
      });
  }

  saveApplicant(bewerber) {
    this.JoinBewerber = bewerber;
  }

  async deleteApplicant(applicantId) {
    //add log before deletion.
    //first get idToken of user to authorize cloud function
    const idPromises = [];
    console.log('app2 auth', this.user.user);
    idPromises.push(this.user.user.getIdToken());
    idPromises.push(this.authService.getIdToken());
    Promise.all(idPromises).then(async ([userIdToken, pwaUserIdToken]) => {
      console.log('got id tokens for logging');
      const headers = {
        "Authorization": `Bearer ${pwaUserIdToken}`,
        "authenticated-user-token": `Bearer ${userIdToken}`
      }
      //get applicant data to log
      const applicantData = await this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId).get();
      const data = applicantData.data();
      await this.http.post(`https://save-applicant-logs-219198639425.europe-west3.run.app`, {
        applicantId: applicantId,
        kundennummer: this.customerNumber,
        data: {
          timestamp: new Date().toISOString(),
          action: 'delete',
          before: data,
          after: {}
        }
      }, {
        headers: headers
      }).toPromise();
    });
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(applicantId)
      .delete();
  }

  async archiveApplicant(applicantId) {
    // First add the applicant to archived collection
    await this.addToArchivedApplicants(applicantId);
  }

  /**
   * Add applicant to deleted applicants collection in Firestore.
   * @param applicantToDelete
   */
  async addToDeletedApplicants(applicantToDelete) {
    const applicantData = await this.getApplicantDetail2(applicantToDelete).get();
    if (applicantData) {
      const data = applicantData.data();
      if (data) {
        if (data.cv_embedding) {
          delete data.cv_embedding;
        }
        await this.app2.firestore
          .collection(FirebaseConstants.deletedApplicants).doc(applicantToDelete).set(data);
      }
    }
  }

  /**
   * Add applicant to archived applicants collection in Firestore.
   * @param archivedApplicant
   */
  async addToArchivedApplicants(archivedApplicant) {
    const applicantData = await this.getApplicantDetail2(archivedApplicant).get();
    if (applicantData) {
      const data = applicantData.data();

      data.archived = true;

      if (data) {
        if (data.cv_embedding) {
          delete data.cv_embedding;
        }
        await this.app2.firestore.collection(FirebaseConstants.applicants).doc(archivedApplicant).set(data);
      }
    }
  }

  async reactivateApplicant(applicantId) {
    const applicantData = await this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId).get();
    if (applicantData.exists) {
      const data = applicantData.data();
      if (data) {
        if (data.cv_embedding) {
          delete data.cv_embedding;
        }
        if (data.archived) {
          delete data.archived;
        }
        await this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId).set(data);
      }
    }
  }

  async getAllApplicantsLast30Days(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      const allApplicants = [];
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
      this.app2.firestore
        .collection(FirebaseConstants.applicants)
        .where('created', '>=', thirtyDaysAgo)
        .orderBy('created', 'desc')
        .get()
        .then(async (snap) => {
          const docs = snap.docs;
          const docLength = docs.length;
          if (docLength > 0) {
            docs.forEach((doc) => {
              const data = doc.data();
              data.id = doc.id;
              allApplicants.push(data);
            });
            resolve(allApplicants);
          } else {
            resolve([]);
          }
        });
    });
  }

  getJoinApplicant() {
    return this.JoinBewerber;
  }

  // async archiveApplicant(id, archived) {
  //   return this.app2.firestore.collection('applicants').doc(id).update({
  //     archived: archived,
  //   });
  // }

  getApplicantDetail2(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection('applicants').doc(id);
  }

  setInitialBranding() {
    let colRef = this.getProfile();
    colRef.get().then((snap) => {
      // Only create if no branding document exists yet; never overwrite existing data
      if (snap.empty) {
        const updateData: any = {
          accountId: this.authService.returnUserId(),
          firmenname: '',
          webseite: '',
          companyLogo: '',
          colorCode: '#5c37df',
          email: this.authService.returnUser(),
          emailURL: "http://85.215.122.109:8598/documentsjson/",
          created: new Date(),
          status: 'aktiv',
          createdISO: new Date().toISOString(),
          createdISODate: new Date().toISOString().split('T')[0],
          createdGerman: new Date().toLocaleString('de-DE'),
          standorte: [],
          interviewFinishedURL: '',
          chosenCriteria: [],
          euMatching: false,
          minimumMatchingResult: 100,
          sendMatches: false,
          mustHaves: [],
          emailText: '',
          smsText: '',
          betreffText: '',
          personalizedMessage: '',
          platformMatchingType: "noMapping",
          platformMatchingTypeSpecific: "cvMatching",
        };
        this.app2.firestore.collection(FirebaseConstants.branding).add(updateData);
      }
    });
  }

  getProfile(): firebase.firestore.CollectionReference {
    if (this.app2 == undefined) {
      console.log('app2 is undefined');
      return null;
    }
    return this.app2.firestore.collection(FirebaseConstants.branding);
  }

  // app2 is already scoped to /accounts/{acc_id} for multitenant and stays at
  // project root for enterprise, so account_config/email resolves to:
  //   /accounts/{acc_id}/account_config/email  or  /account_config/email
  getEmailAccountConfigDoc(): firebase.firestore.DocumentReference | null {
    if (this.app2 == undefined || !this.app2.firestore) {
      console.log('app2 is undefined');
      return null;
    }
    return this.app2.firestore.collection(FirebaseConstants.accountConfig).doc('email');
  }

  /**
   * Wait until app2 is tenant-scoped (isConnected). isDatabaseReady() is true as
   * soon as AngularFirestore is constructed, which is BEFORE accounts/{acc_id}
   * scoping — reading then hits the project root instead of the account path.
   */
  async waitForCustomerDbReady(maxWaitTime: number = 15000): Promise<boolean> {
    if (this.isDBConnected()) {
      return true;
    }
    if (!this.app2) {
      await this.ensureConnection();
    }
    const startTime = Date.now();
    while (!this.isDBConnected() && (Date.now() - startTime) < maxWaitTime) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    return this.isDBConnected();
  }

  async getEmailAccountConfig(): Promise<{ headerHtml?: string; footerHtml?: string } | null> {
    const ready = await this.waitForCustomerDbReady();
    if (!ready) {
      return null;
    }
    const docRef = this.getEmailAccountConfigDoc();
    if (!docRef) {
      return null;
    }
    const snap = await docRef.get();
    return snap.exists ? (snap.data() as { headerHtml?: string; footerHtml?: string }) : null;
  }

  /**
   * Partial write: header and footer share one document, so only the keys that
   * are actually present in `data` are sent. { merge: true } merges the
   * DOCUMENT, not the payload — a key that is present always overwrites what is
   * stored, so sending footerHtml on a header-only save would blank the footer.
   * An explicit empty string still clears its own block.
   */
  async saveEmailAccountConfig(data: { headerHtml?: string; footerHtml?: string }): Promise<void> {
    const ready = await this.waitForCustomerDbReady();
    if (!ready) {
      throw new Error('Database not ready');
    }
    const docRef = this.getEmailAccountConfigDoc();
    if (!docRef) {
      throw new Error('Database not ready');
    }
    const payload: { headerHtml?: string; footerHtml?: string } = {};
    if (data.headerHtml !== undefined) payload.headerHtml = data.headerHtml || '';
    if (data.footerHtml !== undefined) payload.footerHtml = data.footerHtml || '';
    if (Object.keys(payload).length === 0) {
      return;
    }
    await docRef.set({
      ...payload,
      updatedAt: new Date(),
      updatedBy: this.userId || ''
    }, { merge: true });
  }

  getArsChatSession(sessionId: string): firebase.firestore.DocumentReference | null {
    if (!this.app2 || !this.accountId || !sessionId) return null;
    return this.app2.firestore
      .collection('accounts').doc(this.accountId)
      .collection('ars_chat_sessions').doc(sessionId);
  }

  getArsChatSessionsCollection(): firebase.firestore.CollectionReference | null {
    if (!this.app2 || !this.accountId) return null;
    return this.app2.firestore
      .collection('accounts').doc(this.accountId)
      .collection('ars_chat_sessions');
  }

  getFeedbackCollection(): firebase.firestore.CollectionReference | null {
    if (!this.app2 || !this.accountId) return null;
    return this.app2.firestore
      .collection('accounts').doc(this.accountId)
      .collection('feedback');
  }

  getBugsCollection(): firebase.firestore.CollectionReference | null {
    if (!this.app2 || !this.accountId) return null;
    return this.app2.firestore
      .collection('accounts').doc(this.accountId)
      .collection('bugs');
  }

  getMiaSessionRef(sessionId: string): firebase.firestore.DocumentReference | null {
    if (!this.app2 || !this.accountId || !sessionId) return null;
    return this.app2.firestore
      .collection('accounts').doc(this.accountId)
      .collection('mia_sessions').doc(sessionId);
  }

  getMiaSessionsCollection(): firebase.firestore.CollectionReference | null {
    if (!this.app2 || !this.accountId) return null;
    return this.app2.firestore
      .collection('accounts').doc(this.accountId)
      .collection('mia_sessions');
  }

  /**
   * Check if a specific help popup has been shown to the user
   * @param popupId - Unique identifier for the popup (e.g., 'flowchart', 'dashboard', 'contacts')
   * @returns true if the popup has been shown, false otherwise
   */
  async hasHelpPopupBeenShown(popupId: string): Promise<boolean> {
    const snap = await this.getProfile().get();
    const docs = snap.docs;
    if (docs.length > 0) {
      const shownPopups: string[] = docs[0].data().shownHelpPopups || [];
      return shownPopups.includes(popupId);
    }
    return false;
  }

  /**
   * Mark a help popup as shown for the user
   * @param popupId - Unique identifier for the popup
   */
  async markHelpPopupAsShown(popupId: string): Promise<void> {
    const snap = await this.getProfile().get();
    const docs = snap.docs;
    if (docs.length > 0) {
      const id = docs[0].id;
      const currentPopups: string[] = docs[0].data().shownHelpPopups || [];
      if (!currentPopups.includes(popupId)) {
        currentPopups.push(popupId);
        await this.app2.firestore
          .collection(FirebaseConstants.branding)
          .doc(id)
          .update({ shownHelpPopups: currentPopups });
      }
    }
  }

  /**
   * Get all shown help popup IDs
   * @returns Array of popup IDs that have been shown
   */
  async getShownHelpPopups(): Promise<string[]> {
    const snap = await this.getProfile().get();
    const docs = snap.docs;
    if (docs.length > 0) {
      return docs[0].data().shownHelpPopups || [];
    }
    return [];
  }

  /**
   * Reset a specific help popup so it shows again
   * @param popupId - Unique identifier for the popup to reset
   */
  async resetHelpPopup(popupId: string): Promise<void> {
    const snap = await this.getProfile().get();
    const docs = snap.docs;
    if (docs.length > 0) {
      const id = docs[0].id;
      const currentPopups: string[] = docs[0].data().shownHelpPopups || [];
      const updatedPopups = currentPopups.filter(p => p !== popupId);
      await this.app2.firestore
        .collection(FirebaseConstants.branding)
        .doc(id)
        .update({ shownHelpPopups: updatedPopups });
    }
  }

  saveDataflow(dataflow: { sources: any[], endpoints: any[] }) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({ dataflow: dataflow });
        }
      });
  }

  async getProfileLanguage() {
    return await this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().platformLanguage;
        } else {
          return false;
        }
      });
  }

  deleteFieldOnFirebaseDocument(id, property) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        [property]: this.app2.firestore.FieldValue.delete(),
      });
  }

  async createProfile(data) {
    // Check if a branding document already exists to prevent duplicates
    const existing = await this.app2.firestore.collection(FirebaseConstants.branding).get();
    if (!existing.empty) {
      console.log('Branding profile already exists, skipping creation');
      return;
    }
    return this.app2.firestore.collection(FirebaseConstants.branding).add({
      firmenname: data.firmenname || '',
      businessName: (data && data.firmenname) ? data.firmenname : '',
      webseite: data.webseite || '',
      companyLogo: data.companyLogo || '',
      colorCode: data.colorCode || '',
      email: data.email || '',
      password: data.password || '',
      allowed_tools: data.allowed_tools || [],
      organisation: data.organisation || '',
      created: new Date(),
      status: 'aktiv',
      createdISO: new Date().toISOString(),
      createdISODate: new Date().toISOString().split('T')[0],
      createdGerman: new Date().toLocaleString('de-DE'),
      emailText: data.emailText || '',
      fallbackInterviewId: data.fallbackInterviewId || '',
      interviewFinishedURL: data.interviewFinishedURL || '',
      euMatching: data.euMatching || false,
      minimumMatchingResult: data.minimumMatchingResult || 0,
      sendMatches: data.sendMatches || false,
      chosenCriteria: data.chosenCriteria || [],
      mustHaves: data.mustHaves || [],
      personalizedMessage: data.personalizedMessage,
      dataProtection: data.dataProtection || '',
    }).then((snap) => {
      console.log('Profile created successfully');
    }).catch((error) => {
      console.error('Error creating profile:', error);
    });
  }

  // Remove duplicate branding documents, keeping the one with the most data
  async cleanupDuplicateBranding(): Promise<void> {
    try {
      const snap = await this.app2.firestore.collection(FirebaseConstants.branding).get();
      if (snap.docs.length <= 1) return;

      // Pick the document with the most real content to keep.
      // Score by presence of key user-edited fields so we never discard real data.
      const score = (data: any): number => {
        let s = 0;
        if (data.businessName && data.businessName.trim() !== '') s += 10;
        if (data.firmenname && data.firmenname.trim() !== '') s += 10;
        if (data.smtpEmail) s += 10;
        if (data.companyLogo && data.companyLogo.trim() !== '') s += 5;
        if (data.standorte && data.standorte.length > 0) s += 5;
        if (data.planLimits) s += 5;
        // Count total non-empty fields as a tiebreaker
        s += Object.keys(data).filter(k => data[k] != null && data[k] !== '').length;
        return s;
      };

      const scored = snap.docs.map(doc => ({ doc, score: score(doc.data()) }));
      scored.sort((a, b) => b.score - a.score);

      // Keep the highest-scored document, delete the rest
      const keep = scored[0].doc;
      const duplicates = scored.slice(1);
      for (const entry of duplicates) {
        console.log('Removing duplicate branding document:', entry.doc.id);
        await this.app2.firestore.collection(FirebaseConstants.branding).doc(entry.doc.id).delete();
      }
      console.log(`Cleaned up ${duplicates.length} duplicate branding document(s), kept: ${keep.id}`);
    } catch (error) {
      console.error('Error cleaning up duplicate branding documents:', error);
    }
  }

  getAPIData() {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data();
        } else {
          return false;
        }
      });
  }

  saveZvooveAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              zvoove: data.zvoove,
              zvooveBewerberApiKey: data.zvooveBewerberApiKey || '',
              zvooveBewerberApiLink: data.zvooveBewerberApiLink || '',
              zvooveStellenApiKey: data.zvooveStellenApiKey || '',
              zvooveStellenApiLink: data.zvooveStellenApiLink || '',
              zvoooveNextLevelApiKey: data.zvoooveNextLevelApiKey || '',
              zvooveNextLevelApiLink: data.zvooveNextLevelApiLink || '',
              zvooveBewerberApiLinkById: data.zvooveBewerberApiLinkById || '',
              zvooveCreateBewerberApiLink:
                data.zvooveCreateBewerberApiLink || '',
              username: data.username || '',
              password: data.password || '',
              AIMatchingType: data.AIMatchingType || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  async saveIntegrationData(app: any) {
    try {
      // Extract appId from app
      const appId = app.appId;

      // Collect data directly from app
      const data: any = {};

      // Since the data is stored directly in app, extract the keys
      app.fields.forEach((field: any) => {
        const key = field.key;
        const value = app[key];
        if (PARTNER_SERVER_FIELDS.includes(key)) {
          return;
        }
        // hr4youUserStatusToPull is optional and numeric — only persist when a value is provided,
        // otherwise skip so we don't write an empty string to Firestore.
        if (key === 'hr4youUserStatusToPull') {
          if (value === undefined || value === null || value === '') {
            return;
          }
          const parsed = Number(value);
          if (!Number.isFinite(parsed)) {
            return;
          }
          data[key] = parsed;
          return;
        }
        data[key] = value; // Get the value from app directly
      });

      console.log('Data to save: ', Object.keys(data));

      // Retrieve the branding document ID
      const snap = await this.getProfile().get();
      const docs = snap.docs;

      if (docs.length > 0) {
        const id = docs[0].id;

        // Prepare the update data
        const updateData: any = {
          updated: new Date(),
          status: 'aktiv',
          ...(getOnboardingPartner(appId) ? {} : { [appId]: app.active !== false }), // Persist the actual active state so deactivation is saved
          ...data, // Include all collected fields
        };

        // Update the branding document
        await this.app2.firestore
          .collection(FirebaseConstants.branding)
          .doc(id)
          .update(updateData);

        console.log(`Data for ${appId} saved successfully.`);
      } else {
        console.error('Branding document not found.');
      }
    } catch (error) {
      console.error(`Error saving data for ${app.appId}:`, error);
      throw error; // Rethrow to handle it in integrations.ts
    }
  }

  async saveIntegrationField(key: string, value: any) {
    const snap = await this.getProfile().get();
    const docs = snap.docs;
    if (docs.length > 0) {
      const id = docs[0].id;
      await this.app2.firestore
        .collection(FirebaseConstants.branding)
        .doc(id)
        .update({ [key]: value, updated: new Date() });
    }
  }

  async enableMonaAppModule(moduleId: string, moduleConfig: { title: string; url: string; icon: string }) {
    try {
      const apiData: any = await this.getAPIData();
      let currentApps: any[] = (apiData && apiData.monaApps) ? apiData.monaApps : [];
      
      const alreadyEnabled = currentApps.some(app => app.id === moduleId);
      if (alreadyEnabled) {
        return { success: true, alreadyEnabled: true };
      }
      
      currentApps.push({
        id: moduleId,
        title: moduleConfig.title,
        url: moduleConfig.url,
        icon: moduleConfig.icon
      });
      
      await this.saveIntegrationField('monaApps', currentApps);
      return { success: true, alreadyEnabled: false };
    } catch (err) {
      console.error('Error enabling MONA app module:', err);
      return { success: false, error: err };
    }
  }

  async saveIntegrationDataAccount(
    app: any,
    accountId: string,
    userId: string,
  ) {
    try {
      // Extract appId from app
      const appId = app.appId;

      // Collect data directly from app
      const data: any = {};

      // Since the data is stored directly in app, extract the keys
      app.fields.forEach((field: any) => {
        const key = field.key;
        const value = app[key];
        if (PARTNER_SERVER_FIELDS.includes(key)) {
          return;
        }
        // hr4youUserStatusToPull is optional and numeric — only persist when a value is provided,
        // otherwise skip so we don't write an empty string to Firestore.
        if (key === 'hr4youUserStatusToPull') {
          if (value === undefined || value === null || value === '') {
            return;
          }
          const parsed = Number(value);
          if (!Number.isFinite(parsed)) {
            return;
          }
          data[key] = parsed;
          return;
        }
        data[key] = value; // Get the value from app directly
      });

      console.log('Data to save: ', Object.keys(data));

      // Retrieve the branding document ID
      const snap = await this.getProfile().get();
      const docs = snap.docs;

      if (docs.length > 0) {
        const id = docs[0].id;

        // Prepare the update data
        const updateData: any = {
          updated: new Date(),
          status: 'aktiv',
          ...data, // Include all collected fields
        };

        // Update the branding document
        await this.app2.firestore
          .collection(FirebaseConstants.branding)
          .doc(id)
          .update(updateData);

        console.log(`Data for ${appId} saved successfully.`);
      } else {
        console.error('Branding document not found.');
      }
    } catch (error) {
      console.error(`Error saving data for ${app.appId}:`, error);
      throw error; // Rethrow to handle it in integrations.ts
    }
  }

  saveTalent360APIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              talent360: data.talent360,
              talentClientId: data.talentClientId || '',
              talentClientSecret: data.talentClientSecret || '',
              talentAPIBaseUrl: data.talentAPIBaseUrl || '',
              talentAccessTokenUrl: data.talentAccessTokenUrl || '',
              talentPublicAudience: data.talentPublicAudience || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveCovetoConfiguration(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        let docs = snap.docs;
        let docLength = docs.length;
        if (docLength > 0) {
          var id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              coveto: data.coveto || false,
              covetoCustomernumber: data.covetoCustomernumber || '',
              covetoMandanten: data.covetoMandanten || '',
              covetoPassword: data.covetoPassword || '',
              covetoStatus: data.covetoStatus || '',
              covetoTypeOfPullingData: data.covetoTypeOfPullingData || '',
              covetoURL: data.covetoURL || '',
              covetoUsername: data.covetoUsername || ''
            });
        } else {
          return false;
        }
      });
  }

  saveAiFindConfiguration(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              aiFind: data.aiFind || false,
              aiFindApiKey: data.aiFindApiKey || '',
              aiFindHostName: data.aiFindHostName || '',
              aiFindNoteCategory: data.aiFindNoteCategory || '',
              aiFindProcess: data.aiFindProcess || '',
              aiFindProcessMona: data.aiFindProcessMona || '',
              aiFindProcessMonaWorking: data.aiFindProcessMonaWorking || '',
              aiFindProcessMonaDone: data.aiFindProcessMonaDone || '',
            });
        } else {
          return false;
        }

      });
  }

  saveIndexAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              index: data.index,
              indexLogin: data.indexLogin || '',
              indexPassword: data.indexPassword || '',
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveZapierAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              zapier: data.zapier,
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveCustomIntegrationAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              customIntegration: data.customIntegration,
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveTalentionAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              talention: data.talention,
              talentionClientId: data.talentionClientId || '',
              talentionClientSecret: data.talentionClientSecret || '',
              talentionAccountId: data.talentionAccountId || '',
              talentionAccountOption: data.talentionAccountOption || '',
              talentionAccountOptionBranches:
                data.talentionAccountOptionBranches || '',
              talentionMonaStatusEingang: data.talentionMonaStatusEingang || '',
              talentionMonaStatusImInterview:
                data.talentionMonaStatusImInterview || '',
              talentionMonaStatusInterviewAbgeschlossen:
                data.talentionMonaStatusInterviewAbgeschlossen || '',
              talentionMonaStatusAbgelehnt:
                data.talentionMonaStatusAbgelehnt || '',
              talentionMonaStatusProfilErstellt:
                data.talentionMonaStatusProfilErstellt || '',
              talentionMonaStatusProfilVersendet:
                data.talentionMonaStatusProfilVersendet || '',
              AIMatchingType: data.AIMatchingType || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveCompleetAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              compleet: data.compleet || true,
              compleetAPIKeys: data.compleetAPIKeys || '',
              initiativRow: data.initiativRow || '',
              initiativApiKey: data.initiativApiKey || '',
              updated: new Date(),
              AIMatchingType: data.AIMatchingType || '',
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveMonaAIAPIKeys(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              monaAI: data.monaAI,
              monaApiKey: data.monaApiKey || '',
              uid: data.uid || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  AddIndexAnzeigen(data) {
    if (data['job-id']) {
      return this.app2.firestore.collection('indexstellenanzeigen').add({
        contantName: data['ad-contact-person'],
        contactEmail: data['ad-contact-person-email'],
        jobOfferText: data['ad-text'],
        companyName: data['company'],
        jobId: data['job-id'],
        lastFound: data['last-found'],
        location: data['location'],
        output: data['output'],
        source: data['source'],
        adprice: data['ad-price'],
        language: data['ad-language'],
        street: data['street'],
        zip: data['zip'],
        city: data['city'],
        url: data['doc-link-txt'],
        streetOnly: data['street-only'],
        houseNumber: data['house-number'],
        created: new Date(),
        status: 'aktiv',
        createdISO: new Date().toISOString(),
        createdISODate: new Date().toISOString().split('T')[0],
      });
    }
  }

  updateApplicantCVQualifications(id, data) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        cvQualifications: data,
        cvAnalyzed: true,
        CVcreated: new Date(),
        status: 'aktiv',
        CVcreatedISO: new Date().toISOString(),
        CVcreatedISODate: new Date().toISOString().split('T')[0],
        CVcreatedGerman: new Date().toLocaleString('de-DE'),
      });
  }

  updateIndexAnzeigen(id, data) {
    return this.app2.firestore
      .collection('indexstellenanzeigen')
      .doc(id)
      .update({
        contantName: data['ad-contact-person'],
        contactEmail: data['ad-contact-person-email'],
        jobOfferText: data['ad-text'],
        companyName: data['company'],
        jobId: data['job-id'],
        lastFound: data['last-found'],
        location: data['location'],
        output: data['output'],
        source: data['source'],
        adprice: data['ad-price'],
        language: data['ad-language'],
        street: data['street'],
        zip: data['zip'],
        city: data['city'],
        streetOnly: data['street-only'],
        houseNumber: data['house-number'],
        url: data['doc-link-txt'],
        created: new Date(),
        status: 'aktiv',
        createdISO: new Date().toISOString(),
        createdISODate: new Date().toISOString().split('T')[0],
      });
  }

  updateIndexAnzeigenAI(id, data) {
    return this.app2.firestore
      .collection('indexstellenanzeigen')
      .doc(id)
      .update({
        jobOfferFeedback: data,
      });
  }

  getIndexAnzeigen(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('indexstellenanzeigen');
  }

  getZvooveJobsApiKey(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveStellenApiKey;
        } else {
          return '';
        }
      });
  }

  getZvooveJobsApiLink(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveStellenApiLink;
        } else {
          return '';
        }
      });
  }

  getZvooveBewerberApiKey(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveBewerberApiKey;
        } else {
          return '';
        }
      });
  }

  getZvooveBewerberApiLinkById(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveBewerberApiLinkById;
        } else {
          return '';
        }
      });
  }

  getZvooveBewerberApiLink(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveBewerberApiLink;
        } else {
          return '';
        }
      });
  }

  getZvooveCreateBewerberApiLink(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveCreateBewerberApiLink;
        } else {
          return '';
        }
      });
  }

  getZvooveMandantUuID(): Promise<string> {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().zvooveMandantUuID;
        } else {
          return '';
        }
      });
  }

  updateFallbackJobOffer(id) {
    this.getJobOffersDetail(id).update({
      isFallback: true,
    });
    this.getJobOffers()
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          if (doc.id != id) {
            this.getJobOffersDetail(doc.id).update({
              isFallback: false,
            });
          }
        });
      });
  }

  retreiveMONAIMAPAccounts() {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().imapArray;
        } else {
          return [];
        }
      });
  }

  retreiveMONASMSAccounts() {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().smsArray;
        } else {
          return [];
        }
      });
  }

  retreiveMONASMTPAccounts() {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          return docs[0].data().smtpArray;
        } else {
          return [];
        }
      });
  }

  saveMONAIMAPAccountWithAttachedWorkflow(email, password, workflow) {
    const workflowId = workflow.id;
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        let imapArray = [];
        if (docLength > 0) {
          const id = docs[0].id;
          if (docs[0].data().imapArray) {
            imapArray = docs[0].data().imapArray;
          }
          console.log('imapArray: ', imapArray);

          // check if email already exists
          let emailExists = false;
          imapArray.forEach((item) => {
            if (item.email == email.email) {
              emailExists = true;
            }
          });

          if (emailExists) {
            // only update the workflows inside the array element, not the array itself
            imapArray.forEach((item) => {
              if (item.email == email.email) {
                item.workflow = workflow;
              }
            });
            return this.app2.firestore
              .collection(FirebaseConstants.branding)
              .doc(id)
              .update({
                imapArray: imapArray,
              });
          }
          if (imapArray.length > 0) {
            const item = {
              email: email,
              password: password,
              host: email.host || '7e6e417.online-server.cloud',
              tls: email.tls || true,
              port: email.port || 993,
              timeRange: email.timeRange || '1day',
              authTimeout: email.authTimeout || 30000,
              workflowId: workflowId,
            };
            imapArray.push(item);
          } else {
            imapArray = [
              {
                email: email,
                password: password,
                host: email.host || '7e6e417.online-server.cloud',
                tls: email.tls || true,
                port: email.port || 993,
                timeRange: email.timeRange || '1day',
                authTimeout: email.authTimeout || 30000,
                workflowId: workflowId,
              },
            ];
          }
          console.log('imapArray: ', imapArray);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              imapArray: imapArray,
            });
        } else {
          return false;
        }
      });
  }

  saveMONASMTPAccountWithAttachedWorkflow(email, workflow) {
    const workflowId = workflow.id;
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        let smtpArray = [];
        if (docLength > 0) {
          const id = docs[0].id;
          if (docs[0].data().smtpArray) {
            smtpArray = docs[0].data().smtpArray;
          }
          console.log('smtpArray: ', smtpArray);

          // check if email already exists
          let emailExists = false;
          smtpArray.forEach((item) => {
            if (item.email == email.email) {
              emailExists = true;
            }
          });

          if (emailExists) {
            // only update the workflows inside the array element, not the array itself
            smtpArray.forEach((item) => {
              if (item.email == email.email) {
                item.workflow = workflow;
              }
            });
            return this.app2.firestore
              .collection(FirebaseConstants.branding)
              .doc(id)
              .update({
                smtpArray: smtpArray,
              });
          }
          if (smtpArray.length > 0) {
            const item = {
              email: email.email,
              password: email.password,
              host: email.host || '7e6e417.online-server.cloud',
              tls: email.tls || true,
              port: email.port || 993,
              timeRange: email.timeRange || '1day',
              authTimeout: email.authTimeout || 30000,
              workflowId: workflowId,
            };
            smtpArray.push(item);
          } else {
            smtpArray = [
              {
                email: email.email,
                password: email.password,
                host: email.host || '7e6e417.online-server.cloud',
                tls: email.tls || true,
                port: email.port || 993,
                timeRange: email.timeRange || '1day',
                authTimeout: email.authTimeout || 30000,
                workflowId: workflowId,
              },
            ];
          }
          console.log('smtpArray: ', smtpArray);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              smtpArray: smtpArray,
            });
        } else {
          return false;
        }
      });
  }

  saveEmailCredentials(data) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              email: data.email || '',
              password: data.password || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  deleteMONAIMAPAccount(email) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        if (docs.length > 0) {
          const id = docs[0].id;
          const imapArray = docs[0].data().imapArray || [];
          console.log(this.app2.firestore.collection(FirebaseConstants.branding));
          // Entferne das Objekt mit passender Email
          const newIMAPArray = imapArray.filter(item => item.email !== email.email);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              imapArray: newIMAPArray,
            });
        } else {
          return false;
        }
      });
  }

  deleteMONASMTPAccount(email) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          const smtpArray = docs[0].data().smtpArray;
          const newSMTPArray = smtpArray.filter((item) => {
            return item.email != email.email;
          });
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              smtpArray: newSMTPArray,
            });
        } else {
          return false;
        }
      });
  }

  createProfileEmail(
    email,
    password,
    host?,
    tls?,
    port?,
    timeRange?,
    authTimeout?,
    type?,
  ) {
    if (type == 'imap') {
      return this.getProfile()
        .get()
        .then((snap) => {
          const docs = snap.docs;
          const docLength = docs.length;
          let imapArray = [];
          if (docLength > 0) {
            const id = docs[0].id;
            if (docs[0].data().imapArray) {
              imapArray = docs[0].data().imapArray;
            }
            // check if email already exists
            let emailExists = false;
            imapArray.forEach((item) => {
              if (item.email == email) {
                emailExists = true;
              }
            });

            if (emailExists) {
              return false;
            }

            if (imapArray.length > 0) {
              const item = {
                email: email,
                password: password,
                host: host || '7e6e417.online-server.cloud',
                tls: tls || true,
                port: port || 993,
                timeRange: timeRange || '1day',
                authTimeout: authTimeout || 30000,
              };
              imapArray.push(item);
            } else {
              imapArray = [
                {
                  email: email,
                  password: password,
                  host: host || '7e6e417.online-server.cloud',
                  tls: tls || true,
                  port: port || 993,
                  timeRange: timeRange || '1day',
                  authTimeout: authTimeout || 30000,
                },
              ];
            }
            console.log('imapArray: ', imapArray);
            return this.app2.firestore
              .collection(FirebaseConstants.branding)
              .doc(id)
              .update({
                imapArray: imapArray,
              });
          } else {
            return false;
          }
        });
    } else if (type == 'smtp') {
      return this.getProfile()
        .get()
        .then((snap) => {
          const docs = snap.docs;
          const docLength = docs.length;
          if (docLength > 0) {
            const id = docs[0].id;
            return this.app2.firestore
              .collection(FirebaseConstants.branding)
              .doc(id)
              .update({
                smtpEmail: email || '',
                smtpPassword: password || '',
                smtpHost: host || '7e6e417.online-server.cloud',
                smtpTls: tls || true,
                smtpPort: port || 993,
                smtpTimeRange: timeRange || '1day',
                smtpAuthTimeout: authTimeout || 30000,
              });
          } else {
            return false;
          }
        });
    }
  }

  updateProfileSMTP(
    email,
    password,
    host?,
    tls?,
    port?,
    timeRange?,
    authTimeout?,
  ) {
    // get profile and add the email into the array of smtpArray
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        let smtpArray = [];
        if (docLength > 0) {
          const id = docs[0].id;
          if (docs[0].data().smtpArray) {
            smtpArray = docs[0].data().smtpArray;
          }
          // check if email already exists
          let emailExists = false;
          let passwordExists = false;
          smtpArray.forEach((item) => {
            if (item.email == email) {
              emailExists = true;
            }
            if (item.password == password) {
              passwordExists = true;
            }
          });

          if (emailExists && passwordExists) {
            return false;
          }

          if (smtpArray.length > 0) {
            const item = {
              email: email,
              password: password,
              host: host || '7e6e417.online-server.cloud',
              tls: tls || true,
              port: port || 993,
              timeRange: timeRange || '1day',
              authTimeout: authTimeout || 30000,
            };
            smtpArray.push(item);
          } else {
            smtpArray = [
              {
                email: email,
                password: password,
                host: host || '7e6e417.online-server.cloud',
                tls: tls || true,
                port: port || 993,
                timeRange: timeRange || '1day',
                authTimeout: authTimeout || 30000,
              },
            ];
          }
          console.log('smtpArray: ', smtpArray);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              smtpArray: smtpArray,
            });
        } else {
          return false;
        }
      });
  }

  async generateApplicantInboxAdress() {
    const userId = this.authService.returnUserId();
    let accountId = this.authService.returnAccountId();
    if (accountId == undefined || accountId == null || accountId == "") {
      accountId = userId;
    }
    const brandingInfo = {
      userId,
      accountId
    }
    this.firebaseService = this.getFirebaseService();
    const docRef = await this.firebaseService.generateMONAIMAPAccount(brandingInfo);
    docRef.onSnapshot((doc) => {
      if (doc.data().MONAIMAPEmail) {
        this.updateProfileIMAP(doc.data().MONAIMAPEmail, doc.data().MONAIMAPPassword, true);
        return;
      } else {
        console.log("No email address generated yet");
      }
    });
  }

  async getApplicantInboxEmail(): Promise<string | null> {
    try {
      const snap = await this.getProfile().get();
      const docs = snap.docs;

      if (docs.length > 0) {
        const data = docs[0].data();
        if (data.imapArray && data.imapArray.length > 0) {
          // Find the email with isApplicantInbox = true
          const applicantInbox = data.imapArray.find(item => item.isApplicantInbox === true);
          if (applicantInbox) {
            return applicantInbox.email;
          }
        }
      }
      return null;
    } catch (error) {
      console.error('Error getting applicant inbox email:', error);
      return null;
    }
  }

  updateProfileIMAP(email, password, isApplicantInbox, host?, tls?, port?, timeRange?, authTimeout?) {
    // get profile and add the email into the array of imaparray
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        let imapArray = [];
        if (docLength > 0) {
          const id = docs[0].id;
          if (docs[0].data().imapArray) {
            imapArray = docs[0].data().imapArray;
          }
          // check if email already exists
          let emailExists = false;
          let passwordExists = false;
          imapArray.forEach((item) => {
            if (item.email == email) {
              emailExists = true;
            }
            if (item.password == password) {
              passwordExists = true;
            }
          });

          if (emailExists && passwordExists) {
            return false;
          }

          if (imapArray.length > 0) {
            const item = {
              email: email,
              password: password,
              host: host || 'mail.mona-ai.online',
              tls: tls || true,
              port: port || 993,
              timeRange: timeRange || '1day',
              authTimeout: authTimeout || 30000,
              isApplicantInbox: isApplicantInbox || false,
            };
            imapArray.push(item);
          } else {
            imapArray = [
              {
                email: email,
                password: password,
                host: host || 'mail.mona-ai.online',
                tls: tls || true,
                port: port || 993,
                timeRange: timeRange || '1day',
                authTimeout: authTimeout || 30000,
                isApplicantInbox: isApplicantInbox || false,
              },
            ];
          }
          console.log('imapArray: ', imapArray);
          return this.app2.firestore
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              imapArray: imapArray,
            });
        } else {
          return false;
        }
      });
  }

  /**
   * Clean undefined values from an object before saving to Firestore
   * Firestore doesn't accept undefined values
   */
  private cleanUndefinedValues(obj: any): any {
    const cleaned = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value !== undefined) {
          // Keep defined values (including null, empty strings, 0, false)
          cleaned[key] = value;
        }
        // Skip undefined values - they won't be in the cleaned object
      }
    }
    return cleaned;
  }

  async updateProfile(data) {
    const isNewLogoUploaded = data.isNewLogoUploaded || false;

    if (isNewLogoUploaded) {
      const newName = `${new Date().getTime()}-companyLogo.png`;
      const storageRef: AngularFireStorageReference = this.customerStorage.ref(
        `/company/${newName}`,
      );
      const base64 = data.companyLogo;

      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray as unknown as ArrayBuffer], { type: 'image/png' });

      const uploadTaskSnapshot = await storageRef.put(blob);
      const publicUrl = await uploadTaskSnapshot.ref.getDownloadURL();

      data.companyLogo = publicUrl;

    }

    const snap = await this.getProfile().get();
    const docs = snap.docs;
    if (docs.length === 0) return;

    const updateData: any = {};

    if (data.firmenname !== undefined || data.businessName !== undefined) {
      updateData.firmenname = data.firmenname || data.businessName || '';
      updateData.businessName = data.businessName || data.firmenname || '';
    }
    if (data.webseite !== undefined) updateData.webseite = data.webseite || '';
    if (data.companyLogo !== undefined) updateData.companyLogo = data.companyLogo || '';
    if (data.colorCode !== undefined) updateData.colorCode = data.colorCode || '';
    if (data.email !== undefined) updateData.email = data.email || '';
    if (data.allowed_tools !== undefined) updateData.allowed_tools = data.allowed_tools || [];
    if (data.standorte !== undefined) updateData.standorte = data.standorte || [];
    if (data.zvooveBewerberApiKey !== undefined) updateData.zvooveBewerberApiKey = data.zvooveBewerberApiKey || '';
    if (data.zvooveBewerberApiLink !== undefined) updateData.zvooveBewerberApiLink = data.zvooveBewerberApiLink || '';
    if (data.zvooveStellenApiKey !== undefined) updateData.zvooveStellenApiKey = data.zvooveStellenApiKey || '';
    if (data.zvooveStellenApiLink !== undefined) updateData.zvooveStellenApiLink = data.zvooveStellenApiLink || '';
    if (data.zvooveBewerberApiLinkById !== undefined) updateData.zvooveBewerberApiLinkById = data.zvooveBewerberApiLinkById || '';
    if (data.zvooveCreateBewerberApiLink !== undefined) updateData.zvooveCreateBewerberApiLink = data.zvooveCreateBewerberApiLink || '';
    if (data.zvooveMandantUuID !== undefined) updateData.zvooveMandantUuID = data.zvooveMandantUuID || '';
    if (data.fallbackInterviewId !== undefined) updateData.fallbackInterviewId = data.fallbackInterviewId || '';
    if (data.interviewFinishedURL !== undefined) updateData.interviewFinishedURL = data.interviewFinishedURL || '';
    if (data.chosenCriteria !== undefined) updateData.chosenCriteria = data.chosenCriteria || [];
    if (data.euMatching !== undefined) updateData.euMatching = data.euMatching || false;
    if (data.minimumMatchingResult !== undefined) updateData.minimumMatchingResult = data.minimumMatchingResult || 0;
    if (data.sendMatches !== undefined) updateData.sendMatches = data.sendMatches || false;
    if (data.mustHaves !== undefined) updateData.mustHaves = data.mustHaves || [];
    if (data.isZvoove !== undefined) updateData.isZvoove = data.isZvoove || false;
    if (data.emailText !== undefined) updateData.emailText = data.emailText || '';
    if (data.smsText !== undefined) updateData.smsText = data.smsText || '';
    if (data.autoTranslateInviteMessagesBool !== undefined) updateData.autoTranslateInviteMessagesBool = data.autoTranslateInviteMessagesBool || false;
    if (data.betreffText !== undefined) updateData.betreffText = data.betreffText || '';
    if (data.personalizedMessage !== undefined) updateData.personalizedMessage = data.personalizedMessage || '';
    if (data.dataProtection !== undefined) updateData.dataProtection = data.dataProtection || '';
    if (data.platformLanguage !== undefined) updateData.platformLanguage = data.platformLanguage || '';
    if (data.planLimits !== undefined) updateData.planLimits = data.planLimits || {};
    if (data.platformMatchingType !== undefined) updateData.platformMatchingType = data.platformMatchingType || {};
    if (data.platformMatchingTypeSpecific !== undefined) updateData.platformMatchingTypeSpecific = data.platformMatchingTypeSpecific || {};
    if (data.imapArray !== undefined) updateData.imapArray = data.imapArray || [];
    if (data.defaultSmsSender !== undefined) updateData.defaultSmsSender = data.defaultSmsSender || 'firmenname';
    if (data.cvFilter !== undefined) updateData.cvFilter = data.cvFilter || false;
    if (data.cvFilterCriteria !== undefined) updateData.cvFilterCriteria = data.cvFilterCriteria || [];
    if (data.cvFilterPrompt !== undefined) updateData.cvFilterPrompt = data.cvFilterPrompt || '';
    if (data.cvFilterMode !== undefined) updateData.cvFilterMode = data.cvFilterMode || 'include';
    if (data.cvFilterApiKey !== undefined) updateData.cvFilterApiKey = data.cvFilterApiKey || '';
    if (data.cvFilterUid !== undefined) updateData.cvFilterUid = data.cvFilterUid || '';
    if (data.cvFilterExcludeSources !== undefined) updateData.cvFilterExcludeSources = data.cvFilterExcludeSources || [];
    if (data.cvFilterIncludeSources !== undefined) updateData.cvFilterIncludeSources = data.cvFilterIncludeSources || [];
    if (data.globalSound !== undefined) updateData.globalSound = data.globalSound || '';
    if (data.uid !== undefined) updateData.uid = data.uid || '';
    if (data.apiCredits !== undefined) updateData.apiCredits = data.apiCredits ?? 0;
    if (data.organisation !== undefined) updateData.organisation = data.organisation || '';
    if (data.functionName !== undefined) updateData.functionName = data.functionName || '';
    if (data.phoneSetupComplete !== undefined) updateData.phoneSetupComplete = !!data.phoneSetupComplete;
    if (data.phoneSetupType !== undefined) updateData.phoneSetupType = data.phoneSetupType || '';
    if (data.phoneNumber !== undefined) updateData.phoneNumber = data.phoneNumber || '';
    if (data.phoneSetupSkipped !== undefined) updateData.phoneSetupSkipped = !!data.phoneSetupSkipped;
    if (data.calendarConnected !== undefined) updateData.calendarConnected = !!data.calendarConnected;
    if (data.calendarSetupSkipped !== undefined) updateData.calendarSetupSkipped = !!data.calendarSetupSkipped;
    if (data.atsConnected !== undefined) updateData.atsConnected = !!data.atsConnected;
    if (data.atsProvider !== undefined) updateData.atsProvider = data.atsProvider || '';
    if (data.atsProviderName !== undefined) updateData.atsProviderName = data.atsProviderName || '';
    if (data.smsSetupComplete !== undefined) updateData.smsSetupComplete = !!data.smsSetupComplete;
    if (data.smsSenderNumber !== undefined) updateData.smsSenderNumber = data.smsSenderNumber || '';
    if (data.smsSenderName !== undefined) updateData.smsSenderName = data.smsSenderName || '';
    if (data.linkedinConnected !== undefined) updateData.linkedinConnected = !!data.linkedinConnected;
    if (data.linkedinAccountId !== undefined) updateData.linkedinAccountId = data.linkedinAccountId || '';
    if (data.linkedinConnectedAt !== undefined) updateData.linkedinConnectedAt = data.linkedinConnectedAt || '';
    if (data.notetakerSetupComplete !== undefined) updateData.notetakerSetupComplete = !!data.notetakerSetupComplete;
    if (data.emailValidationComplete !== undefined) updateData.emailValidationComplete = !!data.emailValidationComplete;

    if (Object.keys(updateData).length > 0) {
      updateData.created = new Date();
      updateData.status = 'aktiv';
      updateData.createdISO = new Date().toISOString();
      updateData.createdISODate = new Date().toISOString().split('T')[0];
      updateData.createdGerman = new Date().toLocaleString('de-DE');

      await this.app2.firestore
        .collection(FirebaseConstants.branding)
        .doc(docs[0].id)
        .update(updateData).then(() => {
          //auto update company logo for app.component.ts
          if (isNewLogoUploaded) {
            this.menuService.setCompanyLogo(data.companyLogo);
          }
          //update locations
          this.setLocations(data.standorte || []);
        })
    }
  }

  /**
   * Upload a global MP3 sound to storage and save its URL to branding.globalSound
   */
  async uploadGlobalSound(file: File): Promise<string> {
    if (!file) {
      return null;
    }

    try {
      const sanitizedName = `${new Date().getTime()}-${(file.name || 'sound.mp3').replace(/\s+/g, '_')}`;
      const storageRef: AngularFireStorageReference = this.customerStorage.ref(`/sounds/${sanitizedName}`);

      const metadata = { contentType: file.type || 'audio/mpeg' } as any;
      const uploadTaskSnapshot = await storageRef.put(file, metadata);
      const publicUrl = await uploadTaskSnapshot.ref.getDownloadURL();

      // Only return the Storage download URL; do not persist to Firestore here.
      return publicUrl;
    } catch (error) {
      console.error('Failed to upload global sound:', error);
      throw error;
    }
  }
  createaApplicantProfile(form) {
    return this.app2.firestore.collection('applicantProfile').add({
      form: form,
      email: form.email,
      vorname: form.vorname || '',
      language: form.language,
      nachname: form.nachname || '',
      jobTitle: form.jobTitle || '',
      jobpost: form.jobTitle || '',
      codingScore: form.codingScore || '',
      codingTitle: form.challengeTitle || '',
      codingChallenge: form.codingChallenge || {
        checked: false,
        description: '',
        language: '',
        level: '',
        name: '',
        type: '',
        url: '',
      },
      bewerberID: form.id,
      created: new Date(),
      status: 'aktiv',
      createdISO: new Date().toISOString(),
      createdISODate: new Date().toISOString().split('T')[0],
      createdGerman: new Date().toLocaleString('de-DE'),
    });
  }

  updateApplicantProfile(id, form) {
    return this.app2.firestore.collection('applicantProfile').doc(id).update({
      form: form,
    });
  }

  addApplicant(applicant) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .add(applicant);
  }

  /**
   * Counts applicants that came from one import source, so test data can be reviewed
   * before it is removed.
   */
  async countApplicantsBySource(source: string): Promise<number> {
    if (!source || !this.app2 || !this.app2.firestore) return 0;
    const snapshot = await this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .where('source', '==', source)
      .get();
    return snapshot.size;
  }

  /**
   * Removes every applicant that was created by one import source. Without this there was no way
   * to get imported test candidates out of the pool once real applicants had arrived.
   * Returns the number of deleted documents.
   */
  async deleteApplicantsBySource(source: string): Promise<number> {
    if (!source) throw new Error('An import source is required');
    if (!this.app2 || !this.app2.firestore) throw new Error('Database not initialized');
    const snapshot = await this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .where('source', '==', source)
      .get();
    const BATCH_LIMIT = 499;
    const docs = snapshot.docs;
    for (let i = 0; i < docs.length; i += BATCH_LIMIT) {
      const batch = (this.app2.firestore.firestore || this.app2.firestore).batch();
      for (const doc of docs.slice(i, i + BATCH_LIMIT)) {
        batch.delete(doc.ref);
      }
      await batch.commit();
    }
    return docs.length;
  }

  async importApplicantsDirectly(applicants: any[]): Promise<{ count: number; ids: string[] }> {
    if (!applicants || applicants.length === 0) {
      return { count: 0, ids: [] };
    }
    if (!this.app2 || !this.app2.firestore) {
      throw new Error('Database not initialized');
    }
    const ids: string[] = [];
    const collection = this.app2.firestore.collection(FirebaseConstants.applicants);
    for (const applicant of applicants) {
      const now = new Date();
      const ref = collection.doc();
      const id = ref.id;
      await ref.set({
        ...applicant,
        id,
        applicant_id: id,
        created: now,
        createdISO: now.toISOString(),
        createdGerman: now.toLocaleString('de-DE'),
        source: applicant.source || 'ARS Test Import',
        status: applicant.status || 'Neu',
        cvAnalyzed: true,
        cvUrl: applicant.cvUrl || 'ars-test-data://generated',
        hasCvData: true
      });
      ids.push(id);
    }
    return { count: ids.length, ids };
  }

  getEmailApplicants() {
    return this.app2.firestore.collection(FirebaseConstants.emailapplicants);
  }

  createZvooveApplicant(data) {
    this.getEmailApplicants()
      .where('uid', '==', data.uid)
      .get()
      .then(async (snap) => {
        if (snap.docs.length == 0) {
          const apiKey = await this.getZvooveBewerberApiKey();
          const apiLink = await this.getZvooveBewerberApiLinkById();
          const body = {
            apiKey: apiKey,
            apiLink: apiLink,
            applicantId: data.uid,
          };
          return this.http
            .post(
              'https://us-central1-mona-ai-pwa-firebase.cloudfunctions.net/zvoove-applicants-by-id',
              body,
            )
            .subscribe((res: any) => {
              console.log(res);
              this.getEmailApplicants().add({
                created: new Date(),
                email: data.email || '',
                vorname: data.name || '',
                nachname: data.surename || '',
                telefonnummer: data.mobile || data.phone || '',
                uid: data.uid || '',
                quelle: 'zvoove',
                jobUid:
                  res.Bewerbungen.length > 0
                    ? res.Bewerbungen[0].Stelle.ObjectUuid
                    : '',
                isInZvoove: true,
              });
            });
        }
      });
  }

  getReports() {
    return this.app2.firestore.collection('reporting');
  }

  returnEmails() {
    return this.app2.firestore.collection('emails');
  }

  getRecentEmails(limitNumber = 200) {
    return this.app2.firestore.collection('emails').orderBy('created', 'desc').limit(limitNumber).get();
  }

  getRecentSmsMessages(limitNumber = 200) {
    return this.app2.firestore.collection('sms_messages').orderBy('created', 'desc').limit(limitNumber).get();
  }

  returnChatHistory() {
    return this.app2.firestore.collection('MONARetrieval01');
  }

  addMONAChatMessage(message) {
    const userId = this.authService.returnUserId() || '';
    const accountId = this.authService.returnAccountId() || '';
    let db_level = 'sub';
    if (accountId == '') {
      db_level = 'top';
    }
    console.log('message', message);
    console.log('userId', userId);
    console.log('accountId', accountId);
    return this.app2.firestore.collection('MONARetrieval01').add({
      prompt: message.content || '',
      sender: message.sender,
      session_id: message.session_id,
      user_input: message.user_input,
      document_link: message.document_link,
      document_name: message.document_name,
      allowed_tools: message.allowed_tools,
      current_date: message.current_date,
      description: message.description,
      language_code: message.language_code,
      user_id: userId,
      db_level: db_level,
      account_id: accountId,
      created: new Date(),
      createTime: new Date(),
      createdISO: new Date().toISOString(),
    });
  }

  createChatSession(sessionData) {
    return this.app2.firestore.collection('AgentExecutorChat').add(sessionData);
  }

  getRecentChatSessions() {
    const userId = this.authService.returnUserId();
    const accountId = this.authService.returnAccountId();

    let query = this.app2.firestore.collection('AgentExecutorChat')
      .orderBy('created', 'desc')
      .limit(50);

    if (accountId) {
      query = query.where('account_id', '==', accountId);
    } else if (userId) {
      query = query.where('user_id', '==', userId);
    }

    return query;
  }

  addFormattingAIBefore(message) {
    return this.app2.firestore.collection('MONARetrieval01').add({
      prompt: message.content || '',
      sender: message.sender,
      tool: '',
      created: new Date(),
      createTime: new Date(),
      createdISO: new Date().toISOString(),
    });
  }

  deleteMONAChatMessage(messageid) {
    return this.app2.firestore.collection('MONARetrieval01').delete(messageid);
  }

  updateChatMessageFeedback(id, feedback) {
    return this.app2.firestore.collection('MONARetrieval01').doc(id).update({
      feedback: feedback,
    });
  }

  savePlatformChat(chatData: {
    componentName: string;
    sessionId: string;
    messages: Array<{ role: string; content: string; timestamp: Date }>;
    generatedWorkflow?: any;
    agentId?: string;
    agentName?: string;
    arsSessionId?: string;
    linkedinSearchResults?: any[];
  }) {
    const userId = this.authService.returnUserId() || '';
    const accountId = this.authService.returnAccountId() || '';
    const doc: any = {
      componentName: chatData.componentName,
      sessionId: chatData.sessionId,
      messages: chatData.messages,
      generatedWorkflow: chatData.generatedWorkflow || null,
      agentId: chatData.agentId || null,
      agentName: chatData.agentName || null,
      userId: userId,
      accountId: accountId,
      created: new Date(),
      createdISO: new Date().toISOString(),
    };
    if (chatData.arsSessionId) doc.arsSessionId = chatData.arsSessionId;
    if (chatData.linkedinSearchResults?.length) doc.linkedinSearchResults = chatData.linkedinSearchResults;
    return this.app2.firestore.collection('mona-ai-platform-chat').add(stripUndefinedDeep(doc));
  }

  updatePlatformChat(docId: string, chatData: {
    messages: Array<{ role: string; content: string; timestamp: Date }>;
    generatedWorkflow?: any;
    arsSessionId?: string;
    linkedinSearchResults?: any[];
  }) {
    const update: any = {
      messages: chatData.messages,
      generatedWorkflow: chatData.generatedWorkflow || null,
      updated: new Date(),
      updatedISO: new Date().toISOString(),
    };
    if (chatData.arsSessionId !== undefined) update.arsSessionId = chatData.arsSessionId;
    if (chatData.linkedinSearchResults !== undefined) update.linkedinSearchResults = chatData.linkedinSearchResults;
    return this.app2.firestore.collection('mona-ai-platform-chat').doc(docId).update(stripUndefinedDeep(update));
  }

  getPlatformChatHistory(componentName: string, agentId?: string) {
    const userId = this.authService.returnUserId() || '';
    return this.app2.firestore.collection('mona-ai-platform-chat')
      .where('userId', '==', userId);
  }

  getPlatformChatDoc(docId: string) {
    return this.app2.firestore.collection('mona-ai-platform-chat').doc(docId);
  }

  getArsChatHistorySessions(userId: string) {
    return this.app2.firestore
      .collection('ars_chat_history')
      .doc(userId)
      .collection('sessions');
  }

  async getNotetakerTranscripts(agentId: string, maxResults: number = 10): Promise<any[]> {
    const userId = this.authService.returnUserId() || '';
    if (!userId || !agentId) return [];
    try {
      const snap = await this.app2.firestore.collection('mona-ai-platform-chat')
        .where('userId', '==', userId)
        .get();
      const all = snap.docs
        .map((d: any) => ({ id: d.id, ...d.data() }))
        .filter((s: any) => s.agentId === agentId && s.componentName === 'mona-agent-chat');
      all.sort((a: any, b: any) => {
        const da = a.created?.toDate ? a.created.toDate() : new Date(a.createdISO || a.created || 0);
        const db = b.created?.toDate ? b.created.toDate() : new Date(b.createdISO || b.created || 0);
        return db.getTime() - da.getTime();
      });
      return all.slice(0, maxResults);
    } catch (e) {
      console.error('getNotetakerTranscripts error:', e);
      return [];
    }
  }

  // addMONAChatMessage(message, monaTool) {
  //   console.log("message", message);
  //   return this.app2.firestore.collection("generate").add({
  //     prompt: message.content || "",
  //     sender: message.sender,
  //     tool: monaTool
  //   })
  // }

  // addFormattingAIBefore(message) {
  //   return this.app2.firestore.collection("generate").add({
  //     prompt: message.content || "",
  //     sender: message.sender,
  //     tool: ""
  //   })
  // }

  // deleteMONAChatMessage(messageid) {
  //   return this.app2.firestore.collection("generate").delete(messageid)
  // }
  //

  AddJobs(profile) {
    const platformId = PLATFORM_ID;
    const settings = {};
    const accountId = this.authService.returnAccountId();

    return this.app2.firestore
      .collection('applicantsToCall')
      .add({
        accountId: accountId,
        profile: profile,
        jobId: profile.jobId,
        phoneNumber: profile.mobiltelefon || profile.telefon || '',
        email: profile.email,
        telefonnummer: profile.telefon,
        mobilnummer: profile.mobiltelefon,
        jobOfferWorkflow: profile.jobOfferWorkflow,
        firstName: profile.vorname,
        lastName: profile.nachname,
        vorname: profile.vorname,
        nachname: profile.nachname,
        jobTitle: profile.jobTitle,
        quelle: 'intern',
        status: 'new',
        created: new Date(),
        createdGerman: new Date().toLocaleDateString('de-DE'),
        createdISO: new Date().toISOString(),
        createdISODate: new Date().toISOString().split('T')[0],
        timestamp: new Date().getTime(),
      })
      .then(() => { })
      .catch((err) => {
        if (profile.email) {
          this.alertErrorUpload(profile.email);
        } else if (profile.mobiltelefon || profile.telefon) {
          this.alertErrorUpload(profile.mobiltelefon || profile.telefon);
        } else if (profile.vorname || profile.nachname) {
          this.alertErrorUpload(profile.vorname || profile.nachname);
        } else {
          this.alertErrorUpload('unknown');
        }
      });
  }

  setFallbackJobOffer(id) {
    this.getProfile().get().then((snap) => {
      if (snap.docs && snap.docs.length > 0) {
        let doc = snap.docs[0];
        if (doc.exists) {
          doc.ref.update({
            fallbackInterviewId: id,
          });
        }
      } else {
        this.app2.firestore.collection(FirebaseConstants.branding).add({
          fallbackInterviewId: id,
        });
      }
    });
  }

  /*
    * This function is used to create a new applicant.
    */
  async createNewApplicant(newApplicantData) {
    return await this.app2.firestore.collection(FirebaseConstants.applicants).add(newApplicantData)

  }

  /*
    * Returns a new document reference with an auto-generated ID for the applicants collection.
    * Use this to pre-generate an ID before writing, so the applicantId can be set in the initial write.
    */
  getNewApplicantRef() {
    return this.app2.firestore.collection(FirebaseConstants.applicants).doc();
  }

  createApplicant(form) {
    this.getApplicants()
      .orderBy('id', 'desc')
      .get()
      .then((snap) => {
        if (snap.docs) {
          var id = String(Number(snap.docs[0].id) + 1);
          return this.app2.firestore
            .collection(FirebaseConstants.applicants)
            .doc(id)
            .set({
              form: form,
              email: form.email,
              id: id,
            });
        } else {
          var id = '1001';
          return this.app2.firestore
            .collection(FirebaseConstants.applicants)
            .doc(id)
            .set({
              form: form,
              email: form.email,
              id: id,
            });
        }
      })
      .catch((err) => {
        const id = 'no id';
        return id;
      });
  }

  getApplicantEditingData(id) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .get();
  }

  async updateApplicantForm(id, form) {
    console.log(form);
    form.Wohnort = {
      city: form.wohnort || '',
      hausnummer: form.hausnummer || '',
      strasse: form.strasse || '',
      postleitzahl: form.postleitzahl || '',
    }
    //get the old obj 
    const oldForm = await this.app2.firestore.collection(FirebaseConstants.applicants).doc(id).get().then(doc => doc.data() || {});
    //find the differences
    const previousValue = {}
    const newValue = {};
    for (const key in form) {
      if (form.hasOwnProperty(key)) {
        if (form[key] !== oldForm[key]) {
          previousValue[key] = oldForm[key];
          newValue[key] = form[key];
        }
      }
    }
    //log the changes 
    if (Object.keys(previousValue).length > 0) {
      //add log before deletion.
      //first get idToken of user to authorize cloud function
      console.log('app2 auth', this.user.user);
      let idPromises = [];
      idPromises.push(this.user.user.getIdToken())
      idPromises.push(this.authService.getIdToken());
      Promise.all(idPromises).then(async ([userIdToken, pwaUserIdToken]) => {
        const headers = {
          "Authorization": `Bearer ${pwaUserIdToken}`,
          "authenticated-user-token": `Bearer ${userIdToken}`
        }
        this.http.post(`https://save-applicant-logs-219198639425.europe-west3.run.app`, {
          applicantId: id,
          kundennummer: this.customerNumber,
          data: {
            timestamp: new Date().toISOString(),
            action: 'update',
            before: previousValue,
            after: newValue
          }
        }, {
          headers: headers
        }).toPromise().then(response => {
          console.log('Applicant changes logged successfully', response);
        }).catch(error => {
          console.error('Error logging applicant changes', error);
        });
      });
    }
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        Wohnort: form.Wohnort,
        vorname: form.vorname || '',
        nachname: form.nachname || '',
        geburtsname: form.geburtsname || '',
        land: form.land || '',
        geburtsdatum: form.geburtsdatum || '',
        sprache: form.sprache || [''],
        languages: form.languages || [''],
        strasse: form.strasse || '',
        hausnummer: form.hausnummer || [''],
        postleitzahl: form.postleitzahl || '',
        wohnort: form.wohnort || '',
        geburtsland: form.geburtsland || '',
        geburtsort: form.geburtsort || '',
        staatsangehoerigkeit: form.staatsangehoerigkeit || '',
        telefonnummer: form.telefonnummer || '',
        handynummer: form.handynummer || '',
        email: form.email || '',
        sentSMS: form.sentSMS || false,
        sentPhonecall: form.sentPhonecall || false,
        sentEmail: form.sentEmail || false,
        updated: { date: new Date(), updatedBy: this.authService.returnUser() },
        notes: form.notes || '',
        qualifications: form.qualifications || '',
        unternehmen: form.unternehmen || '',
        customFields: form.customFields || [''],
        experience: form.experience || '',
        mobilnummer: form.mobilnummer || '',
        nationalitaet: form.staatsangehoerigkeit || '',
      });
  }

  updateApplicantMONAFeedback(id, feedback) {
    console.log(feedback);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        MONAFeedback: feedback,
      });
  }

  updateApplicantMatches(id, feedback) {
    console.log(feedback);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        AIMatches: feedback,
      });
  }

  updateApplicantResumeFeedback(id, feedback) {
    console.log(feedback);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        ResumeFeedback: feedback,
      });
  }

  updateApplicantInformation(id, pn, arbeit, form) {
    console.log(form);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        status: 'mitarbeiter',
        personalnummer: pn,
        Personalnummer: pn,
        Arbeit: arbeit,
        arbeit: arbeit,
        form: form,
      });
  }

  getFirestoreDate(date) {
    // Check if 'date' is an instance of Date and is valid
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      console.error('Invalid date object:', date);
      // Handle the error appropriately
      return; // or throw an error
    }

    // If valid, convert to Firestore Timestamp
    const firestoreDate = firebase.firestore.Timestamp.fromDate(date);
    return firestoreDate;
  }

  updateApplicantStatus(id, status) {
    console.log('----------- status changed to: ' + status + ' ----------- ');
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        status: status,
      });
  }

  updateApplicantWithArray(id, data) {
    console.log(data);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        workflowArray: data,
      });
  }

  updateFullApplicantObjectWithLogs(id, logs) {
    console.log(logs);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        logs: logs,
      });
  }

  updateApplicant(id: string, data: Partial<any>): Promise<void> {
    return this.app2.firestore
      .collection('applicants')
      .doc(id)
      .update(data)
      .then(() => {
        console.log(`Applicant ${id} successfully updated.`);
      })
      .catch((error) => {
        console.error(`Error updating applicant ${id}:`, error);
        throw error; // Re-throw the error after logging
      });
  }

  getApplicants(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.applicants);
  }

  async getApplicantCount(): Promise<number> {
    try {
      if (!this.app2 || !this.app2.firestore) {
        console.warn('[getApplicantCount] Database not connected');
        return 0;
      }
      const snapshot = await this.app2.firestore
        .collection(FirebaseConstants.applicants)
        .get();
      return snapshot.size;
    } catch (error) {
      console.error('[getApplicantCount] Error fetching applicant count:', error);
      return 0;
    }
  }

  // Returns IDs of applicants that require payment to unlock
  async getPayToUnlockApplicantIds(): Promise<string[]> {
    try {
      const snapshot = await this.app2.firestore
        .collection(FirebaseConstants.applicants)
        .where('payToUnlock', '==', true)
        .get();
      return snapshot.docs.map(doc => doc.id);
    } catch (error) {
      console.error('[PayToUnlock] Error fetching locked applicant IDs:', error);
      return [];
    }
  }

  deleteApplicantField(id: string, field: string): Promise<void> {
    console.log(
      `----------- Deleting field '${field}' for applicant ID: ${id} ----------- `,
    );
    const updateData: any = {};
    updateData[field] = firebase.firestore.FieldValue.delete();
    return this.updateApplicant(id, updateData);
  }

  updateCalendlyLink(id: string, calendlyLink: string): Promise<void> {
    console.log(
      `----------- Updating calendly link for applicant ID: ${id} -----------`,
    );
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        calendlyLink: calendlyLink,
      });
  }

  updateJobOfferWorkflowInApplicants(
    id: string,
    jobOfferWorkflow: string,
  ): Promise<void> {
    console.log(
      `----------- Updating job offer workflow for applicant ID: ${id} ----------- `,
    );
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        jobOfferWorkflow: jobOfferWorkflow,
      });
  }

  async deleteLastLog(id: string, currentLogs: any[]): Promise<void> {
    if (Array.isArray(currentLogs) && currentLogs.length > 0) {
      const updatedLogs = currentLogs.slice(0, -1);
      console.log(
        `----------- Deleting last log for applicant ID: ${id} ----------- `,
      );
      await this.updateApplicant(id, { logs: updatedLogs });
    } else {
      console.log(
        `----------- No logs to delete for applicant ID: ${id} ----------- `,
      );
    }
  }

  addLogToApplicant(id: string, log: any): Promise<void> {
    console.log(`----------- Adding log to applicant ID: ${id} ----------- `);
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        logs: firebase.firestore.FieldValue.arrayUnion(log),
      });
  }

  async getApplicantById(applicantId) {
    if (applicantId == null || applicantId == undefined || applicantId === '') {
      return null;
    }
    const docRef = await this.app2.firestore.collection(FirebaseConstants.applicants).doc(applicantId);
    if (docRef) {
      return docRef.get().then((doc) => {
        if (doc.exists) {
          const data = doc.data();
          data.id = doc.id;
          data.applicantId = doc.id;
          return data;
        } else {
          console.log("No such document!");
          return null;
        }
      }).catch((error) => {
        console.error("Error getting document:", error);
        return null;
      });
    }
    return null;
  }

  async getApplicantsWithCreated() {
    const snapshot = await this.createdQuery.get();
    // iterate docs and get data
    const applicants = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
      };
    });
    // TODO after change to pull data from API
    return applicants;
  }

  async getMatchesFromAPI(
    pageSize: 50 | 100 | null = null,
    paginationToken: string | null = null,
    location: string | string[] | null = null,
    offset: number | null = null
  ): Promise<{
    total: number;
    count: number;
    data: { emailsToBeSent: any[] };
    error?: string;
    nextPageToken?: string | null;
    nextOffset?: number | null;
  }> {
    const allMatches: any[] = [];
    let hasMore = true;
    let currentToken: string | null = paginationToken;
    let totalFromApi: number | null = null;
    let pagesProcessed = 0;

    try {
      const apiKey = await this.getApiKey();
      while (hasMore) {
        const requestBody: any = {
          endpoint: 'getMatchesFromDatabaseForPlatform',
          apiKey: apiKey,
          uid: this.authService.returnUserId(),
          platform: 'MONA',
          permission: 'readData',
          sortBy: 'created',
          sortOrder: 'desc',
          ...(location ? { location } : {}),
          ...(location && offset !== null ? { offset } : {}),
          ...(!location && currentToken ? { paginationToken: currentToken } : {}),
          ...(pageSize && { pageSize })
        };

        const response: any = await this.http
          .post(
            `${environment.cloudFunctionsBase}/database`,
            requestBody,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .toPromise();

        console.log('API Response:', response);

        if (response?.data?.emailsToBeSent) {
          allMatches.push(...response.data.emailsToBeSent);

          if (totalFromApi === null) {
            totalFromApi = response.total || response.pagination?.total || null;
          }

          if (location) {
            const responseNextOffset = response.pagination?.nextOffset;
            offset = responseNextOffset !== null && responseNextOffset !== undefined ? responseNextOffset : null;
          } else {
            currentToken = response.pagination?.nextPageToken || null;
          }
          pagesProcessed++;

          if (pageSize) {
            console.log(`[Matches] Initial load: fetched first page with ${allMatches.length} matches out of ${totalFromApi || 'unknown'} total`);
            hasMore = false;
          } else {
            hasMore = location ? (offset !== null) : (currentToken !== null);
          }
        } else {
          console.log('No more data or invalid response structure');
          hasMore = false;
        }
      }

      const result = {
        total: totalFromApi || allMatches.length,
        count: allMatches.length,
        data: { emailsToBeSent: allMatches },
        nextPageToken: location ? null : currentToken,
        nextOffset: location ? offset : null
      };

      console.log('[Matches] Final aggregated result:', {
        totalMatches: result.total,
        loadedMatches: result.count,
        pagesProcessed
      });

      return result;
    } catch (error: any) {
      console.error('Error fetching matches:', error);
      return {
        total: 0,
        count: 0,
        data: { emailsToBeSent: [] },
        error: error?.message ?? 'Unknown error',
      };
    }
  }


  // async getMatchesFromAPI() {
  //   let allMatches = [];
  //   let hasMore = true;
  //   let paginationToken = null;

  //   try {
  //     // Keep fetching pages until we have all the data
  //     while (hasMore) {
  //       const requestBody: any = {
  //         endpoint: 'getMatchesFromDatabaseForPlatform',
  //         apiKey: 'asd',
  //         uid: this.authService.returnUserId(),
  //         platform: 'MONA',
  //         permission: 'readData'
  //       };

  //       // Add pagination token if we have one
  //       if (paginationToken) {
  //         requestBody.paginationToken = paginationToken;
  //       }

  //       const response: any = await this.http.post(
  //         'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //         requestBody,
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Accept-Encoding': 'gzip, deflate'
  //           }
  //         }
  //       ).toPromise();

  //       console.log('API Response:', response);

  //       // Check if we got valid data
  //       if (response && response.data && response.data.emailsToBeSent) {
  //         // Add this page of data to our collection
  //         allMatches = [...allMatches, ...response.data.emailsToBeSent];

  //         // Check if there are more pages to fetch
  //         // Your API returns nextPageToken in pagination object
  //         paginationToken = response.pagination?.nextPageToken || null;
  //         hasMore = paginationToken !== null;

  //         // Safety check to prevent infinite loops
  //         if (allMatches.length >= 5000) { // Increased limit since we're fetching 250 per page
  //           console.warn('Reached maximum limit of 5000 matches, stopping pagination');
  //           hasMore = false;
  //         }
  //       } else {
  //         console.log('No more data or invalid response structure');
  //         hasMore = false;
  //       }
  //     }

  //     // Return data using the total from the API response (if available from last call)
  //     // or fall back to the actual count we collected
  //     const result = {
  //       total: allMatches.length, // You could also use response.total from the last response
  //       count: allMatches.length,
  //       data: { emailsToBeSent: allMatches }
  //     };

  //     console.log('Final aggregated result:', {
  //       totalMatches: result.total,
  //       pagesProcessed: Math.ceil(allMatches.length / 250) // Now 250 per page
  //     });

  //     return result;

  //   } catch (error) {
  //     console.error('Error fetching matches:', error);
  //     throw error;
  //   }
  // }

  // async getApplicantsWithCreatedFromAPI() {
  //   // Define smaller page size to avoid response size limitations
  //   const pageSize = 100;
  //   let allApplicants = [];
  //   let hasMore = true;
  //   let cursor = null;

  //   try {
  //     // Keep fetching pages until we have all the data
  //     while (hasMore) {
  //       const response: any = await this.http.post(
  //         'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //         {
  //           endpoint: 'getApplicantsFromDatabaseForPlatform',
  //           apiKey: 'asd',
  //           uid: this.authService.returnUserId(),
  //           platform: 'MONA',
  //           permission: 'readApplicants',
  //           // Add pagination parameters
  //           pageSize: pageSize,
  //           cursor: cursor
  //         },
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Accept-Encoding': 'gzip, deflate' // Support compression
  //           }
  //         }
  //       ).toPromise();

  //       // Check if we got valid data
  //       if (response && response.data) {
  //         // Add this page of data to our collection
  //         allApplicants = [...allApplicants, ...response.data];

  //         // Check if there are more pages to fetch
  //         hasMore = response.pagination?.hasMore || false;
  //         cursor = response.pagination?.nextCursor || null;

  //         // Safety check to prevent infinite loops
  //         if (!cursor || allApplicants.length >= 2500) {
  //           hasMore = false;
  //         }
  //       } else {
  //         hasMore = false;
  //       }
  //     }

  //     // Return data in the same format as the original API
  //     const result = {
  //       data: allApplicants,
  //       count: allApplicants.length
  //     };

  //     console.log('Response from API:', result);
  //     return result;

  //   } catch (error) {
  //     console.error('Error fetching applicants:', error);
  //     throw error;
  //   }
  // }

  // async getSalesCorrespondenceFromDatabaseFromAPI() {
  //   // Define smaller page size to avoid response size limitations
  //   const pageSize = 100;
  //   let allCorrespondence = [];
  //   let hasMore = true;
  //   let cursor = null;

  //   try {
  //     // Keep fetching pages until we have all the data
  //     while (hasMore) {
  //       const response: any = await this.http.post(
  //         'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //         {
  //           endpoint: 'getSalesCorrespondenceFromDatabase',
  //           apiKey: 'asd',
  //           uid: this.authService.returnUserId(),
  //           platform: 'MONA',
  //           permission: 'readData',
  //           // Add pagination parameters
  //           pageSize: pageSize,
  //           cursor: cursor
  //         },
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Accept-Encoding': 'gzip, deflate' // Support compression
  //           }
  //         }
  //       ).toPromise();

  //       // Check if we got valid data
  //       if (response && response.data) {
  //         // Add this page of data to our collection
  //         allCorrespondence = [...allCorrespondence, ...response.data];

  //         // Check if there are more pages to fetch
  //         hasMore = response.nextPageToken || response.pagination?.hasMore || false;
  //         cursor = response.nextPageToken || response.pagination?.nextCursor || null;

  //         // Safety check to prevent infinite loops
  //         if (!cursor || allCorrespondence.length >= 2500) {
  //           hasMore = false;
  //         }
  //       } else {
  //         hasMore = false;
  //       }
  //     }

  //     // Return data in the same format as the original API
  //     const result = {
  //       data: allCorrespondence,
  //       pageSize: allCorrespondence.length,
  //       totalMatches: allCorrespondence.length
  //     };

  //     console.log('Response from API:', result);
  //     return result;

  //   } catch (error) {
  //     console.error('Error fetching sales correspondence:', error);
  //     throw error;
  //   }
  // }

  // getMatchesPaginated(options: any = {}) {
  //   return this.http.post(
  //     'https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/database',
  //     {
  //       endpoint: 'getMatchesFromDatabaseForPlatform',
  //       apiKey: 'asd',
  //       uid: this.authService.returnUserId(),
  //       platform: 'MONA',
  //       permission: 'readData',
  //       // Pagination and filter options
  //       pageSize: options.pageSize || 50,
  //       cursor: options.cursor || null,
  //       minScore: options.minScore || 50,
  //       dateFrom: options.dateFrom || null,
  //       dateTo: options.dateTo || null
  //     },
  //     {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept-Encoding': 'gzip, deflate'
  //       }
  //     }
  //   );
  // }

  // Updated service methods to work with the new API pagination
  // All methods maintain the same interface while adapting to the new API internally

  // Base URL for API calls
  private readonly API_URL = `${environment.cloudFunctionsBase}/database`;
  private readonly MAX_TOTAL_RECORDS = 5000; // Set a reasonable upper limit for safety

  /**
   * Gets all matches from the API by automatically fetching all pages
   * @returns Promise with all matches consolidated into a single response
   */
  // async getMatchesFromAPI() {
  //   const MAX_PAGE_SIZE = 250;         // fixed by the API
  //   const allMatches: any[] = [];
  //   let hasMore = true;
  //   let nextPageToken: string | null = null;
  //   let totalCount = 0;
  //   let batchNumber = 1;

  //   console.log('Starting to fetch all matches in batches...');

  //   while (hasMore) {
  //     const offset = nextPageToken ?? '0';
  //     console.log(`Fetching batch #${batchNumber} (offset ${offset})…`);

  //     interface ApiResponse {
  //       total: number;
  //       count: number;
  //       emailsToBeSent: any[];
  //       pagination: {
  //         nextPageToken: string | null;
  //         total: number;
  //         hasMore: boolean;
  //       };
  //     }

  //     const response = await this.http
  //       .post<ApiResponse>(
  //         this.API_URL,
  //         {
  //           endpoint: 'getMatchesFromDatabaseForPlatform',
  //           apiKey: 'asd',
  //           uid: this.authService.returnUserId(),
  //           platform: 'MONA',
  //           paginationToken: nextPageToken
  //         },
  //         { headers: { 'Content-Type': 'application/json' } }
  //       )
  //       .toPromise();

  //       console.log(response);

  //     // On first page, stash the total
  //     if (batchNumber === 1) {
  //       totalCount = response.total;
  //       console.log(`Total records available: ${totalCount}`);
  //     }

  //     const matches = response.emailsToBeSent || [];
  //     if (matches.length) {
  //       allMatches.push(...matches);
  //       console.log(
  //         `Batch #${batchNumber} added ${matches.length} (fetched ${allMatches.length}/${totalCount})`
  //       );

  //       // prepare for next iteration
  //       nextPageToken = response.pagination.nextPageToken;
  //       hasMore =
  //         !!nextPageToken &&
  //         allMatches.length < totalCount &&
  //         allMatches.length < this.MAX_TOTAL_RECORDS;

  //       if (!hasMore) {
  //         console.log('No more pages or reached your max-record limit.');
  //       }
  //     } else {
  //       console.log('No matches returned in this batch.');
  //       hasMore = false;
  //     }

  //     batchNumber++;
  //   }

  //   return {
  //     total: totalCount,
  //     count: allMatches.length,
  //     emailsToBeSent: allMatches,
  //     pagination: {
  //       nextPageToken: null,
  //       total: totalCount,
  //       hasMore: false
  //     }
  //   };
  // }

  /**
   * Gets all applicants with created timestamp from the API
   * @returns Promise with all applicants
   */
  async getApplicantsWithCreatedFromAPI(
    pageSize: 50 | 100 | null = null,
    paginationToken: string | null = null,
    location: string | string[] | null = null,
    offset: number | null = null
  ) {
    try {
      console.log(`[Applicants] Fetching applicants with pageSize: ${pageSize}, location: ${JSON.stringify(location)}...`);

      const requestBody: any = {
        endpoint: 'getApplicantsFromDatabaseForPlatform',
        apiKey: await this.getApiKey(),
        uid: this.authService.returnUserId(),
        platform: 'MONA',
        sortBy: 'created',
        sortOrder: 'desc',
        ...(pageSize && { pageSize }),
        ...(location ? { location } : {}),
        ...(location && offset ? { offset } : {}),
        ...(!location && paginationToken ? { paginationToken } : {})
      };

      const response: any = await this.http.post(
        this.API_URL,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).pipe(timeout(25000)).toPromise();

      let applicants = [];
      let total = 0;
      let nextPageToken = null;
      let nextOffset: number | null = null;

      if (response && response.data) {
        applicants = response.data;
        total = response.total || response.pagination?.total || applicants.length;
        if (location) {
          nextOffset = response.pagination?.nextOffset ?? null;
        } else {
          nextPageToken = response.pagination?.nextPageToken || null;
        }
        console.log(`[Applicants] Retrieved ${applicants.length} applicants (total: ${total}, hasMore: ${nextPageToken !== null || nextOffset !== null}).`);
      } else {
        console.log('No applicants found or invalid response.');
      }

      const result = {
        data: applicants,
        count: applicants.length,
        total: total,
        nextPageToken: nextPageToken,
        nextOffset: nextOffset
      };

      return result;

    } catch (error) {
      console.error('Error fetching applicants:', error);
      return {
        data: [],
        count: 0,
        total: 0,
        nextPageToken: null,
        nextOffset: null
      };
    }
  }

  /**
   * Gets all job offers from the API
   * @returns Promise with all job offers
   */
  async getJobOffersFromAPI() {
    try {
      console.log(`[Job Offers] Fetching job offers...`);

      const requestBody: any = {
        endpoint: 'getJobOffersFromDatabaseForPlatform',
        apiKey: await this.getApiKey(),
        uid: this.authService.returnUserId(),
        platform: 'MONA',
        sortBy: 'updated',
        sortOrder: 'desc'
      };

      const response: any = await this.http.post(
        this.API_URL,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).toPromise();

      let jobOffers = [];
      let total = 0;

      if (response && response.data) {
        jobOffers = response.data;
        total = response.total || jobOffers.length;
        console.log(`[Job Offers] Retrieved ${jobOffers.length} job offers (total: ${total}).`);
      } else {
        console.log('No job offers found or invalid response.');
      }

      // Return data in the format matching the API response
      const result = {
        data: jobOffers,
        count: jobOffers.length,
        total: total
      };

      return result;

    } catch (error) {
      console.error('Error fetching job offers:', error);
      return {
        data: [],
        count: 0,
        total: 0
      };
    }
  }


  /**
   * Gets all sales correspondence from the API by automatically fetching all pages
   * @returns Promise with all correspondence consolidated into a single response
   */
  async getSalesCorrespondenceFromDatabaseFromAPI(pageSize: 50 | 100 | null = null, paginationToken: string | null = null) {
    try {
      console.log(`[Sales Correspondence] Fetching with pageSize: ${pageSize}...`);

      const requestBody: any = {
        endpoint: 'getSalesCorrespondenceFromDatabase',
        apiKey: await this.getApiKey(),
        uid: this.authService.returnUserId(),
        platform: 'MONA',
        sortBy: 'created',
        sortOrder: 'desc',
        ...(pageSize && { pageSize }),
        ...(paginationToken && { paginationToken })
      };

      const response: any = await this.http.post(
        this.API_URL,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).toPromise();

      let correspondence = [];
      let total = 0;
      let nextPageToken = null;

      if (response && response.data) {
        correspondence = response.data;
        total = response.pagination?.total || response.totalMatches || correspondence.length;
        nextPageToken = response.pagination?.nextPageToken || null;
        console.log(`[Sales Correspondence] Retrieved ${correspondence.length} records (total: ${total}, hasMore: ${nextPageToken !== null}).`);
      } else {
        console.log('[Sales Correspondence] No data found or invalid response.');
      }

      const result = {
        data: correspondence,
        count: correspondence.length,
        total: total,
        totalMatches: total,
        pageSize: correspondence.length,
        nextPageToken: nextPageToken,
        pagination: {
          nextPageToken: nextPageToken,
          total: total,
          pageSize: correspondence.length,
          hasMore: nextPageToken !== null
        }
      };

      return result;

    } catch (error) {
      console.error('[Sales Correspondence] Error fetching:', error);
      return {
        data: [],
        count: 0,
        total: 0,
        totalMatches: 0,
        pageSize: 0,
        nextPageToken: null,
        pagination: {
          nextPageToken: null,
          total: 0,
          pageSize: 0,
          hasMore: false
        }
      };
    }
  }

  /**
   * Search matches with filtering by field (email, applicantId, jobTitle)
   */
  async searchMatchesFromAPI(
    searchQuery: string,
    searchField: 'email' | 'applicantId' | 'jobTitle' | 'date',
    pageSize: 50 | 100 = 50,
    paginationToken: string | null = null
  ) {
    try {
      console.log(`[Search Matches] Searching ${searchField}="${searchQuery}" with pageSize: ${pageSize}...`);

      const requestBody: any = {
        endpoint: 'searchMatchesForPlatform',
        uid: this.authService.returnUserId(),
        searchQuery,
        searchField,
        pageSize,
        ...(paginationToken && { paginationToken })
      };

      const response: any = await this.http.post(
        this.API_URL,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).toPromise();

      let matches = [];
      let total = 0;
      let nextPageToken = null;

      if (response && response.data) {
        matches = response.data.emailsToBeSent || response.data;
        total = response.pagination?.total || response.total || matches.length;
        nextPageToken = response.pagination?.nextPageToken || null;
        console.log(`[Search Matches] Found ${matches.length} results (total: ${total})`);
      }

      return {
        data: { emailsToBeSent: matches },
        count: matches.length,
        total: total,
        nextPageToken: nextPageToken,
        pagination: {
          nextPageToken: nextPageToken,
          total: total,
          pageSize: matches.length,
          hasMore: nextPageToken !== null
        }
      };

    } catch (error) {
      console.error('[Search Matches] Error searching:', error);
      return {
        data: { emailsToBeSent: [] },
        count: 0,
        total: 0,
        nextPageToken: null,
        pagination: {
          nextPageToken: null,
          total: 0,
          pageSize: 0,
          hasMore: false
        }
      };
    }
  }

  /**
   * Search sales correspondence with filtering by field (email, applicantId, jobTitle, status)
   */
  async searchSalesFromAPI(
    searchQuery: string,
    searchField: 'email' | 'applicantId' | 'jobTitle' | 'status' | 'date',
    pageSize: 50 | 100 = 50,
    paginationToken: string | null = null
  ) {
    try {
      console.log(`[Search Sales] Searching ${searchField}="${searchQuery}" with pageSize: ${pageSize}...`);

      const requestBody: any = {
        endpoint: 'searchSalesForPlatform',
        uid: this.authService.returnUserId(),
        searchQuery,
        searchField,
        pageSize,
        ...(paginationToken && { paginationToken })
      };

      const response: any = await this.http.post(
        this.API_URL,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ).toPromise();

      let correspondence = [];
      let total = 0;
      let nextPageToken = null;

      if (response && response.data) {
        correspondence = response.data;
        total = response.pagination?.total || response.total || correspondence.length;
        nextPageToken = response.pagination?.nextPageToken || null;
        console.log(`[Search Sales] Found ${correspondence.length} results (total: ${total})`);
      }

      return {
        data: correspondence,
        count: correspondence.length,
        total: total,
        nextPageToken: nextPageToken,
        pagination: {
          nextPageToken: nextPageToken,
          total: total,
          pageSize: correspondence.length,
          hasMore: nextPageToken !== null
        }
      };

    } catch (error) {
      console.error('[Search Sales] Error searching:', error);
      return {
        data: [],
        count: 0,
        total: 0,
        nextPageToken: null,
        pagination: {
          nextPageToken: null,
          total: 0,
          pageSize: 0,
          hasMore: false
        }
      };
    }
  }

  /**
   * Global search across all fields for matches
   * Searches email, applicantId, and jobTitle in parallel and merges results
   */
  async globalSearchMatches(searchQuery: string, pageSize: 50 | 100 = 50) {
    try {
      console.log(`[Global Search Matches] Searching for "${searchQuery}" across all fields...`);

      // Search all fields in parallel
      const [emailResults, applicantIdResults, jobTitleResults] = await Promise.all([
        this.searchMatchesFromAPI(searchQuery, 'email', pageSize),
        this.searchMatchesFromAPI(searchQuery, 'applicantId', pageSize),
        this.searchMatchesFromAPI(searchQuery, 'jobTitle', pageSize)
      ]);

      // Merge all results
      const allMatches = [
        ...emailResults.data.emailsToBeSent,
        ...applicantIdResults.data.emailsToBeSent,
        ...jobTitleResults.data.emailsToBeSent
      ];

      // Deduplicate by ID
      const uniqueMatches = Array.from(
        new Map(allMatches.map(match => [match.id, match])).values()
      );

      console.log(`[Global Search Matches] Found ${uniqueMatches.length} unique results (${allMatches.length} total before dedup)`);

      return {
        data: { emailsToBeSent: uniqueMatches },
        count: uniqueMatches.length,
        total: uniqueMatches.length,
        nextPageToken: null, // Global search doesn't support pagination
        pagination: {
          nextPageToken: null,
          total: uniqueMatches.length,
          pageSize: uniqueMatches.length,
          hasMore: false
        }
      };

    } catch (error) {
      console.error('[Global Search Matches] Error:', error);
      return {
        data: { emailsToBeSent: [] },
        count: 0,
        total: 0,
        nextPageToken: null,
        pagination: {
          nextPageToken: null,
          total: 0,
          pageSize: 0,
          hasMore: false
        }
      };
    }
  }

  /**
   * Global search across all fields for sales correspondence
   * Searches email, applicantId, jobTitle, and status in parallel and merges results
   */
  async globalSearchSales(searchQuery: string, pageSize: 50 | 100 = 50) {
    try {
      console.log(`[Global Search Sales] Searching for "${searchQuery}" across all fields...`);

      // Search all fields in parallel
      const [emailResults, applicantIdResults, jobTitleResults, statusResults] = await Promise.all([
        this.searchSalesFromAPI(searchQuery, 'email', pageSize),
        this.searchSalesFromAPI(searchQuery, 'applicantId', pageSize),
        this.searchSalesFromAPI(searchQuery, 'jobTitle', pageSize),
        this.searchSalesFromAPI(searchQuery, 'status', pageSize)
      ]);

      // Merge all results
      const allCorrespondence = [
        ...emailResults.data,
        ...applicantIdResults.data,
        ...jobTitleResults.data,
        ...statusResults.data
      ];

      // Deduplicate by ID
      const uniqueCorrespondence = Array.from(
        new Map(allCorrespondence.map(item => [item.id, item])).values()
      );

      console.log(`[Global Search Sales] Found ${uniqueCorrespondence.length} unique results (${allCorrespondence.length} total before dedup)`);

      return {
        data: uniqueCorrespondence,
        count: uniqueCorrespondence.length,
        total: uniqueCorrespondence.length,
        nextPageToken: null, // Global search doesn't support pagination
        pagination: {
          nextPageToken: null,
          total: uniqueCorrespondence.length,
          pageSize: uniqueCorrespondence.length,
          hasMore: false
        }
      };

    } catch (error) {
      console.error('[Global Search Sales] Error:', error);
      return {
        data: [],
        count: 0,
        total: 0,
        nextPageToken: null,
        pagination: {
          nextPageToken: null,
          total: 0,
          pageSize: 0,
          hasMore: false
        }
      };
    }
  }

  /**
   * Smart search that maps Kendo Grid column filters to appropriate search fields
   * This is more efficient than global search when user filters specific columns
   */
  async searchMatchesByColumn(columnName: string, searchQuery: string, pageSize: 50 | 100 = 50) {
    // Map Kendo Grid column names to API search fields
    const columnToFieldMap: { [key: string]: 'email' | 'applicantId' | 'jobTitle' | 'date' } = {
      'email': 'email',
      'contactPersonEmail': 'email',
      'applicantId': 'applicantId',
      'position': 'jobTitle',
      'jobTitle': 'jobTitle',
      'company': 'jobTitle',
      'companyName': 'jobTitle',
      'created': 'date',
      'createdDate': 'date',
      'date': 'date'
    };

    const searchField = columnToFieldMap[columnName];

    if (searchField) {
      console.log(`[Smart Search Matches] Column "${columnName}" → Searching field "${searchField}"`);
      return await this.searchMatchesFromAPI(searchQuery, searchField, pageSize);
    } else {
      // Column doesn't map to a searchable field - use global search
      console.log(`[Smart Search Matches] Column "${columnName}" not mapped → Using global search`);
      return await this.globalSearchMatches(searchQuery, pageSize);
    }
  }

  /**
   * Smart search for sales correspondence by column
   */
  async searchSalesByColumn(columnName: string, searchQuery: string, pageSize: 50 | 100 = 50) {
    // Map Kendo Grid column names to API search fields
    const columnToFieldMap: { [key: string]: 'email' | 'applicantId' | 'jobTitle' | 'status' | 'date' } = {
      'email': 'email',
      'contactPersonEmail': 'email',
      'applicantId': 'applicantId',
      'position': 'jobTitle',
      'jobTitle': 'jobTitle',
      'company': 'jobTitle',
      'companyName': 'jobTitle',
      'status': 'status',
      'statusName': 'status',
      'created': 'date',
      'createdDate': 'date',
      'date': 'date'
    };

    const searchField = columnToFieldMap[columnName];

    if (searchField) {
      console.log(`[Smart Search Sales] Column "${columnName}" → Searching field "${searchField}"`);
      return await this.searchSalesFromAPI(searchQuery, searchField, pageSize);
    } else {
      // Column doesn't map to a searchable field - use global search
      console.log(`[Smart Search Sales] Column "${columnName}" not mapped → Using global search`);
      return await this.globalSearchSales(searchQuery, pageSize);
    }
  }

  /**
   * Gets paginated matches - but automatically fetches all pages if no pagination options provided
   * This method maintains the same interface as before but adapts to the new API internally
   * @param options Pagination and filter options
   * @returns Observable with matches (either paginated or all, depending on options)
   */
  getMatchesPaginated(options: any = {}) {
    // If specific pagination is requested, use it
    if (options.paginationToken || options.cursor || options.pageSize || options.page) {
      console.log('Using paginated matches retrieval with provided pagination options');
      return from(this.getApiKey()).pipe(
        switchMap((apiKey) => this.http.post(
          this.API_URL,
          {
            endpoint: 'getMatchesFromDatabaseForPlatform',
            apiKey: apiKey,
            uid: this.authService.returnUserId(),
            platform: 'MONA',
            // Pagination and filter options - updated to match new API
            paginationToken: options.paginationToken || options.cursor || null,
            minScore: options.minScore || 50
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ))
      );
    } else {
      // If no pagination specified, call our method that fetches everything
      // but wrap it in an Observable to maintain the same interface
      console.log('No pagination options provided, fetching all matches');
      return new Observable(observer => {
        this.getMatchesFromAPI()
          .then(result => {
            observer.next(result);
            observer.complete();
          })
          .catch(error => {
            observer.error(error);
          });
      });
    }
  }

  /**
   * Gets matches by timeframe - either paginated or all matches in the timeframe
   * @param options Timeframe and pagination options
   * @returns Observable with matches in specified timeframe
   */
  getMatchesByTimeframe(options: any = {}) {
    // If specific pagination is requested, use it
    if (options.paginationToken || options.cursor || options.pageSize || options.page) {
      console.log('Using paginated timeframe matches retrieval with provided pagination options');
      return from(this.getApiKey()).pipe(
        switchMap((apiKey) => this.http.post(
          this.API_URL,
          {
            endpoint: 'getMatchesByTimeframe',
            apiKey: apiKey,
            uid: this.authService.returnUserId(),
            platform: 'MONA',
            // Date range parameters
            startDate: options.startDate || options.dateFrom || null,
            endDate: options.endDate || options.dateTo || null,
            // Pagination
            paginationToken: options.paginationToken || options.cursor || null,
            // Additional options
            minScore: options.minScore || 50
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ))
      );
    } else {
      // For timeframe queries without pagination, we need to fetch all pages
      // and combine them into one response
      console.log('Fetching all matches within the specified timeframe');

      return new Observable(observer => {
        this.fetchAllTimeframeMatches(options)
          .then(result => {
            observer.next(result);
            observer.complete();
          })
          .catch(error => {
            observer.error(error);
          });
      });
    }
  }

  /**
   * Helper function that fetches all pages for a timeframe query
   * @param options Timeframe options
   * @returns Promise with all matches in the timeframe
   */
  private async fetchAllTimeframeMatches(options: any = {}) {
    let allMatches = [];
    let hasMore = true;
    let nextPageToken = null;
    let totalCount = 0;
    let firstResponse = null;

    try {
      console.log('Starting to fetch all timeframe matches in batches...');
      let batchNumber = 1;
      const apiKey = await this.getApiKey();

      while (hasMore) {
        console.log(`Fetching timeframe batch #${batchNumber}...`);

        const response: any = await this.http.post(
          this.API_URL,
          {
            endpoint: 'getMatchesByTimeframe',
            apiKey: apiKey,
            uid: this.authService.returnUserId(),
            platform: 'MONA',
            startDate: options.startDate || options.dateFrom || null,
            endDate: options.endDate || options.dateTo || null,
            minScore: options.minScore || 50,
            paginationToken: nextPageToken
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ).toPromise();

        // Keep the first response to use its structure
        if (!firstResponse) {
          firstResponse = response;
          totalCount = response?.pagination?.total || 0;
          console.log(`Total timeframe records available: ${totalCount}`);
        }

        // Process the response data
        if (response?.data?.emailsToBeSent && response.data.emailsToBeSent.length > 0) {
          allMatches = [...allMatches, ...response.data.emailsToBeSent];
          console.log(`Timeframe batch #${batchNumber} added ${response.data.emailsToBeSent.length} records. Total fetched: ${allMatches.length}`);

          // Check if there are more pages to fetch
          nextPageToken = response.pagination?.nextPageToken || null;
          hasMore = !!nextPageToken;

          // Safety checks
          if (!hasMore) {
            console.log('No more timeframe pages available.');
          }
          if (allMatches.length >= this.MAX_TOTAL_RECORDS) {
            console.log(`Maximum record limit (${this.MAX_TOTAL_RECORDS}) reached.`);
            hasMore = false;
          }
          if (allMatches.length >= totalCount) {
            console.log('All available timeframe records retrieved.');
            hasMore = false;
          }
        } else {
          console.log('No timeframe matches in this batch or invalid response.');
          hasMore = false;
        }

        batchNumber++;
      }

      // Create a consolidated response with all timeframe matches
      const result = {
        total: totalCount || allMatches.length,
        count: allMatches.length,
        data: { emailsToBeSent: allMatches },
        pagination: {
          nextPageToken: null,
          total: totalCount || allMatches.length,
          hasMore: false
        },
        timeframe: {
          startDate: options.startDate || options.dateFrom || null,
          endDate: options.endDate || options.dateTo || null,
          minScore: options.minScore || 50
        }
      };

      console.log(`Completed fetching all timeframe matches. Total records: ${allMatches.length}`);
      return result;

    } catch (error) {
      console.error('Error fetching timeframe matches:', error);
      throw error;
    }
  }

  /**
   * Gets match insights within a timeframe
   * @param options Timeframe options
   * @returns Observable with match insights
   */
  getMatchesInsights(options: any = {}) {
    return from(this.getApiKey()).pipe(
      switchMap((apiKey) => this.http.post(
        this.API_URL,
        {
          endpoint: 'getMatchesInsights',
          apiKey: apiKey,
          uid: this.authService.returnUserId(),
          platform: 'MONA',
          startDate: options.startDate || options.dateFrom || null,
          endDate: options.endDate || options.dateTo || null
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      ))
    );
  }

  getAllNewAndOldApplicants() {
    const applicants = [];
    return this.app2.firestore
      .collection(FirebaseConstants.applicants).where("created", ">=", new Date("2025-05-01"))
      .get()
      .then((snap) => {
        snap.forEach((doc: any) => {
          const applicant = doc.data();
          applicant.id = doc.id;
          applicants.push(applicant);
        });
        return applicants;
      });
  }

  getAllActiveInterviews() {
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).where("status", "==", "public").get();
  }

  getAllApplicants() {
    const date = new Date("2025-01-01");
    return this.app2.firestore.collection(FirebaseConstants.applicants).where("created", ">=", date).get();
  }

  async getContingentApplicants(timestamp) {
    const applicants = [];
    const activeApplicants = await this.fetchContingentApplicants(
      this.getApplicants(),
      timestamp,
    );
    const deletedApplicants = await this.fetchContingentApplicants(
      this.getDeletedApplicants(),
      timestamp,
    );
    return applicants.concat(activeApplicants, deletedApplicants);
  }

  async fetchContingentApplicants(collection, timestamp) {
    const applicants = [];
    // let date = new Date(timestamp.seconds * 1000)
    // await collection.where('created', '>=', date).get().then((snap) => {
    //   snap.forEach((doc: any) => {
    //     let applicant = doc.data();
    //     applicant.id = doc.id;
    //     applicants.push(applicant);
    //   });
    // });
    return applicants;
  }

  getDeletedApplicants() {
    return this.app2.firestore.collection(FirebaseConstants.deletedApplicants);
  }

  getApplicantProfiles(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.applicantProfile);
  }

  getApplicantProfileDetail(id): firebase.firestore.DocumentReference {
    return this.app2.firestore.collection('applicantProfile').doc(id);
  }

  getPicklistApplicantContracts(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection('kunden');
  }

  createWorkflow(form) {
    return this.app2.firestore.collection(FirebaseConstants.workflows).add({
      name: form.name,
      appliesto: form.appliesto,
      whenthishappens: form.whenthishappens,
      dothis: form.dothis,
      id: form.id,
      receiver: form.receiver,
      calendlyLink: form.calendlyLink || '',
      when: form.when,
      receivers: form.receivers || [],
      created: new Date(),
      createdISO: new Date().toISOString(),
      createdGerman: new Date().toLocaleString('de-DE'),
      // new ones
      workflowSendEmailSubject: form.workflowSendEmailSubject,
      emails: form.emails || [],
      emailText: form.emailText || '',
      smsCountryCode: form.smsCountryCode || '',
      smsPhoneNumbers: form.smsPhoneNumbers || [],
      //added phoneNumber and WhatsappNumber (smsPhoneNumbers when undefined should also be [], maybe change in the future) (31.10.2024)
      callPhoneNumbers: form.callPhoneNumbers || [],
      whatsAppPhoneNumbers: form.whatsAppPhoneNumbers || [],
      smsText: form.smsText || '',
      information: form.information || [],
      dynamicAttachment: form.dynamicAttachment || '',
      workflowSendEmailMessage: form.workflowSendEmailMessage || '',
      customTime: form.customTime || {},
      attachment: form.attachment || '',
      attachmentURL: form.attachmentURL || '',
      document: form.document || '',
      documentURL: form.documentURL || '',
      documentName: form.documentName || '',
      agent: form.agent || '',
      prompt: form.prompt || '',
      status: 'aktiv',
      // superior changes
      lastChosenWorkflow: form.lastChosenWorkflow || '',
      //priority of workflow should be priorityOfWorkflow. If old workflow have some broken things, maybe revert, but think of another way to save this. (31.10.2024)
      // priorityOfWorkflow: form.lastChosenWorkflowDate || "",
      priorityOfWorkflow: form.priorityOfWorkflow || '',
      subWorkflows: form.subWorkflows || [],
      lastChosenWorkflowMatching: form.lastChosenWorkflowMatching || {},
      reminder: form.reminder || {},
    });
  }

  createCommunicationWorkflow(form) {
    // Pre-generate a document ID
    const docRef = this.app2.firestore.collection(FirebaseConstants.workflows).doc();
    const newId = docRef.id;


    const workflowData = {
      id: newId,
      isCommunication: form.isCommunication,
      name: form.name,
      url: form.url
    };

    return docRef.set(workflowData)
      .then(() => {
        console.log("Document successfully written with ID: ", newId);
        return docRef;
      });
  }

  createHybridWorkflow(form) {
    // Pre-generate a document ID for hybrid workflows
    const docRef = this.app2.firestore.collection(FirebaseConstants.workflows).doc();
    const newId = docRef.id;

    console.log('[createHybridWorkflow] Creating workflow with steps:', {
      name: form.name,
      stepsCount: form.steps?.length || 0,
      steps: JSON.stringify(form.steps || []),
      firstStepHasPayload: form.steps?.[0]?.payload ? true : false
    });

    // Build hybrid workflow data structure
    const workflowData = {
      // Core hybrid workflow properties
      id: newId,
      name: form.name,
      description: form.description || '',
      errorHandling: form.errorHandling || 'stop',
      maxRetries: form.maxRetries || 2,
      retryDelay: form.retryDelay || 1000,
      tasks: form.tasks || form.steps || [],
      steps: form.steps || form.tasks || [],
      trigger: form.trigger || { type: 'manual', enabled: true },
      isActive: typeof form.isActive === 'boolean' ? form.isActive : false,

      // Workflow metadata
      workflowType: 'hybrid',
      workflowBuilderVersion: form.workflowBuilderVersion || '2.0',
      created: new Date(),
      createdISO: new Date().toISOString(),
      createdGerman: new Date().toLocaleString('de-DE'),
      status: 'active',

      // Flowchart state for UI reconstruction
      flowchartState: form.flowchartState || {},

      // Agent and connection information
      selectedAgents: form.selectedAgents || [],
      agentConnections: form.agentConnections || [],
      humanInLoopEnabled: form.humanInLoopEnabled || false,
      humanInLoopPhone: form.humanInLoopPhone || '',
      humanInLoopEmail: form.humanInLoopEmail || '',

      // Legacy compatibility properties (for backward compatibility)
      appliesto: form.appliesto || '',
      whenthishappens: form.whenthishappens || '',
      dothis: form.dothis || '',
      receiver: form.receiver || '',
      calendlyLink: form.calendlyLink || '',
      when: form.when || 'immediate',
      receivers: form.receivers || [],
      workflowSendEmailSubject: form.workflowSendEmailSubject || '',
      emails: form.emails || [],
      emailText: form.emailText || '',
      smsCountryCode: form.smsCountryCode || '+49',
      smsPhoneNumbers: form.smsPhoneNumbers || [],
      callPhoneNumbers: form.callPhoneNumbers || [],
      whatsAppPhoneNumbers: form.whatsAppPhoneNumbers || [],
      smsText: form.smsText || '',
      information: form.information || [],
      dynamicAttachment: form.dynamicAttachment || '',
      workflowSendEmailMessage: form.workflowSendEmailMessage || '',
      customTime: form.customTime || {},
      attachment: form.attachment || '',
      attachmentURL: form.attachmentURL || '',
      document: form.document || '',
      documentURL: form.documentURL || '',
      documentName: form.documentName || '',
      agent: form.agent || '',
      prompt: form.prompt || '',
      priorityOfWorkflow: form.priorityOfWorkflow || 'medium',
      subWorkflows: form.subWorkflows || [],
      lastChosenWorkflowMatching: form.lastChosenWorkflowMatching || {},
      reminder: form.reminder || {}
    };

    return docRef.set(workflowData)
      .then(() => {
        console.log("Hybrid workflow successfully created with ID: ", newId);
        return { id: newId, ...workflowData };
      })
      .catch((error) => {
        console.error("Error creating hybrid workflow: ", error);
        throw error;
      });
  }

  getHybridWorkflows(): firebase.firestore.CollectionReference {
    // Simple collection reference - filtering and sorting done client-side
    return this.app2.firestore.collection(FirebaseConstants.workflows);
  }

  getLegacyWorkflows(): firebase.firestore.CollectionReference {
    // Simple collection reference - filtering and sorting done client-side
    return this.app2.firestore.collection(FirebaseConstants.workflows);
  }

  getAllWorkflowsWithType(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.workflows);
  }

  updateHybridWorkflow(workflowId: string, updates: any) {
    return this.app2.firestore
      .collection(FirebaseConstants.workflows)
      .doc(workflowId)
      .update({
        ...updates,
        lastModified: new Date(),
        lastModifiedISO: new Date().toISOString(),
        lastModifiedGerman: new Date().toLocaleString('de-DE')
      });
  }

  isLeffer(): boolean {
    //CustomerNumber 1011 is Leffer
    //Checking the customerNumber because at the moment just Leffer has RecruitmentTests (11 May 2023)
    if (this.customerNumber === 1011) {
      return true;
    }
    return false;
  }

  // Process Manager Entity Methods
  async saveProcessManagerConfiguration(config: any) {
    const docRef = this.app2.firestore.collection('process_manager').doc(config.id || this.app2.firestore.collection('process_manager').doc().id);
    const processData = {
      id: docRef.id,
      name: config.name || 'Process Configuration',
      type: 'process_configuration',
      company: config.company || null,
      departments: config.departments || [],
      divisions: config.divisions || [],
      teams: config.teams || [],
      people: config.people || [],
      workflowId: config.workflowId || null,
      created: new Date(),
      createdISO: new Date().toISOString(),
      lastModified: new Date(),
      lastModifiedISO: new Date().toISOString(),
      createdBy: this.getUserEmail() || '',
      status: 'active'
    };

    return docRef.set(processData)
      .then(() => {
        console.log("Process Manager configuration saved with ID: ", docRef.id);
        return { id: docRef.id, ...processData };
      })
      .catch((error) => {
        console.error("Error saving process configuration: ", error);
        throw error;
      });
  }

  async updateProcessManagerConfiguration(configId: string, updates: any) {
    return this.app2.firestore
      .collection('process_manager')
      .doc(configId)
      .update({
        ...updates,
        lastModified: new Date(),
        lastModifiedISO: new Date().toISOString()
      });
  }

  getProcessManagerConfigurations() {
    return this.app2.firestore.collection('process_manager');
  }

  getProcessManagerConfiguration(configId: string) {
    return this.app2.firestore.collection('process_manager').doc(configId);
  }

  async deleteProcessManagerConfiguration(configId: string) {
    return this.app2.firestore.collection('process_manager').doc(configId).delete();
  }

  // Save individual process entities
  async saveProcessEntity(entityType: string, entityData: any) {
    const collectionName = `process_${entityType}`;
    const docRef = this.app2.firestore.collection(collectionName).doc(entityData.id || this.app2.firestore.collection(collectionName).doc().id);

    // Clean up undefined values that Firebase doesn't accept
    const cleanData = Object.entries(entityData).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {} as any);

    const data = {
      ...cleanData,
      id: docRef.id,
      entityType: entityType,
      created: cleanData.created || new Date(),
      createdISO: cleanData.createdISO || new Date().toISOString(),
      lastModified: new Date(),
      lastModifiedISO: new Date().toISOString(),
      createdBy: this.getUserEmail() || ''
    };

    return docRef.set(data)
      .then(() => {
        console.log(`Process entity ${entityType} saved with ID: ${docRef.id}`);
        return { id: docRef.id, ...data };
      })
      .catch((error) => {
        console.error(`Error saving process entity ${entityType}: `, error);
        throw error;
      });
  }

  async getProcessEntities(entityType: string) {
    return this.app2.firestore.collection(`process_${entityType}`);
  }

  async saveProcessEntitiesBatch(processConfig: any) {
    if (!this.app2 || !this.app2.firestore) {
      console.error('[BatchWrite] app2 or firestore not initialized');
      throw new Error('Database not initialized');
    }

    let batch = this.app2.firestore.batch();
    const userEmail = this.getUserEmail() || '';
    const now = new Date();
    const nowISO = now.toISOString();
    let operationCount = 0;
    let totalOperations = 0;
    const maxBatchSize = 500;

    const cleanData = (data: any): any => {
      if (data === null || data === undefined) {
        return null;
      }
      if (Array.isArray(data)) {
        return data.filter(item => item !== undefined && item !== null).map(item => cleanData(item));
      }
      if (typeof data === 'object' && !(data instanceof Date)) {
        return Object.entries(data).reduce((acc, [key, value]) => {
          if (value !== undefined) {
            const cleaned = cleanData(value);
            if (cleaned !== undefined) {
              acc[key] = cleaned;
            }
          }
          return acc;
        }, {} as any);
      }
      return data;
    };

    const prepareEntityData = (entityData: any, entityType: string) => {
      const clean = cleanData(entityData);
      return {
        ...clean,
        id: clean.id || this.app2.firestore.collection(`process_${entityType}`).doc().id,
        entityType: entityType,
        created: clean.created || now,
        createdISO: clean.createdISO || nowISO,
        lastModified: now,
        lastModifiedISO: nowISO,
        createdBy: clean.createdBy || userEmail
      };
    };

    if (processConfig.company) {
      const companyData = prepareEntityData(processConfig.company, 'company');
      const companyRef = this.app2.firestore.collection('process_company').doc(companyData.id);
      batch.set(companyRef, companyData);
      operationCount++;
    }

    if (processConfig.departments && processConfig.departments.length > 0) {
      for (const dept of processConfig.departments) {
        if (operationCount >= maxBatchSize) {
          await batch.commit();
          totalOperations += operationCount;
          batch = this.app2.firestore.batch();
          operationCount = 0;
        }
        const deptData = prepareEntityData(dept, 'department');
        const deptRef = this.app2.firestore.collection('process_department').doc(deptData.id);
        batch.set(deptRef, deptData);
        operationCount++;
      }
    }

    if (processConfig.divisions && processConfig.divisions.length > 0) {
      for (const division of processConfig.divisions) {
        if (operationCount >= maxBatchSize) {
          await batch.commit();
          totalOperations += operationCount;
          batch = this.app2.firestore.batch();
          operationCount = 0;
        }
        const divisionData = prepareEntityData(division, 'division');
        const divisionRef = this.app2.firestore.collection('process_division').doc(divisionData.id);
        batch.set(divisionRef, divisionData);
        operationCount++;
      }
    }

    if (processConfig.teams && processConfig.teams.length > 0) {
      for (const team of processConfig.teams) {
        if (operationCount >= maxBatchSize) {
          await batch.commit();
          totalOperations += operationCount;
          batch = this.app2.firestore.batch();
          operationCount = 0;
        }
        const teamData = prepareEntityData(team, 'team');
        const teamRef = this.app2.firestore.collection('process_team').doc(teamData.id);
        batch.set(teamRef, teamData);
        operationCount++;
      }
    }

    if (processConfig.people && processConfig.people.length > 0) {
      for (const person of processConfig.people) {
        if (operationCount >= maxBatchSize) {
          await batch.commit();
          totalOperations += operationCount;
          batch = this.app2.firestore.batch();
          operationCount = 0;
        }
        const personData = prepareEntityData(person, 'person');
        const personRef = this.app2.firestore.collection('process_person').doc(personData.id);
        batch.set(personRef, personData);
        operationCount++;
      }
    }

    if (processConfig.locations && processConfig.locations.length > 0) {
      for (const location of processConfig.locations) {
        if (operationCount >= maxBatchSize) {
          await batch.commit();
          totalOperations += operationCount;
          batch = this.app2.firestore.batch();
          operationCount = 0;
        }
        const locationData = prepareEntityData(location, 'location');
        const locationRef = this.app2.firestore.collection('process_location').doc(locationData.id);
        batch.set(locationRef, locationData);
        operationCount++;
      }
    }

    if (operationCount > 0) {
      await batch.commit();
      totalOperations += operationCount;
    }

    console.log(`[BatchWrite] Saved ${totalOperations} entities in ${Math.ceil(totalOperations / maxBatchSize)} batch(es)`);
  }

  async updateProcessEntity(entityType: string, entityId: string, updates: any) {
    return this.app2.firestore
      .collection(`process_${entityType}`)
      .doc(entityId)
      .update({
        ...updates,
        lastModified: new Date(),
        lastModifiedISO: new Date().toISOString()
      });
  }

  async deleteProcessEntity(entityType: string, entityId: string) {
    return this.app2.firestore.collection(`process_${entityType}`).doc(entityId).delete();
  }

  async clearAllProcessEntities() {
    const entityTypes = ['company', 'location', 'department', 'division', 'team', 'person'];
    let totalDeleted = 0;
    
    for (const entityType of entityTypes) {
      const collectionRef = this.app2.firestore.collection(`process_${entityType}`);
      const snapshot = await collectionRef.get();
      
      if (!snapshot.empty) {
        const batch = this.app2.firestore.batch();
        let count = 0;
        
        for (const doc of snapshot.docs) {
          batch.delete(doc.ref);
          count++;
          
          if (count >= 500) {
            await batch.commit();
            totalDeleted += count;
            count = 0;
          }
        }
        
        if (count > 0) {
          await batch.commit();
          totalDeleted += count;
        }
      }
    }
    
    console.log(`[clearAllProcessEntities] Deleted ${totalDeleted} entities from global collections`);
    return totalDeleted;
  }

  // Enhanced hybrid workflow creation with process manager data
  createHybridWorkflowWithProcessManager(form: any, processConfig?: any) {
    const docRef = this.app2.firestore.collection(FirebaseConstants.workflows).doc();
    const newId = docRef.id;

    const workflowData = {
      id: newId,
      name: form.name,
      description: form.description || '',
      errorHandling: form.errorHandling || 'stop',
      maxRetries: form.maxRetries || 2,
      retryDelay: form.retryDelay || 1000,
      tasks: form.tasks || [],

      // Process Manager data
      processManagerConfig: processConfig || null,
      processManagerEnabled: !!processConfig,

      workflowType: 'hybrid',
      workflowBuilderVersion: form.workflowBuilderVersion || '2.0',
      created: new Date(),
      createdISO: new Date().toISOString(),
      createdGerman: new Date().toLocaleString('de-DE'),
      status: 'active',

      flowchartState: form.flowchartState || {},
      selectedAgents: form.selectedAgents || [],
      agentConnections: form.agentConnections || [],
      humanInLoopEnabled: form.humanInLoopEnabled || false,
      humanInLoopPhone: form.humanInLoopPhone || '',
      humanInLoopEmail: form.humanInLoopEmail || '',

      // Legacy compatibility properties
      appliesto: form.appliesto || '',
      whenthishappens: form.whenthishappens || '',
      dothis: form.dothis || '',
      receiver: form.receiver || '',
      calendlyLink: form.calendlyLink || '',
      when: form.when || 'immediate',
      receivers: form.receivers || [],
      workflowSendEmailSubject: form.workflowSendEmailSubject || '',
      emails: form.emails || [],
      emailText: form.emailText || '',
      smsCountryCode: form.smsCountryCode || '+49',
      smsPhoneNumbers: form.smsPhoneNumbers || [],
      callPhoneNumbers: form.callPhoneNumbers || [],
      whatsAppPhoneNumbers: form.whatsAppPhoneNumbers || [],
      smsText: form.smsText || '',
      information: form.information || [],
      dynamicAttachment: form.dynamicAttachment || '',
      workflowSendEmailMessage: form.workflowSendEmailMessage || '',
      customTime: form.customTime || {},
      attachment: form.attachment || '',
      attachmentURL: form.attachmentURL || '',
      document: form.document || '',
      documentURL: form.documentURL || '',
      documentName: form.documentName || '',
      agent: form.agent || '',
      prompt: form.prompt || '',
      priorityOfWorkflow: form.priorityOfWorkflow || 'medium',
      subWorkflows: form.subWorkflows || [],
      lastChosenWorkflowMatching: form.lastChosenWorkflowMatching || {},
      reminder: form.reminder || {}
    };

    return docRef.set(workflowData)
      .then(() => {
        console.log("Hybrid workflow with Process Manager successfully created with ID: ", newId);
        return { id: newId, ...workflowData };
      })
      .catch((error) => {
        console.error("Error creating hybrid workflow with Process Manager: ", error);
        throw error;
      });
  }

  updateCommunicationWorkflow(form) {
    return this.app2.firestore.collection(FirebaseConstants.workflows).doc(form.id).update({
      name: form.name,
      url: form.url
    });
  }

  async createDeletedJobOffer(id, data) {

    //for old versions, the flowchart is on the job offer document itself.
    //to make it easy, we move it first to flowchart sub collections
    //then continue the process.
    await this.processFlowchartsToDatabase(id, data.flowcharts);

    //find the flowchart collection and move it as well if needed.
    const flowchartCollection = this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).collection(FirebaseConstants.flowcharts);
    const flowcharts = [];
    const snapshot = await flowchartCollection.get();
    snapshot.forEach((doc) => {
      flowcharts.push({ id: doc.id, data: doc.data() });
      this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).collection(FirebaseConstants.flowcharts).doc(doc.id).delete();
    });

    return this.app2.firestore
      .collection(FirebaseConstants.deletedJobOffers)
      .doc(id)
      .set(data).then(() => {
        //adding flowcharts here.
        flowcharts.forEach((flowchart) => {
          this.app2.firestore.collection(FirebaseConstants.deletedJobOffers)
            .doc(id)
            .collection('flowcharts')
            .doc(flowchart.id)
            .set(flowchart.data)
        })
      });
  }

  getLast1000Applicants() {
    return this.app2.firestore.collection(FirebaseConstants.applicants).orderBy('created', 'desc').limit(1000).get();
  }

  getToolCallings() {
    return this.app2.firestore.collection('tool_calling').orderBy('timestamp', 'desc').limit(1000).get();
  }

  getEmailsFromCollection() {
    return this.app2.firestore.collection("emails").orderBy('created', 'desc').limit(1000).get();
  }

  getMoreApplicants() {
    return this.app2.firestore.collection(FirebaseConstants.applicants).orderBy('created', 'desc').limit(70).get();
  }

  createJobOffer(form) {
    // flowcharts subcollection = additional (e.g. location) flowcharts only; general flowchart is in job offer doc (conditionalWorkflow). Empty array is valid.
    form.flowcharts = Array.isArray(form.flowcharts) ? form.flowcharts : [];
    this.changeFlowchartStructure(form);
    console.log('saving data job offer.')
    const date = this.getActualDate();
    console.log(form);
    const colRef = this.app2.firestore.collection(FirebaseConstants.jobOffers);
    return colRef.add({
      jobTitle: form.jobTitle || '',
      introduction: form.introduction || '',
      tasks: form.tasks || '',
      qualifications: form.qualifications || '',
      benefits: form.benefits || '',
      closingwords: form.closingwords || '',
      money: form.money || '',
      education: form.education || '',
      experience: form.experience || '',
      employment: form.employment || '',
      careerLevel: form.careerLevel || '',
      jobCategory: form.jobCategory || '',
      applicationForm: form.applicationForm || '',
      employmentType: form.employmentType || '',
      applicationTime: form.applicationTime || '',
      country: form.country || '',
      public: form.public,
      city: form.city || '',
      assessmentTestTitle: form.assessmentTestTitle || '',
      uploadLogo: form.uploadLogo || '',
      selectedFont: form.selectedFont || 'Manrope',
      selectedHeaderColor: form.selectedHeaderColor || '',
      selectedBodyColor: form.selectedBodyColor || '',
      selectedCompanyTitle: form.selectedCompanyTitle || '#ffffff',
      creationDate: date || '',
      documents: form.documents || [],
      isFromFirebase: true,
      avatar: form.avatar || {},
      languages: form.languages || [],
      messages: form.messages || [],
      conditionalWorkflow: form.conditionalWorkflow || {},
      //flowcharts: form.flowcharts || [],
      isAutomaticApplication: form.isAutomaticApplication || false,
      isAutomaticContract: form.isAutomaticContract || false,
      isAutomaticVoice: form.isAutomaticVoice || false,
      isAutomaticCV: form.isAutomaticCV || false,
      isFeedback: form.isFeedback || true,
      sharable: form.sharable || false,
      codingChallenge: form.codingChallenge || [],
      status: form.status || '',
      created: new Date(),
      updated: new Date(),
      qnaPairs: form.qnaPairs || [],
      testmode: form.testmode || false,
      dfcxAgent: form.dfcxAgent || '',
      isFastApplication: form.isFastApplication,
      isDetailedApplication: form.isDetailedApplication,
      isAutomaticRecruitmentTest: form.isAutomaticRecruitmentTest || false,
      isQandAAllowed: form.isQandAAllowed || false,
      isForcedLanguage: form.isForcedLanguage || false,
      useAIQuestions: form.useAIQuestions || false,
      goals: form.goals || [],
      exploreCulturalFit: form.exploreCulturalFit || false,
      exploreTechnicalFit: form.exploreTechnicalFit || false,
      'text-only': (form['text-only'] ?? form.textOnly ?? false),
      aiPersonality: form.aiPersonality || '',
      defaultJobOfferLanguage: form.defaultJobOfferLanguage || '',
      // locationName nur persistieren, wenn ein spezifischer Standort gewählt wurde.
      // "all" bedeutet: kein Feld setzen -> Standort bleibt undefined.
      ...(form.locationName && form.locationName !== 'all' ? { locationName: form.locationName } : {}),
    }).then(async (docRef) => {
      console.log(docRef.id);
      let id = docRef.id;
      this.processFlowchartsToDatabase(id, form.flowcharts);

      return id;
    });
  }

  createZvooveJob(job) {
    const domParser = new DOMParser();
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).add({
      applicationForm: 'Deutsch',
      applicationTime: '',
      avatar: {
        avatarId: 'anna_costume1_cameraA',
        avatarName: 'MONA',
        name: 'Anna',
        toggle: true,
      },
      benefits:
        domParser.parseFromString(job.Perspektiven, 'text/html').body
          .textContent || '',
      careerLevel: '',
      city: job.EinsatzortOrt || '',
      closingWords: '',
      codingChallenge: [],
      conditionalWorkflow: job.conditionalWorkflow,
      country: '',
      created: new Date(),
      dfcxAgent: '',
      documents: {},
      education: '',
      employment: '',
      employmentType: '',
      experience: '',
      introduction:
        domParser.parseFromString(job.Arbeitgebervorstellung, 'text/html').body
          .textContent || '',
      isAutomaticApplication: true,
      isAutonaticCV: false,
      isAutomaticContract: false,
      isAutomaticRecruitmentTest: false,
      isAutomaticVoice: false,
      isDetailedApplication: false,
      isFastApplication: false,
      isQandAAllowed: false,
      isForcedLanguage: false,
      jobCategory: '',
      jobTitle:
        domParser.parseFromString(job.BezeichnungAusschreibung, 'text/html')
          .body.textContent || '',
      languages: [{ language: 'deutsch', toggle: true }],
      messages: job.messages,
      money: '',
      public: true,
      qnaPairs: [],
      qualifications:
        domParser.parseFromString(job.FachlicheAnforderungen, 'text/html').body
          .textContent || '',
      status: 'aktiv',
      tasks:
        domParser.parseFromString(job.Aufgaben, 'text/html').body.textContent ||
        '',
      updated: new Date(),
    });
  }

  archiveJobOffer(id) {
    return this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .update({
        status: 'archiviert',
      });
  }
  templateJobOffer(id) {
    return this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .update({
        status: 'template',
      });
  }

  updateExternalIdForJobOffer(externalId, id) {
    return this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .update({
        externalId: externalId,
      });
  }

  updatejobOfferInformationAI(id, form) {
    return this.app2.firestore
      .collection('indexstellenanzeigen')
      .doc(id)
      .update({
        AIFeedback: form,
        status: 'AI',
      });
  }

  updateJobOfferApplicantsToZero(id: string) {
    this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).update({
      applicants: [],
    });
  }

  async ReactivateJobOffer(id, form) {
    const res = (await this.getDeletedJobOffersDetail(id).get()).data();
    //get the flowcharts collection as well if needed.
    const flowchartCollection = this.app2.firestore
      .collection(FirebaseConstants.deletedJobOffers)
      .doc(id)
      .collection('flowcharts');
    const flowcharts = [];
    const snapshot = await flowchartCollection.get()
    snapshot.forEach((doc) => {
      flowcharts.push({ id: doc.id, data: doc.data() });
    });
    console.log(res);
    await this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .set(res);

    form.flowcharts = flowcharts.map(flowchart => flowchart.data);
    //flowchart is updated on the function below as well
    await this.updateJobOffer(id, form);

    await this.app2.firestore
      .collection(FirebaseConstants.deletedJobOffers)
      .doc(id)
      .delete();
    flowcharts.forEach(async (flowchart) => {
      await this.app2.firestore
        .collection(FirebaseConstants.deletedJobOffers)
        .doc(id)
        .collection('flowcharts')
        .doc(flowchart.id)
        .delete();
    });
  }

  //the flowchart from JobOfferInfo n newJobOffer has .label value and .text as the text.
  //we change it here. 
  //beware that the template does not have .text value, so we keep the .label in that case.
  changeNodesLabelToText(nodes) {
    if (!nodes || nodes.length === 0) return;
    for (let node of nodes) {
      node.label = node.text ?? node.label;
      delete node.text;
    }
  }
  changeFlowchartStructure(form) {
    this.changeNodesLabelToText(form?.conditionalWorkflow?.nodes);
    const otherFlowcharts = form?.flowcharts?.map((flowchart) => flowchart?.flowchart);
    if (!otherFlowcharts || otherFlowcharts.length === 0) return;
    for (let flowchart of otherFlowcharts) {
      this.changeNodesLabelToText(flowchart?.messageNodes);
    }
  }

  async updateJobOffer(id, form) {
    if (!id) return;
    // flowcharts subcollection = additional flowcharts only; general is in job offer doc. Empty array is valid.
    form.flowcharts = Array.isArray(form.flowcharts) ? form.flowcharts : [];
    this.changeFlowchartStructure(form);

    console.log('updating data job offer.', form);
    const date = this.getActualDate();
    await this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(id)
      .update({
        jobTitle: form.jobTitle || '',
        introduction: form.introduction || '',
        tasks: form.tasks || '',
        qualifications: form.qualifications || '',
        benefits: form.benefits || '',
        closingwords: form.closingwords || '',
        money: form.money || '',
        education: form.education || '',
        experience: form.experience || '',
        employment: form.employment || '',
        careerLevel: form.careerLevel || '',
        jobCategory: form.jobCategory || '',
        applicationForm: form.applicationForm || '',
        employmentType: form.employmentType || '',
        applicationTime: form.applicationTime || '',
        country: form.country || '',
        public: form.public || '',
        testmode: form.testmode || false,
        city: form.city || '',
        assessmentTestTitle: form.assessmentTestTitle || '',
        uploadLogo: form.uploadLogo || '',
        selectedFont: form.selectedFont || 'Manrope',
        selectedHeaderColor: form.selectedHeaderColor || '',
        selectedBodyColor: form.selectedBodyColor || '',
        selectedCompanyTitle: form.selectedCompanyTitle || '#ffffff',
        creationDate: date || '',
        documents: form.documents || [],
        languages: form.languages || [],
        avatar: form.avatar || {},
        goals: form.goals || [],
        messages: form.messages || [],
        conditionalWorkflow: form.conditionalWorkflow || {},
        flowcharts: [],
        status: form.status,
        qnaPairs: form.qnaPairs || [],
        dfcxAgent: form.dfcxAgent || '',
        isAutomaticApplication: form.isAutomaticApplication || false,
        isAutomaticContract: form.isAutomaticContract || false,
        isAutomaticVoice: form.isAutomaticVoice || false,
        isAutomaticCV: form.isAutomaticCV || false,
        isAutomaticRecruitmentTest: form.isAutomaticRecruitmentTest || false,
        isQandAAllowed: form.isQandAAllowed || false,
        isForcedLanguage: form.isForcedLanguage || false,
        useAIQuestions: form.useAIQuestions || false,
        exploreCulturalFit: form.exploreCulturalFit || false,
        exploreTechnicalFit: form.exploreTechnicalFit || false,
        'text-only': (form['text-only'] ?? form.textOnly ?? false),
        aiPersonality: form.aiPersonality || '',
        isFeedback: form.isFeedback || false,
        sharable: form.sharable || false,
        codingChallenge: form.codingChallenge || [],
        updated: new Date(),
        defaultJobOfferLanguage: form.defaultJobOfferLanguage || '',
        // locationName: spezifischer Standort -> schreiben, "all"/leer -> Feld entfernen.
        locationName: (form.locationName && form.locationName !== 'all')
          ? form.locationName
          : firebase.firestore.FieldValue.delete(),
      });

    this.processFlowchartsToDatabase(id, form.flowcharts);
  }

  async processFlowchartsToDatabase(jobOfferId, flowcharts) {
    const flowchartsList = Array.isArray(flowcharts) ? flowcharts : [];
    let colRef = await this.app2.firestore
      .collection(FirebaseConstants.jobOffers)
      .doc(jobOfferId).collection(FirebaseConstants.flowcharts).get();
    let databaseLocations = [];
    let docRef = colRef.docs;

    if (docRef != undefined && docRef.length > 0) {
      for (let doc of docRef) {
        let data = doc.data();
        if (data && data.location) {
          let location = data.location;
          if (location) {
            databaseLocations.push({ location: location, id: doc.id });
          }
        }
      }
    }

    const flowchartLocations = flowchartsList.map(f => f.location?.name).filter(Boolean);

    // add flowcharts that are not in the database or update flowcharts that are in the database
    for (const location of flowchartLocations) {
      const flowchart = flowchartsList.find(f => f.location?.name === location);
      if (!flowchart) continue;
      const dbLoc = databaseLocations.find(d => d.location?.name === location);
      if (!dbLoc) {
        await this.app2.firestore
          .collection(FirebaseConstants.jobOffers)
          .doc(jobOfferId)
          .collection(FirebaseConstants.flowcharts)
          .add(flowchart);
      } else {
        await this.app2.firestore
          .collection(FirebaseConstants.jobOffers)
          .doc(jobOfferId)
          .collection(FirebaseConstants.flowcharts)
          .doc(dbLoc.id)
          .update(flowchart);
      }
    }

    // delete flowcharts that are not in the flowcharts array
    const locations = flowchartLocations;
    this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(jobOfferId).collection(FirebaseConstants.flowcharts).get().then((snap) => {
      snap.forEach((doc: any) => {
        let data = doc.data();
        if (data) {
          let loc = data.location;
          if (loc) {
            let locName = loc.name;
            if (locName) {
              if (!locations.includes(locName)) {
                doc.ref.delete();
              }
            }
          }
        }
      });
    });
  }

  // async setAutoSaveFlowchart(id, form) {
  //   return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).set({
  //     autoSaveConditionalWorkflow: form.conditionalWorkflow || {},
  //     autoSaveFlowcharts: form.flowcharts || [],
  //   });
  // }

  // async updateAutoSaveFlowchart(id, form) {
  //   console.log("updateAutoSaveFlowchart", form.conditionalWorkflow, form.flowcharts);
  //   return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).update({
  //     autoSaveConditionalWorkflow: form.conditionalWorkflow || {},
  //     autoSaveFlowcharts: form.flowcharts || []
  //   });
  // }

  // async updateAutoSaveMessages(id, form, isAutomaticCV, messageNodes) {
  //   console.log(form, messageNodes);
  //   let autoSaveMessages = form.messages || [];

  //   if (isAutomaticCV) {
  //     autoSaveMessages = autoSaveMessages.filter((message) => {
  //       return message.value !== 'Danke' && message.value !== 'Sprache' && message.value !== 'Ende' && message.value !== 'Vertrag' && message.value !== 'Q&A';
  //     });
  //   }
  //   else {
  //     autoSaveMessages = autoSaveMessages.filter((message) => {
  //       return message.value !== 'Danke' && message.value !== 'Sprache' && message.value !== 'Ende' && message.value !== 'Vertrag' && message.value !== 'Q&A' && message.value !== 'CV Upload';
  //     });
  //   }

  //   const refMessages = [];
  //   autoSaveMessages.forEach((message) => {
  //     refMessages.push(message);
  //   });
  //   autoSaveMessages = []
  //   refMessages.forEach((messageNode) => {

  //     if (messageNode.label != "End Session" && messageNode.label != "Start") {
  //       const message = refMessages.filter(msg => msg.parameterMap['deutsch'] == messageNode.parameterMap['deutsch'] || msg.languageMap['deutsch'] == messageNode.languageMap['deutsch']);
  //       if (message) {
  //         //do the loop slower to get easily readable messages (similar to messages[]). If this is slow, please change it
  //         const messageWithCorrectLang = message.find(msg => msg.language === messageNode.language)
  //         autoSaveMessages.push(messageWithCorrectLang);
  //       }
  //       else {
  //         console.log("!!!!!!!!!!!!!!!!can not find message", messageNode);
  //         const message2 = messageNodes.find(msg => msg.parameterMap['deutsch'] == messageNode.parameterMap['deutsch'] || msg.languageMap['deutsch'] == messageNode.languageMap['deutsch']);
  //         if (message2) {
  //           autoSaveMessages.push(message2);
  //         }
  //         else {
  //           console.log("!!!!!!!!!!!!!!!!can not find message", messageNode);
  //         }
  //       }
  //     }
  //   });

  //   console.log("autoSaveMessages", autoSaveMessages);

  //   let transferMessageNodes = [];
  //   messageNodes.forEach((messageNode) => {
  //     if (messageNode.rightMessage.value) {

  //     }
  //     else {
  //       messageNode.rightMessage.value = "";
  //     }

  //     if (messageNode.standAlone) {

  //     }
  //     else {
  //       messageNode.standAlone = false;
  //     }

  //     transferMessageNodes.push({

  //       data: messageNode.data,
  //       dimension: messageNode.dimension,
  //       filtered: messageNode.filtered,
  //       id: messageNode.id,
  //       inPoint: messageNode.inPoint,
  //       label: messageNode.label,
  //       languageMap: messageNode.languageMap,
  //       meta: messageNode.meta,
  //       outPoint: messageNode.outPoint,
  //       parameterMap: messageNode.parameterMap,
  //       position: messageNode.position,
  //       rightMessage: messageNode.rightMessage,
  //       shape: messageNode.shape,
  //       standAlone: messageNode.standAlone,
  //       status: messageNode.status,
  //       text: messageNode.text,
  //       transform: messageNode.transform,
  //       visible: messageNode.visible
  //     });


  //   });



  //   console.log("autoSaveMessageNodes", transferMessageNodes);

  //   return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).update({
  //     autoSaveMessages: autoSaveMessages || [],
  //     autoSaveMessageNodes: transferMessageNodes || [],
  //   });
  // }

  async getAutoSaveFlowchart(id) {
    return this.app2.firestore.collection(FirebaseConstants.jobOffers).doc(id).get();
  }

  private getActualDate() {
    const date = new Date();
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const today = dd + '.' + mm + '.' + yyyy;
    return today;
  }

  getContracts(): firebase.firestore.CollectionReference {
    if (!this.isDatabaseReady()) {
      console.warn('getContracts called before database was ready');
      return null;
    }
    return this.app2.firestore.collection(FirebaseConstants.contracts);
  }

  getContract(id): firebase.firestore.DocumentReference {
    if (!this.isDatabaseReady()) {
      console.warn('getContract called before database was ready');
      return null;
    }
    return this.app2.firestore.collection(FirebaseConstants.contracts).doc(id);
  }

  getContractyName(name) {
    if (!this.isDatabaseReady()) {
      console.warn('getContractyName called before database was ready');
      return null;
    }
    return this.app2.firestore
      .collection(FirebaseConstants.contracts)
      .where('name', '==', name);
  }

  getContractSrc(name) {
    const storageRef = this.storage.ref(name);
    return storageRef.getDownloadURL().toPromise();
  }

  getNewContractId() {
    return this.newContractId;
  }

  async deleteContract(id) {
    this.getContract(id)
      .get()
      .then((snap) => {
        const filepath = snap.data().downloadURL;
        this.storage.storage.refFromURL(filepath).delete();
      })
      .then(() => {
        this.getContract(id)
          .delete()
          .then(() => {
            console.log('deleted');
          });
      });
  }

  async downloadContract(filename, id) {
    await this.getContract(id)
      .get()
      .then((snap) => {
        const filepath = snap.data().downloadURL;
        this.http.get(filepath, { responseType: 'blob' }).subscribe((res) => {
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(res);
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        });
      });
  }

  deleteApplicantFile(downloadURL, applicantId) {
    this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(applicantId)
      .get()
      .then((snap) => {
        const data = snap.data();
        const files = data.files;
        const newFiles = [];
        files.forEach((file) => {
          if (file.downloadURL != downloadURL) {
            newFiles.push(file);
          }
        });
        this.storage.storage.refFromURL(downloadURL).delete();
        this.app2.firestore
          .collection(FirebaseConstants.applicants)
          .doc(applicantId)
          .update({ files: newFiles });
      });
  }

  storeFilesFirebase(
    image,
    collection: string,
    documentId?: string,
    type?: string,
  ) {
    if (documentId) {
      const files = this.getApplicantFiles(documentId);
      files.then((snap) => {
        const f = [];
        if (snap) {
          if (type) {
            snap.push({
              createdISO: image.createdISO,
              name: image.name,
              downloadURL: image.downloadURL,
              type: type,
            });
          } else {
            snap.push({
              createdISO: image.createdISO,
              name: image.name,
              downloadURL: image.downloadURL,
            });
          }
          // f.push({
          //   createdISO: image.createdISO,
          //   name: image.name,
          //   downloadURL: image.downloadURL
          // })
          this.app2.firestore.collection(collection).doc(documentId).update({
            files: snap,
          });
        } else {
          if (type) {
            f.push({
              createdISO: image.createdISO,
              name: image.name,
              downloadURL: image.downloadURL,
              type: type,
            });
          } else {
            f.push({
              createdISO: image.createdISO,
              name: image.name,
              downloadURL: image.downloadURL,
            });
          }
          this.app2.collection(collection).doc(documentId).update({
            files: f,
          });
        }
      });
    } else {
      this.app2.firestore
        .collection(collection)
        .add(image)
        .then((res) => {
          this.newContractId = res.id;
        })
        .catch((err) => {
          console.log('error', err);
        });
    }
  }

  storeAICVFeedback(feedback) {
    this.app2.collection(FirebaseConstants.aiCVFeedback).add({
      feedback: feedback,
      created: new Date(),
    });
  }

  storeAICVFeedbackForMatching(id, feedback) {
    this.app2
      .collection(FirebaseConstants.applicants)
      .doc(id)
      .update({
        feedbackForMatching: feedback,
        created: new Date(),
        isFeedbackForMatching: true,
        createdISODate: new Date().toISOString(),
        createdISO: new Date().toISOString().slice(0, 10),
      });
  }

  getImageRef(fileStoragePath) {
    return this.storage.ref(fileStoragePath);
  }

  getCustomerImageRef(fileStoragePath) {
    return this.customerStorage.ref(fileStoragePath);
  }

  async getGeneratedFileDownloadUrl(bucket: string, blob: string): Promise<string | null> {
    const resolved = await this.resolveGeneratedFileDownload(bucket, blob);
    return resolved.url;
  }

  // Same lookup as getGeneratedFileDownloadUrl, but keeps the Storage SDK code so callers can
  // tell a missing object from a 403 or a timeout instead of treating every empty URL the same.
  async resolveGeneratedFileDownload(bucket: string, blob: string): Promise<{ url: string | null; code: string }> {
    try {
      if (!this.customerStorageReady || !this.customerStorage) {
        const uid = this.userId || this.authService.returnUserId();
        if (uid) {
          await this.setUserStorage(uid);
        }
      }
      if (!this.customerStorage) {
        throw new Error('Customer storage not initialized');
      }

      let normalizedBucket = (bucket || '').replace(/^gs:\/\//, '').replace(/\/$/, '');
      let normalizedBlob = blob || '';
      if (normalizedBlob.startsWith('gs://')) {
        const withoutScheme = normalizedBlob.replace('gs://', '');
        const firstSlash = withoutScheme.indexOf('/');
        if (firstSlash !== -1) {
          if (!normalizedBucket) {
            normalizedBucket = withoutScheme.substring(0, firstSlash);
          }
          normalizedBlob = withoutScheme.substring(firstSlash + 1);
        }
      }
      normalizedBlob = normalizedBlob.replace(/^\/+/, '');

      const storageService: any = this.customerStorage.storage;
      const defaultBucket = (this.bucketName || '').replace(/^gs:\/\//, '');

      if (normalizedBucket && normalizedBucket !== defaultBucket) {
        const ref = storageService.app.storage('gs://' + normalizedBucket).ref(normalizedBlob);
        return { url: await ref.getDownloadURL(), code: '' };
      }

      const angularRef = this.customerStorage.ref(normalizedBlob);
      return { url: await angularRef.getDownloadURL().toPromise(), code: '' };
    } catch (error) {
      console.error('Error resolving generated file download URL:', error);
      return { url: null, code: this.storageErrorCode(error) };
    }
  }

  private storageErrorCode(error: any): string {
    if (!error) { return 'failed'; }
    if (typeof error.code === 'string' && error.code) { return error.code; }
    const nested = error.error || error.rejection || error.originalError;
    if (nested && typeof nested.code === 'string' && nested.code) { return nested.code; }
    if (typeof error.message === 'string' && error.message) { return error.message; }
    return 'failed';
  }

  getCustomerDBImageRef(fileStoragePath) {
    console.log('this.storage', this.storage);
    return this.customerStorage.ref(fileStoragePath);
  }

  getCustomerUploadTask(fileStoragePath, file) {
    if (!this.customerStorageReady || !this.customerStorage) {
      throw new Error('Customer storage not initialized. Please try logging out and logging back in.');
    }

    return this.customerStorage.upload(fileStoragePath, file);
  }

  getUploadTask(fileStoragePath, file) {
    return this.storage.upload(fileStoragePath, file);
  }

  async updateEmailImage(data) {
    let newName = `${new Date().getTime()}-${data.fileName}`;
    let storageRef: AngularFireStorageReference = this.customerStorage.ref(
      `/company/${newName}`,
    );
    let base64 = data.base64;

    // Clean and validate base64 data
    if (base64.includes(',')) {
      base64 = base64.split(',')[1]; // Remove data URL prefix
    }
    base64 = base64.replace(/\s/g, ''); // Remove whitespace

    // Validate base64 format
    if (!/^[A-Za-z0-9+/]*={0,2}$/.test(base64)) {
      throw new Error('Invalid base64 format in company logo');
    }

    // Convert base64 to Blob
    let byteCharacters;
    try {
      byteCharacters = atob(base64);
    } catch (error) {
      throw new Error('Failed to decode base64 company logo: ' + error.message);
    }
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray as any], { type: 'image/png' });

    // Upload to Firebase Storage
    const uploadTaskSnapshot = await storageRef.put(blob);
    const publicUrl = await uploadTaskSnapshot.ref.getDownloadURL();

    // data.base64 = publicUrl; // Update the data with the new URL
    return publicUrl;
  }

  saveAIDisclaimer(userId, disclaimer) {
    const disclaimerString = JSON.stringify(disclaimer);
    this.coolStore.firestore
      .collection('customers')
      .doc(userId)
      .collection('disclaimers')
      .add({
        created: new Date(),
        createdISO: new Date().toISOString(),
        createdGerman: new Date().toLocaleDateString('de-DE'),
        disclaimerSeen: true,
        disclaimerString: disclaimerString,
      });
  }

  confirmedAIDisclaimer(userId) {
    this.coolStore.firestore.collection('customers').doc(userId).update({
      disclaimerConfirmed: true,
      disclaimerConfirmedDate: new Date(),
    });
  }

  returnSeenDisclaimerStatus() {
    return this.seenDisclaimer;
  }

  returnConfirmedDisclaimerStatus() {
    return this.confirmedDisclaimer;
  }

  returnUserId() {
    return this.userId || this.authService.returnUserId();
  }

  async setUserStorage(uid) {
    try {
      const snap = await this.coolStore.firestore
        .collection('customers')
        .doc(uid)
        .get();

      const customerData = snap.data();
      this.seenDisclaimer = customerData.disclaimerSeen || false;
      this.confirmedDisclaimer = customerData.disclaimerConfirmed || false;
      this.userId = uid;
      const user = customerData.kundennummer;

      const companiesSnap = await this.coolStore.firestore
        .collection(FirebaseConstants.companies)
        .where(FirebaseConstants.kundennummer, '==', user)
        .get();

      if (companiesSnap.docs.length > 0) {
        const data = companiesSnap.docs[0].data();

        // Wait for secondApp to be initialized from connectDB
        if (!this.secondApp) {
          console.warn('SecondApp not initialized yet, waiting...');
          let attempts = 0;
          while (!this.secondApp && attempts < 100) {
            await new Promise(resolve => setTimeout(resolve, 100));
            attempts++;
          }

          if (!this.secondApp) {
            throw new Error('SecondApp failed to initialize after 10 seconds');
          }
        }

        const platformId = PLATFORM_ID;

        // Initialize storage using the authenticated secondApp instance
        // This ensures it uses the same custom token authentication as the database

        // Create AngularFireStorage using the authenticated secondApp
        // This ensures the storage uses the same authentication as the database

        // Create standard AngularFireStorage first
        this.customerStorage = new AngularFireStorage(
          data.database,
          'customerStorage',
          data.database.storageBucket,
          platformId,
          this.zone,
          null,
          null
        );
        this.bucketName = data.database.storageBucket;

        // Ensure custom token is available
        const customToken = this.authService.getCustomToken();
        // Try to auth storage with same token
        const authForStorage = this.customerStorage.storage.app.auth();
        await authForStorage.signInWithCustomToken(customToken);
        console.log("Storage Auth User:", authForStorage.currentUser?.uid);

        // Override the internal storage to use the authenticated secondApp
        try {
          if (this.secondApp && this.secondApp.storage) {
            // Replace the storage instance with one from the authenticated app
            (this.customerStorage as any).storage = this.secondApp.storage();
          }
        } catch (error) {
          console.error('Failed to override storage with authenticated app:', error);
        }


        this.customerStorageReady = true;

        return true;
      }

      console.error('No company data found for customer');
      return false;
    } catch (error) {
      console.error('Error initializing customer storage:', error);
      return false;
    }
  }

  resetUserStorage() {
    this.customerStorage = null;
    this.customerStorageReady = false;
    this.userId = '';
  }

  getAllVideos() {
    // For self-service customers, videos are at top level
    if (this.isSelfServiceMode()) {
      return this.getAllVideosTopLevel();
    }
    // For regular customers, videos are at root level (using app2)
    // return this.app2.firestore.collection(FirebaseConstants.videos);
    return this.videoStore.firestore.collection(FirebaseConstants.videos);
  }

  /**
   * Get videos collection at top level (for self-service customers with customerNumber 100002)
   * Videos are always stored at top level, not in account subcollections
   */
  getAllVideosTopLevel() {
    // Use secondApp which stays at root level for self-service customers
    if (this.secondApp && this.secondApp.firestore) {
      // return this.secondApp.firestore.collection(FirebaseConstants.videos);
      return this.videoStore.firestore.collection(FirebaseConstants.videos);
    }
    // Fallback to app2 if secondApp not available
    // return this.app2.firestore.collection(FirebaseConstants.videos);
    return this.videoStore.firestore.collection(FirebaseConstants.videos);
  }

  /**
   * Returns the current videoCount from branding; if missing, initializes with 0 and returns 0.
   * We "start from now" and don't backfill historical counts.
   */
  async getOrInitVideoCount(): Promise<number> {
    try {
      const branding = await this.getBrandingDoc();
      if (!branding) {
        // Create minimal branding doc with videoCount if none exists
        const ref = await this.getProfile().add({
          created: new Date(),
          createdISO: new Date().toISOString(),
          videoCount: 0,
        });
        return 0;
      }
      const current = branding.data?.videoCount;
      if (current === undefined || current === null) {
        await this.getProfile().doc(branding.id).update({ videoCount: 0, updated: new Date() });
        return 0;
      }
      return Number(current) || 0;
    } catch (err) {
      console.error('Error initializing videoCount:', err);
      return 0;
    }
  }

  /**
   * Returns the current recruitingCredits from branding.
   * If the field or document does not exist, returns 0 (entspricht: keine Credits verfügbar).
   */
  async getRecruitingCreditsFromBranding(): Promise<number | null> {
    try {
      const branding = await this.getBrandingDoc();
      if (!branding) {
        return 0;
      }
      const credits = branding.data?.recruitingCredits;
      if (credits === undefined || credits === null) {
        return 0;
      }
      return Number(credits) || 0;
    } catch (err) {
      console.error('Error fetching recruitingCredits from branding:', err);
      return null;
    }
  }

  async getContactCreditsFromBranding(): Promise<number | null> {
    try {
      const branding = await this.getBrandingDoc();
      if (!branding) {
        return 0;
      }
      const hybridCredits = branding.data?.plan?.hybrid?.credits;
      const credits = typeof hybridCredits === 'number' ? hybridCredits : branding.data?.recruitingCredits;
      return Number(credits) || 0;
    } catch (err) {
      console.error('Error fetching contact credits from branding:', err);
      return null;
    }
  }

  async getCvFilterCreditsFromBranding(): Promise<number | null> {
    try {
      const branding = await this.getBrandingDoc();
      if (!branding) {
        return null;
      }
      if (branding.data?.cvFilter !== true) {
        return null;
      }
      const credits = branding.data?.plan?.api?.credits ?? branding.data?.apiCredits ?? 0;
      return Number(credits) || 0;
    } catch (err) {
      console.error('Error fetching cvFilter credits from branding:', err);
      return null;
    }
  }

  async sendLowCvCreditsEmail(userEmail: string, credits: number): Promise<void> {
    try {
      const uid = this.authService.returnUserId();
      const lastSentKey = `cvCreditsEmailSent_${uid}`;
      const lastSent = localStorage.getItem(lastSentKey);
      if (lastSent) {
        const hoursSinceLastSent = (Date.now() - parseInt(lastSent, 10)) / (1000 * 60 * 60);
        if (hoursSinceLastSent < 24) {
          return;
        }
      }
      await this.http.post(`${environment.CLOUD_URL_BASE}/auth/sendLowCreditsMail`, {
        uid: uid,
        email: userEmail,
        creditType: 'cvFilter',
        creditsRemaining: credits
      }).toPromise();
      localStorage.setItem(lastSentKey, Date.now().toString());
    } catch (err) {
      console.error('Error sending low cvFilter credits email:', err);
    }
  }

  /**
   * Atomically increment the branding.recruitingCredits by N (can be negative if needed).
   */
  async incrementRecruitingCredits(by: number): Promise<void> {
    try {
      const branding = await this.getBrandingDoc();
      if (!branding) {
        const newDoc = await this.getProfile().add({
          created: new Date(),
          createdISO: new Date().toISOString(),
          recruitingCredits: 0,
        });
        await this.getProfile().doc(newDoc.id).update({
          recruitingCredits: firebase.firestore.FieldValue.increment(by),
          updated: new Date(),
        });
        return;
      }
      await this.getProfile().doc(branding.id).update({
        recruitingCredits: firebase.firestore.FieldValue.increment(by),
        updated: new Date(),
      });
    } catch (err) {
      console.error('Error incrementing recruitingCredits:', err);
    }
  }

  /**
   * Get branding document for current scope (self-service: scoped to account via app2; regular: customer root).
   */
  private async getBrandingDoc(): Promise<{ id: string, data: any } | null> {
    try {
      const snap = await this.getProfile().get();
      const docs = snap.docs || [];
      if (docs.length > 0) {
        const doc = docs[0];
        return { id: doc.id, data: doc.data() };
      }
      return null;
    } catch (err) {
      console.error('Error fetching branding doc:', err);
      return null;
    }
  }


  /**
   * Atomically increment the branding.videoCount by N (can be negative if needed).
   */
  async incrementVideoCount(by: number): Promise<void> {
    try {
      const branding = await this.getBrandingDoc();
      if (!branding) {
        // Ensure branding doc exists
        const newDoc = await this.getProfile().add({
          created: new Date(),
          createdISO: new Date().toISOString(),
          videoCount: 0,
        });
        await this.getProfile().doc(newDoc.id).update({
          videoCount: firebase.firestore.FieldValue.increment(by),
          updated: new Date(),
        });
        return;
      }
      await this.getProfile().doc(branding.id).update({
        videoCount: firebase.firestore.FieldValue.increment(by),
        updated: new Date(),
      });
    } catch (err) {
      console.error('Error incrementing videoCount:', err);
    }
  }

  getTeammembers(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.teammembers);
  }

  AddBlacklistCustomer(item) {
    this.app2.firestore.collection(FirebaseConstants.blacklist).add({
      email: item,
    });
  }

  async RemoveBlacklistCustomer(item) {
    const ids = [];
    await this.app2.firestore.collection(FirebaseConstants.blacklist).where("email", "==", item).get().then((snap) => {
      snap.forEach(async (doc) => {
        ids.push(doc.id);
        await this.app2.collection(FirebaseConstants.blacklist).doc(doc.id).delete();
      });
    });
    return ids;
  }

  GetBlacklist(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.blacklist);
  }

  async loadBlacklist(event?: any) {
    if (this.loading) return;
    this.loading = true;
    const batchSize = 25;
    if (event.name === "firstLoad") {
      this.lastDoc = null;
      this.blackListItems = [];
      this.hasMoreDataBlacklist = true;
    } else {
      this.hasMoreDataBlacklist = true;
    }

    let query = this.app2.firestore.collection(FirebaseConstants.blacklist)
      .orderBy('__name__')
      .limit(batchSize);
    if (this.lastDoc) {
      const lastId = this.lastDoc.id;
      console.log('Fetching batch after:', this.lastDoc?.id);
      query = query.startAfter(this.lastDoc);
    }

    try {
      const snapshot = await query.get();
      console.log('Snapshot:', snapshot);
      if (snapshot.empty) {
        console.log('No matching documents found.');
        this.hasMoreDataBlacklist = false;
        if (event) {
          event.target.complete();
          event.target.disabled = true;
        }
        this.loading = false;
        return [];
      } else {
        if (snapshot.docs) {
          console.log('Documents found:', snapshot.docs.length);
          const newItems = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          this.blackListItems.push(...newItems);
          if (snapshot.docs.length > 0) {
            this.lastDoc = snapshot.docs[snapshot.docs.length - 1];
          }

          if (snapshot.size < batchSize) {
            this.hasMoreDataBlacklist = false;
            console.log('All data loaded. Hiding + sign');
            if (event) {
              event.target.disabled = true;
            }
          }
          if (event) {
            event.target.complete();
          }

          console.log('Loading batch...');
          console.log('Batch size:', snapshot.docs.length);
          console.log('Last doc:', this.lastDoc?.id);
          return newItems;
        }
      }
    } catch (error) {
      console.error('Error loading emails:', error);
      if (event) event.target.complete(); // Fail-safe
      this.loading = false;
      return [];
    }
  }


  async updateTeammemberLocation(email, location: string | string[]) {
    // Normalize input. We store the canonical list in `locationNames` (string[]) and
    // keep `locationName` (legacy string) in sync with the first entry for backward compat
    // with older reads that still expect a single location.
    const locations: string[] = Array.isArray(location)
      ? location.filter(l => typeof l === 'string' && l.trim() !== '')
      : (typeof location === 'string' && location.trim() !== '' ? [location] : []);

    const legacyLocation = locations[0] || '';

    return this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          this.app2.firestore
            .collection(FirebaseConstants.teammembers)
            .doc(doc.id)
            .update({
              locationName: legacyLocation,
              locationNames: locations,
            });
        });
      });
  }

  retreiveTeammemberStatusByEmail(): firebase.firestore.CollectionReference {
    return this.app2.firestore.collection(FirebaseConstants.teammembers);
  }

  async updateTeammemberStatus(email, value) {
    return this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        console.log('snap', snap);
        snap.forEach((doc) => {
          this.app2.firestore
            .collection(FirebaseConstants.teammembers)
            .doc(doc.id)
            .update({
              status: value,
            })
            .then((snap) => {
              console.log(snap);
            })
            .catch((err) => {
              console.log(err);
            });
        });
      });
  }

  async updateTeammemberPrivileges(email: string, privileges: any) {
    return this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          this.app2.firestore
            .collection(FirebaseConstants.teammembers)
            .doc(doc.id)
            .update({ privileges });
        });
      });
  }

  async updateEnterpriseUserPrivileges(email: string, privileges: any) {
    const snap = await this.app2.firestore
      .collection('users')
      .where('email', '==', email)
      .limit(1)
      .get();
    if (!snap.empty) {
      await snap.docs[0].ref.update({ privileges });
    }
  }

  async updateTeammemberHybridAccess(email: string, hybridAccess: boolean) {
    await this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          this.app2.firestore
            .collection(FirebaseConstants.teammembers)
            .doc(doc.id)
            .update({ hybridAccess });
        });
      });

    await this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .where('email', '==', email)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          doc.ref.update({ hybridAccess });
        });
      });
  }

  async updateEnterpriseUserHybridAccess(email: string, hybridAccess: boolean) {
    const snap = await this.app2.firestore
      .collection('users')
      .where('email', '==', email)
      .limit(1)
      .get();
    if (!snap.empty) {
      await snap.docs[0].ref.update({ hybridAccess });
    }

    const customerSnap = await this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .where('email', '==', email)
      .limit(1)
      .get();
    if (!customerSnap.empty) {
      await customerSnap.docs[0].ref.update({ hybridAccess });
    }
  }

  inviteTeammemberIntoSubCollection(email, accountId) {
    this.app2.collection(FirebaseConstants.teammembers).add({
      email: email,
      status: 'Mitarbeiter*in',
      accountId: accountId,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      createdIsoTime: new Date().toISOString(),
    });
    this.coolStore.firestore.collection(FirebaseConstants.customers).add({
      email: email,
      kundennummer: this.customerNumber,
      accountId: accountId,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      status: 'teammember',
      createdIsoTime: new Date().toISOString(),
    });
  }

  async inviteTeammember(email, name?: string, role?: number | null, firstname?: string, lastname?: string) {
    // If a role (numeric id) is provided we store it as the status; otherwise
    // keep the legacy 'Mitarbeiter*in' default so older call-sites still work.
    const status: any = (role !== undefined && role !== null) ? role : 'Mitarbeiter*in';
    this.app2.collection(FirebaseConstants.teammembers).add({
      email: email,
      name: name || '',
      status: status,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      createdIsoTime: new Date().toISOString(),
    });
    await this.coolStore.firestore.collection(FirebaseConstants.customers).add({
      email: email,
      name: name || '',
      firstname: firstname || '',
      lastname: lastname || '',
      kundennummer: this.customerNumber,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      status: status,
      createdIsoTime: new Date().toISOString(),
    });
  }

  async getTeammember(email) {
    return this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get();
  }

  async getTeammemberCoolstore(id) {
    return this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .doc(id)
      .get();
  }

  updateTeammember(form) {
    this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .doc(form.value.teammemberId)
      .update({
        email: form.value.email,
        name: form.value.firstname + ' ' + form.value.lastname,
        status: 'Mitarbeiter*in',
      });
  }

  async updateCustomerTeamMember(kundennummer, uid, customerID) {
    const docRef = await this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .doc(uid);
    const doc = await docRef.get();
    if (doc.exists) {
      docRef.update({
        kundennummer: kundennummer,
        emailVerified: true,
      });
      this.coolStore.firestore
        .collection(FirebaseConstants.customers)
        .doc(customerID)
        .delete();
    } else {
      this.updateCustomerTeamMember(kundennummer, uid, customerID);
    }
  }

  getCompanyId() {
    const id = '';
    this.coolStore.firestore
      .collection('companies')
      .where(FirebaseConstants.kundennummer, '==', this.customerNumber)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          return doc.id;
        });
      });
  }

  getCompany() {
    return this.coolStore.firestore
      .collection('companies')
      .where(FirebaseConstants.kundennummer, '==', this.customerNumber)
      .get();
  }

  getCompanyName(): Promise<string> {
    return this.getCompany().then((snap) => {
      const docs = snap.docs;
      if (docs.length > 0) {
        const doc = docs[0];
        const companyName = doc.data().name || doc.data().email;
        return Promise.resolve(companyName);
      }
    });
  }

  async getCompanySsoConfig(): Promise<{
    id: string;
    name: string;
    kundennummer: number;
    ssoDomains: string[];
  } | null> {
    const snap = await this.getCompany();
    if (!snap || snap.empty) return null;
    const doc = snap.docs[0];
    const data = doc.data() || {};
    const domains = Array.isArray(data.ssoDomains)
      ? data.ssoDomains.map((d) => String(d || '').trim().toLowerCase()).filter(Boolean)
      : [];
    return {
      id: doc.id,
      name: data.name || data.email || data.firmenname || '',
      kundennummer: data.kundennummer,
      ssoDomains: Array.from(new Set(domains))
    };
  }

  async saveCompanySsoDomains(domains: string[]): Promise<void> {
    const snap = await this.getCompany();
    if (!snap || snap.empty) {
      throw new Error('Company document not found');
    }
    const unique = Array.from(new Set(
      (domains || []).map((d) => String(d || '').trim().toLowerCase()).filter(Boolean)
    ));
    await snap.docs[0].ref.update({ ssoDomains: unique });
  }

  getDashboardSettings() {
    return this.app2.firestore
      .collection(FirebaseConstants.dashboardSettings)
      .get()
      .then((snap) => {
        if (snap == undefined) {
          this.app2.firestore
            .collection(FirebaseConstants.dashboardSettings)
            .add({});
        } else {
          const docs = snap.docs;
          if (docs != undefined && docs.length > 0) {
            return docs[0].data();
          }
        }
      });
  }

  updateDashboardSettings(timeDisponentSetting, moneyDisponentSetting) {
    this.app2.firestore
      .collection(FirebaseConstants.dashboardSettings)
      .get()
      .then((snap) => {
        if (snap.docs.length > 0) {
          snap.docs[0].ref.update({
            timeDisponentSetting: timeDisponentSetting,
            moneyDisponentSetting: moneyDisponentSetting,
          });
        } else {
          this.app2.firestore
            .collection(FirebaseConstants.dashboardSettings)
            .add({
              timeDisponentSetting: timeDisponentSetting,
              moneyDisponentSetting: moneyDisponentSetting,
            });
        }
      });
  }

  getCustomerPrice() {
    return this.coolStore.firestore
      .collection(FirebaseConstants.companies)
      .where(FirebaseConstants.kundennummer, '==', this.customerNumber)
      .get();
  }

  async getCustomer(email) {
    return this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .where('email', '==', email)
      .get();
  }

  // signupTeammember(email, password) {
  //   this.auth = new AngularFireAuth(
  //     this.db,
  //     'app2',
  //     PLATFORM_ID,
  //     this.zone
  //   );

  //   return this.auth
  //     .createUserWithEmailAndPassword(email, password)
  //     .then((newUserCredential: firebase.auth.UserCredential) => {
  //       firebase
  //         .firestore()
  //         .doc(`/customers/${newUserCredential.user.uid}`)
  //         .set({ email });
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       throw new Error(error);
  //     });
  // }

  async deleteTeammember(email: string): Promise<void> {
    return this.deleteTeammemberFromFirestore(email);
  }

  private async deleteTeammemberFromFirestore(email: string): Promise<void> {
    // The per-tenant teammembers collection lives on app2, which the CF cannot
    // reach — so the client deletes it directly. The main-DB customers doc and
    // the Firebase Auth entry are both removed by the deleteAuthUser CF.

    const teamSnap = await this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get();
    await Promise.all(teamSnap.docs.map((doc) => doc.ref.delete()));

    try {
      await this.deleteAuthUserViaCf(email);
    } catch (err) {
      console.error('deleteAuthUser CF call failed', err);
    }
  }

  private async deleteAuthUserViaCf(email: string): Promise<void> {
    const caller = firebase.auth().currentUser;
    if (!caller) {
      throw new Error('no-current-user');
    }
    const idToken = await caller.getIdToken();
    await this.http.post(
      cfRegionLinks.deleteAuthUser,
      { email: email, customerNumber: this.customerNumber },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
      },
    ).toPromise();
  }

  deactivateAccount(email) {
    const body = {
      email: email,
      customerNumber: this.customerNumber,
    };
    return this.http.post(cfRegionLinks.deactivateUserMonaPlattform, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }

  addmatchingSettings(settings) {
    this.app2.firestore.collection(FirebaseConstants.matchingSettings).add({
      settings: settings,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      createdIsoTime: new Date().toISOString(),
    });
  }

  getMatchingSettings() {
    return this.app2.firestore.collection(FirebaseConstants.matchingSettings);
  }

  deleteWorkflow(id) {
    return this.app2.firestore.collection('workflows').doc(id).delete();
  }

  async getParticularWorkflow(id) {
    const docRef = this.app2.firestore.collection('workflows').doc(id);
    const docSnapshot = await docRef.get();
    if (docSnapshot.exists) {
      return docSnapshot.data();
    } else {
      return undefined;
    }
  }

  async ImportProfilAnlegen(profil) {
    return await this.app2.firestore.collection('applicants').add({
      anrede: profil.anrede || '',
      anschrift: profil.anschrift || '',
      berufswunsch: profil.berufswunsch || '',
      eingangsdatum: profil.eingangsdatum || '',
      email: profil.email || '',
      externeId: profil.externeId || '',
      facebook: profil.facebook || '',
      fuehrerschein: profil.fuehrerschein || '',
      fachkenntnisse: profil.fachkenntnisse || '',
      familienstand: profil.familienstand || '',
      feld1: profil.feld1 || '',
      feld2: profil.feld2 || '',
      feld3: profil.feld3 || '',
      feld4: profil.feld4 || '',
      feld5: profil.feld5 || '',
      geburtsdatum: profil.geburtsdatum || '',
      gehaltswunsch: profil.gehaltswunsch || '',
      hausnummer: profil.hausnummer || '',
      instagram: profil.instagram || '',
      interneId: profil.interneId || '',
      linkedin: profil.linkedin || '',
      mindestgehalt: profil.mindestgehalt || '',
      mobiltelefon: profil.mobiltelefon || '',
      nachname: profil.nachname || '',
      nationalitaet: profil.nationalitaet || '',
      notizen: profil.notizen || '',
      ort: profil.ort || '',
      pkw: profil.pkw || '',
      plz: profil.plz || '',
      quelle: profil.quelle || '',
      reisewunsch: profil.reisewunsch || '',
      socialmedia: profil.socialmedia || '',
      sprachen: profil.sprachen || '',
      status: profil.status || '',
      strasse: profil.strasse || '',
      telefon: profil.telefon || '',
      titel: profil.titel || '',
      umzugwunsch: profil.umzugwunsch || '',
      vorname: profil.vorname || '',
      xing: profil.xing || '',
      clicks: 0,
      seen: 0,
      profilStatus: 'aktiv',
      created: new Date(),
      IsoDate: new Date().toISOString().split('T')[0],
      lastChanged: new Date(),
      lastChangedIsoDate: new Date().toISOString().split('T')[0],
    });
  }

  profilAnlegen(profil) {
    return this.applicantProfile.add({
      anrede: profil.anrede,
      anschrift: profil.anschrift,
      applicationid: profil.applicationid,
      bereich: profil.bereich,
      beschreibung: profil.beschreibung,
      bewerberEinwilligung: profil.bewerberEinwilligung,
      bewertung: profil.bewertung,
      eingangsdatum: profil.eingangsdatum,
      einrichtung: profil.einrichtung,
      email: profil.email,
      endDatum: profil.endDatum,
      fuehrerschein: profil.fuehrerschein,
      geaendertdatum: profil.geaendertdatum,
      jobpost: profil.jobpost,
      kategorie: profil.kategorie,
      mobiltelefon: profil.mobiltelefon,
      nachname: profil.nachname,
      newsletter: profil.newsletter,
      notizen: profil.notizen,
      ort: profil.ort,
      pkw: profil.pkw,
      plz: profil.plz,
      positionen: profil.positionen,
      recruitmentStartdatum: profil.recruitmentStartdatum,
      schlagworte: profil.schlagworte,
      startDatum: profil.startDatum,
      status: profil.status,
      strasse: profil.strasse,
      talentpoolEinwilligung: profil.talentpoolEinwilligung,
      talentpoolEinwilligungDouble: profil.talentpoolEinwilligungDouble,
      telefon: profil.telefon,
      titel: profil.titel,
      unternehmen: profil.unternehmen,
      vorname: profil.vorname,
      clicks: 0,
      seen: 0,
      profilStatus: 'aktiv',
      created: new Date(),
      createdFirestore: firebase.firestore.FieldValue.serverTimestamp(),
      IsoDate: new Date().toISOString().split('T')[0],
      lastChanged: new Date(),
      lastChangedIsoDate: new Date().toISOString().split('T')[0],
    });
  }

  profilUpdate(profil) {
    return this.applicantProfile.doc(profil.id).update({
      anrede: profil.anrede,
      anschrift: profil.anschrift,
      applicationId: profil.applicationId,
      bereich: profil.bereich,
      beschreibung: profil.beschreibung,
      bewerberEinwilligung: profil.bewerberEinwilligung,
      bewertung: profil.bewertung,
      eingangsdatum: profil.eingangsdatum,
      einrichtung: profil.einrichtung,
      email: profil.email,
      endDatum: profil.endDatum,
      fuehrerschein: profil.fuehrerschein,
      geandertdatum: profil.geandertdatum,
      jobpost: profil.jobpost,
      kategorie: profil.kategorie,
      clicks: profil.clicks,
      seen: profil.seen,
      mobiltelefon: profil.mobiltelefon,
      nachname: profil.nachname,
      newsletter: profil.newsletter,
      notizen: profil.notizen,
      ort: profil.ort,
      pkw: profil.pkw,
      plz: profil.plz,
      positionen: profil.positionen,
      recruitmentStartdatum: profil.recruitmentStartdatum,
      schlagworte: profil.schlagworte,
      startDatum: profil.startDatum,
      status: profil.status,
      strasse: profil.strasse,
      talentpoolEinwilligung: profil.talentpoolEinwilligung,
      talentpoolEinwilligungDouble: profil.talentpoolEinwilligungDouble,
      telefon: profil.telefon,
      titel: profil.titel,
      profilStatus: 'aktiv',
      unternehmen: profil.unternehmen,
      vorname: profil.vorname,
      created: profil.created,
      createdFirestore: profil.createdFirestore,
      IsoDate: profil.IsoDate,
      lastChanged: new Date(),
      lastChangedIsoDate: new Date().toISOString().split('T')[0],
    });
  }

  profilDelete(id) {
    return this.applicantProfile.doc(id).delete();
  }

  profilArchive(id) {
    return this.applicantProfile.doc(id).update({
      profilStatus: 'archiviert',
      lastChanged: new Date(),
      lastChangedIsoDate: new Date().toISOString().split('T')[0],
    });
  }

  updateContractMessages(messages, docId) {
    const messagesJSON = JSON.stringify(Array.from(messages.entries()));
    this.getContract(docId).update(FirebaseConstants.messages, messagesJSON);
  }

  alertErrorUpload(kennziffer) {
    this.alertCtrl
      .create({
        header: 'Fehler beim Upload von ' + kennziffer,
        message: 'Bitte versuchen Sie es für die Person erneut.',
        buttons: ['OK'],
      })
      .then((alert) => alert.present());
  }

  createCompleetApplicant(obj) {
    this.app2.firestore.collection('compleetApplicants').add(obj);
  }

  getApplicantsAfterDate(date) {
    return this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .where('created', '>=', date)
      .limit(1000);
  }

  getCompleetApplicant() {
    let startDate = new Date(2025, 8, 1);
    let endDate = new Date(2025, 8, 30);

    const applicants = [];
    this.app2.firestore
      .collection('compleetApplicants')
      .get()
      .then(async (snap) => {
        await snap.docs.forEach((doc) => {
          const data = doc.data();
          const created = data.created.toDate();
          if (created >= startDate && created <= endDate) {
            applicants.push(data);
          }
        });
      })
      .then(() => {
        console.log(applicants.length);
      });
  }

  getTalentionApplicants() {
    const startDate = new Date(2025, 3, 1);
    const endDate = new Date(2025, 3, 30);

    const applicants = [];
    // Use emailapplicants cause in talentionApplicants we would have to filter for the mandanten 
    this.app2.firestore
      .collection('emailapplicants')
      .get()
      .then(async (snap) => {
        await snap.docs.forEach((doc) => {
          const data = doc.data();
          let created = data.created
          if (created) {
            created = created.toDate();
            if (created >= startDate && created <= endDate) {
              applicants.push(data);
            }
          }
        });
      })
      .then(() => {
        console.log(applicants.length);
      });
  }

  async triggerWorkflowOnApplicant(applicantId, workflowId) {
    const applicant = await this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .doc(applicantId);
    applicant
      .update({
        workflowArray: null,
        workflowArrayExecuted: null,
      })
      .then(async () => {
        const workflows = [];
        workflows.push(workflowId);
        applicant.update({
          workflowArray: workflows,
        });
      });
  }

  // agents
  getAgents() {
    if (!this.isDatabaseReady()) {
      throw new Error('Database not initialized yet. Please wait for connection.');
    }
    return this.app2.firestore.collection(FirebaseConstants.agents);
  }

  getAgentDetail(id): firebase.firestore.DocumentReference {
    if (!this.isDatabaseReady()) {
      throw new Error('Database not initialized yet. Please wait for connection.');
    }
    return this.app2.firestore.collection(FirebaseConstants.agents).doc(id);
  }

  addAgent(agent) {
    return this.app2.firestore.collection(FirebaseConstants.agents).add(agent);
  }

  updateAgentFirestore(agent) {
    return this.app2.firestore
      .collection(FirebaseConstants.agents)
      .doc(agent.id)
      .update(agent);
  }

  deleteAgent(id, isMonariAgent: boolean) {
    if (isMonariAgent) {
      return this.app2.firestore
        .collection(FirebaseConstants.monariAgents)
        .doc(id)
        .delete();
    }
    else {
      return this.app2.firestore
        .collection(FirebaseConstants.agents)
        .doc(id)
        .delete();
    }
  }

  retrieveChatHistory() {
    return this.app2.firestore.collection(FirebaseConstants.ChatHistory);
  }

  async getMatchingPunktzahl() {
    return this.getProfile().get().then((snap) => {
      const docs = snap.docs;
      if (docs.length > 0) {
        const doc = docs[0];
        const data = doc.data();
        return data.minimumMatchingResult;
      }
    });
  }

  // agents API
  getProfile2(): CollectionReference {
    return this.app2.collection(FirebaseConstants.branding);
  }

  saveZvooveAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              zvoove: data.zvoove,
              zvooveBewerberApiKey: data.zvooveBewerberApiKey || '',
              zvooveBewerberApiLink: data.zvooveBewerberApiLink || '',
              zvooveStellenApiKey: data.zvooveStellenApiKey || '',
              zvooveStellenApiLink: data.zvooveStellenApiLink || '',
              zvoooveNextLevelApiKey: data.zvoooveNextLevelApiKey || '',
              zvooveNextLevelApiLink: data.zvooveNextLevelApiLink || '',
              zvooveBewerberApiLinkById: data.zvooveBewerberApiLinkById || '',
              zvooveCreateBewerberApiLink:
                data.zvooveCreateBewerberApiLink || '',
              username: data.username || '',
              password: data.password || '',
              AIMatchingType: data.AIMatchingType || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveTalentionAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              talention: data.talention,
              talentionClientId: data.talentionClientId || '',
              talentionClientSecret: data.talentionClientSecret || '',
              talentionAccountId: data.talentionAccountId || '',
              talentionAccountOption: data.talentionAccountOption || '',
              talentionAccountOptionBranches:
                data.talentionAccountOptionBranches || '',
              talentionMonaStatusEingang: data.talentionMonaStatusEingang || '',
              talentionMonaStatusImInterview:
                data.talentionMonaStatusImInterview || '',
              talentionMonaStatusInterviewAbgeschlossen:
                data.talentionMonaStatusInterviewAbgeschlossen || '',
              talentionMonaStatusAbgelehnt:
                data.talentionMonaStatusAbgelehnt || '',
              talentionMonaStatusProfilErstellt:
                data.talentionMonaStatusProfilErstellt || '',
              talentionMonaStatusProfilVersendet:
                data.talentionMonaStatusProfilVersendet || '',
              AIMatchingType: data.AIMatchingType || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveIndexApiKeyCredentials(accessToken, login, password) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              indexApiKey: accessToken,
              indexLogin: login,
              indexPassword: password,
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveGoogleCredentials(accessToken, refreshToken, googleProfile) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              googleAccessToken: accessToken,
              googleRefreshToken: refreshToken,
              googleProfile: googleProfile,
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveMicrosoftCredentials(accessToken, refreshToken, microsoftProfile) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          const microsoftProfileObj = JSON.parse(microsoftProfile);
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              microsoftAccessToken: accessToken,
              microsoftRefreshToken: refreshToken,
              microsoftProfile: microsoftProfileObj,
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  private async updateTeammemberWithMicrosoftCredentials(
    accessToken,
    microsoftProfile,
    refreshToken,
    snap,
  ) {
    snap.docs.forEach((doc) => {
      const id = doc.id;
      this.getTeammembers().doc(id).update({
        microsoftAccessToken: accessToken,
        microsoftRefreshToken: refreshToken,
        microsoftProfile: microsoftProfile,
      });
    });
  }

  private async addTeammemberWithMicrosoftCredentials(
    accessToken,
    microsoftProfile,
    refreshToken,
  ) {
    this.getTeammembers().add({
      email: microsoftProfile.mail,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      status: 'Mitarbeiter*in',
      createdIsoTime: new Date().toISOString(),
      microsoftAccessToken: accessToken,
      microsoftRefreshToken: refreshToken,
      microsoftProfile: microsoftProfile,
    });
  }

  async saveMicrosoftTeamMemberCredentials(
    accessToken,
    refreshToken,
    microsoftProfile,
  ) {
    const microsoftProfileObj = JSON.parse(microsoftProfile);

    this.getTeammembers()
      .where('email', '==', microsoftProfileObj.mail)
      .get()
      .then((snap) => {
        if (snap.docs.length > 0) {
          this.updateTeammemberWithMicrosoftCredentials(
            accessToken,
            microsoftProfileObj,
            refreshToken,
            snap,
          );
        } else {
          this.addTeammemberWithMicrosoftCredentials(
            accessToken,
            microsoftProfileObj,
            refreshToken,
          );
        }
      });

    this.coolStore.firestore
      .collection(FirebaseConstants.customers)
      .where('email', '==', microsoftProfileObj.mail)
      .get()
      .then((snap) => {
        if (snap.docs.length > 0) {
          //do nothing as we do not want to update the token here.
        } else {
          //create a new teamMember without token
          this.AddNewCustomerInCoolstore(microsoftProfileObj.mail);
        }
      });
  }

  AddNewCustomerInCoolstore(email) {
    this.coolStore.firestore.collection(FirebaseConstants.customers).add({
      email: email,
      kundennummer: this.customerNumber,
      created: new Date(),
      createdIso: new Date().toISOString().split('T')[0],
      status: 'Mitarbeiter*in',
      createdIsoTime: new Date().toISOString(),
    });
  }

  saveIMAPCredentials(imapHost, imapPost, imapUsername, imapPassword, imapTLS) {
    return this.getProfile()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              imapHost: imapHost,
              imapPost: imapPost,
              imapUsername: imapUsername,
              imapPassword: imapPassword,
              imapTLS: imapTLS,
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveCompleetAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              compleet: data.compleet,
              compleetAPIKeys: data.compleetAPIKeys || '',
              updated: new Date(),
              AIMatchingType: data.AIMatchingType || '',
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveIndexAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              index: data.index,
              indexLogin: data.indexLogin || '',
              indexPassword: data.indexPassword || '',
              updated: new Date(),
            });
        } else {
          return false;
        }
      });
  }

  saveZapierAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              zapier: data.zapier,
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveCustomIntegrationAPIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              customIntegration: data.customIntegration,
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  saveTalent360APIKeys2(data) {
    return this.getProfile2()
      .get()
      .then((snap) => {
        const docs = snap.docs;
        const docLength = docs.length;
        if (docLength > 0) {
          const id = docs[0].id;
          return this.app2
            .collection(FirebaseConstants.branding)
            .doc(id)
            .update({
              talent360: data.talent360,
              talentClientId: data.talentClientId || '',
              talentClientSecret: data.talentClientSecret || '',
              talentAPIBaseUrl: data.talentAPIBaseUrl || '',
              talentAccessTokenUrl: data.talentAccessTokenUrl || '',
              talentPublicAudience: data.talentPublicAudience || '',
              updated: new Date(),
              status: 'aktiv',
            });
        } else {
          return false;
        }
      });
  }

  sendVideos() {
    // part for new video generation collecting all Videos from customers
    // let i = 1;
    // this.app2.firestore.collection(FirebaseConstants.videos).get().then(async (snap) => {
    //   await snap.forEach((doc) => {
    //     let video = doc.data();
    //     this.videoStore.firestore.collection(FirebaseConstants.videos).add(video).then(() => {
    //       console.log(i++);
    //     })
    //   })
    // })
  }

  async addToVideosToBeGenerated(videosToGenerate: any[]) {
    // getVideosInProgress() now handles the routing automatically
    const collectionRef = this.getVideosInProgress();

    if (this.isSelfServiceMode()) {
      console.log('🎥 SELF-SERVICE: Adding videos to TOP-LEVEL videosInProgress (customerNumber 100002)');
    } else {
      console.log('📁 REGULAR: Adding videos to root-level videosInProgress');
    }

    if (collectionRef) {
      videosToGenerate.forEach(async (video) => {
        video.created = new Date();
        // Add accountId to video metadata for self-service mode tracking
        if (this.isSelfServiceMode()) {
          video.accountId = this.accountId;
          console.log('🎥 Adding accountId to video metadata:', this.accountId);
        }
        await collectionRef.add(video);
        console.log('✅ Video added to collection');
      });
    }
  }

  getVideosInProgress() {
    // For self-service customers, videos in progress are at top level
    if (this.isSelfServiceMode()) {
      return this.getVideosInProgressTopLevel();
    }
    // For regular customers, videos in progress are at root level (using app2)
    // return this.app2.firestore.collection(FirebaseConstants.videosInProgress);
    return this.videoStore.firestore.collection(FirebaseConstants.videosInProgress);
  }

  /**
   * Get videosInProgress collection at top level (for self-service customers with customerNumber 100002)
   * Videos in progress are always stored at top level, not in account subcollections
   */
  getVideosInProgressTopLevel() {
    // Use secondApp which stays at root level for self-service customers
    // if (this.secondApp && this.secondApp.firestore) {
    //   console.log('getVideosInProgressTopLevel: using secondApp.firestore for videos at root level');
    //   return this.secondApp.firestore.collection(FirebaseConstants.videosInProgress);
    // }
    // Fallback to app2 if secondApp not available
    // console.log('getVideosInProgressTopLevel: fallback to app2.firestore');
    // return this.app2.firestore.collection(FirebaseConstants.videosInProgress);

    return this.videoStore.firestore.collection(FirebaseConstants.videosInProgress);
  }

  deleteVideoInProgress(text, language, avatarId, voiceId) {
    let firestore = this.videoStore.firestore;
    let collectionRef = this.videoStore.firestore.collection(FirebaseConstants.videosInProgress);

    // Primary query: langCode
    let query = collectionRef
      .where('text', '==', text)
      .where('langCode', '==', language)
      .where('avatarId', '==', avatarId)
      .where('voiceId', '==', voiceId);

    // In self-service mode, also filter by accountId
    if (this.isSelfServiceMode()) {
      query = query.where('accountId', '==', this.accountId);
    }

    return query
      .get()
      .then(async (snap) => {
        // Fallback: try 'language' field if no docs under 'langCode'
        if (snap.empty) {
          const fallbackQuery = collectionRef
            .where('text', '==', text)
            .where('language', '==', language)
            .where('avatarId', '==', avatarId)
            .where('voiceId', '==', voiceId);
          snap = await fallbackQuery.get();
        }

        if (snap.empty) {
          console.log('No matching videosInProgress found for deletion.');
          return;
        }

        const batch = firestore.batch();
        snap.forEach((doc) => batch.delete(doc.ref));
        return batch.commit().then(() => {
          console.log('videosInProgress documents successfully deleted.');
        });
      })
      .catch((error) => {
        console.error('Error deleting videosInProgress: ', error);
      });
  }

  getMonaLogs(applicantId) {
    const errors = [];
    return this.app2.firestore
      .collection(FirebaseConstants.monaLogs)
      .doc(applicantId)
      .collection(FirebaseConstants.errors)
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          if (doc.exists) {
            const data = doc.data();
            const timestamp = data.created;
            if (timestamp instanceof Date) {
              data.created = timestamp;
            } else {
              data.created = timestamp.toDate();
            }
            errors.push(data);
          }
          // if (snap.exists) {
          //   let data = snap.data();
          //   let errors = data.errorArray;
          //   for (let error of errors) {
          //   }
          //   return errors;
          // };
        });
        return errors;
      });
  }

  // notifications
  public updateLastLoginTime(userId: string): Promise<void> {
    return this.app2.firestore.doc(`users/${userId}`).update({
      lastLoginTime: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }

  // Applicants seit letztem Login
  public getApplicantsSince(lastLogin: Date): Observable<any[]> {
    return this.app2.firestore
      .collection('customers/kunde1001/applicants', (ref) =>
        ref.where('createdAt', '>', lastLogin),
      )
      .valueChanges();
  }

  // Tutorials seit letztem Login
  public getTutorialsSince(lastLogin: Date): Observable<any[]> {
    return this.app2.firestore
      .collection('tutorials', (ref) =>
        ref.where('creationDate', '>', lastLogin),
      )
      .valueChanges();
  }

  // Integrationen seit letztem Login
  public getIntegrationsSince(lastLogin: Date): Observable<any[]> {
    return this.app2.firestore
      .collection('integrations', (ref) =>
        ref.where('createdAt', '>', lastLogin),
      )
      .valueChanges();
  }

  // get all workflows with flag isCommunication as true
  async getAllCommunicationWorkflows() {
    const workflows = [];
    await this.app2.firestore.collection(FirebaseConstants.workflows).get().then((snap) => {
      snap.forEach((doc) => {
        const data = doc.data();
        if (data.isCommunication) {
          const obj = {
            id: data.id,
            name: data.name
          }
          workflows.push(obj);
        }
      })
    })
    return workflows;
  }

  public setUserEmail(email: string) {
    this.userEmail = email;
  }

  public getUserEmail(): string {
    return this.userEmail;
  }

  // Firebase Auth is the only source that is correct right after an in-SPA navigation,
  // the cached values are the fallback for a direct page load.
  public getCurrentUserIdentity(): { uid: string; email: string; rawEmail: string } {
    let rawEmail = '';
    try {
      rawEmail = String(
        this.authService.getCurrentUserFromFirebaseAuth()?.email ||
        this.authService.returnUser() ||
        this.userEmail ||
        ''
      ).trim();
    } catch {
      rawEmail = String(this.userEmail || '').trim();
    }
    return { uid: this.authService.returnUserId() || '', email: rawEmail.toLowerCase(), rawEmail };
  }

  // Owner-controlled visibility of the workspace tasks: keep them private, let the team
  // read them, or additionally allow colleagues to take them over.
  public async getTaskSharingMode(): Promise<TaskSharingMode> {
    const { uid, email, rawEmail } = this.getCurrentUserIdentity();
    // Teammember documents are not stored with a consistent casing, so the original
    // spelling has to be tried as well before falling back to the user document.
    const candidates = Array.from(new Set([email, rawEmail].filter(Boolean)));
    try {
      for (const candidate of candidates) {
        if (!this.app2?.firestore) break;
        const teammemberSnap = await this.app2.firestore
          .collection(FirebaseConstants.teammembers)
          .where('email', '==', candidate)
          .limit(1)
          .get();
        if (!teammemberSnap.empty) {
          return normalizeSharingMode(teammemberSnap.docs[0].data()?.taskSharing);
        }
      }
      if (uid && this.app2?.firestore) {
        const userDoc = await this.app2.firestore.collection('users').doc(uid).get();
        if (userDoc.exists) return normalizeSharingMode(userDoc.data()?.taskSharing);
      }
    } catch (error) {
      console.warn('[getTaskSharingMode] Could not resolve the sharing mode:', error);
    }
    return DEFAULT_TASK_SHARING_MODE;
  }

  async updateTeammemberTaskSharing(email: string, taskSharing: TaskSharingMode) {
    const snap = await this.app2.firestore
      .collection(FirebaseConstants.teammembers)
      .where('email', '==', email)
      .get();
    await Promise.all(snap.docs.map((doc) => doc.ref.update({ taskSharing })));
  }

  async updateEnterpriseUserTaskSharing(email: string, taskSharing: TaskSharingMode) {
    const snap = await this.app2.firestore
      .collection('users')
      .where('email', '==', email)
      .limit(1)
      .get();
    if (!snap.empty) {
      await snap.docs[0].ref.update({ taskSharing });
    }
  }

  logUserOut(email, type: 'outlook' | 'google') {
    //if the user is logged in with the same account, only remove the tokens.
    if (type !== 'outlook' && type !== 'google')
      return;
    this.getTeammembers().where("email", '==', email).get().then((snap) => {
      if (snap.docs.length > 0) {
        snap.docs.forEach((doc) => {
          const id = doc.id;
          const createdFromUser = doc.data().createdFromUser ? doc.data().createdFromUser : { google: null, microsoft: null };
          const newUserForm = this.createUpdatedLoggedInForm(createdFromUser, type);
          this.getTeammembers().doc(id).update(newUserForm)
        })
      }
    })
  }

  private createUpdatedLoggedInForm(createdFromUser, type) {
    switch (type) {
      case 'outlook':
        return {
          microsoftAccessToken: null,
          microsoftRefreshToken: null,
          microsoftProfile: null,
          createdFromUser: {
            microsoft: null,
            google: createdFromUser.google ? createdFromUser.google : null
          }
        }
      case 'google':
        return {
          googleProfile: null,
          googleAccessToken: null,
          googleRefreshToken: null,
          createdFromUser: {
            microsoft: createdFromUser.microsoft ? createdFromUser.microsoft : null,
            google: null
          }
        }
      default:
        return {}
    }
  }

  logSMTPOut(email) {
    this.getProfile().where('smtpEmail', '==', email).get().then((snap) => {
      if (snap.docs.length > 0) {
        //should actually be 1 doc only
        snap.docs.forEach((doc) => {
          const id = doc.id;
          this.getProfile().doc(id).update({
            smtpHost: null,
            smtpPort: null,
            smtpEmail: null
          })
        })
      }
    })
  }

  // Add these methods for CRM functionality
  private getFirebaseService() {
    if (!this.firebaseService) {
      try {
        // Use proper type-based injection instead of string-based
        this.firebaseService = this.injector.get(FirebaseService);
      } catch (error) {
        console.error('FirebaseService not available yet, retrying...');
        // Return a mock for now with the missing loadAPIKeys method
        return {
          returnSalesEmails: () => ({
            orderBy: () => ({
              limit: () => ({ get: async () => ({ empty: true, docs: [] }) }),
            }),
          }),
          returnSalesEmailsSparkasse: () => ({
            orderBy: () => ({
              limit: () => ({ get: async () => ({ empty: true, docs: [] }) }),
            }),
          }),
          returnSalesEmailsNormalCustomers: () => ({
            orderBy: () => ({
              limit: () => ({ get: async () => ({ empty: true, docs: [] }) }),
            }),
          }),
          loadAPIKeys: async () => ({
            empty: true,
            docs: []
          })
        };
      }
    }
    return this.firebaseService;
  }

  async getEmailStats(): Promise<any[]> {
    try {
      // Get customer number to determine which query to use
      const customerNumber = this.getCustomerNumber();
      const businessName = this.returnBusinessName();
      let collection;

      if (!businessName) return [];
      collection = firebase
        .firestore()
        .collection('emailsToBeSentGeneral')
        .doc(businessName)
        .collection('emailsToBeSent');
      // }

      const query = collection.orderBy('created', 'desc').limit(1000);
      const snapshot = await query.get();

      if (snapshot.empty) return [];

      return snapshot.docs.map((doc) => {
        const data = doc.data();
        data.id = doc.id;

        // Process criteriaFulfilled to make it consistent
        if (data.resJob && data.resJob.content) {
          const resJob = data.resJob.content;
          data.matchingPunktzahl = resJob.matchingPunktzahl || 0;

          if ('erfülltMussKriterien' in resJob) {
            data.criteriaFulfilled = resJob['erfülltMussKriterien'];
          } else {
            data.criteriaFulfilled = false;
          }
        }

        return data;
      });
    } catch (error) {
      console.error('Error fetching email stats:', error);
      return [];
    }
  } //

  async getCompanies(): Promise<any[]> {
    try {
      const emails = await this.getEmailStats();
      const uniqueCompanies = new Map();

      emails.forEach((email) => {
        if (!email.company) return;

        // Only add if not already in the map
        if (!uniqueCompanies.has(email.company)) {
          const company = {
            name: email.company || '',
            location: email.location || '',
            industry: email.position || '',
            phone: email.companyPhone || '',
            website: email.companyLink || '',
            contactPerson: email.contactPerson || '',
            email: email.contactPersonEmail || '',
            status: email.contacted ? 'contacted' : 'not_contacted',
            logoUrl: '',
          };
          uniqueCompanies.set(email.company, company);
        }
      });

      return Array.from(uniqueCompanies.values());
    } catch (error) {
      console.error('Error fetching companies:', error);
      return [];
    }
  }

  async updateEmailStatus(emailId: string, status: string): Promise<void> {
    try {
      const customerNumber = this.getCustomerNumber();
      let collection;

      const businessName = this.returnBusinessName();
      if (!businessName) throw new Error('Business name not found');
      collection = firebase
        .firestore()
        .collection('emailsToBeSentGeneral')
        .doc(businessName)
        .collection('emailsToBeSent');

      await collection.doc(emailId).update({
        contacted: status === 'contacted',
        status: status,
        lastUpdated: new Date().toISOString(),
      });
    } catch (error) {
      console.error('Error updating email status:', error);
      throw error;
    }
  }

  /**
   * Gets all ATS connections for the current account
   */
  async getConnections() {
    try {
      const snapshot = await this.app2.firestore
        .collection('ats_connections')
        .get();

      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting connections:', error);
      throw error;
    }
  }

  // Check if database is ready
  isDatabaseReady(): boolean {
    return this.app2 && this.app2.firestore;
  }

  // Wait for database to be ready
  async waitForDatabase(maxWaitTime: number = 10000): Promise<boolean> {
    const startTime = Date.now();
    while (!this.isDatabaseReady() && (Date.now() - startTime) < maxWaitTime) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    return this.isDatabaseReady();
  }

  async getAllAgentNames(): Promise<string[]> {
    if (!this.isDatabaseReady()) {
      console.warn('Database not initialized yet for getAllAgentNames, waiting...');
      const ready = await this.waitForDatabase();
      if (!ready) {
        console.error('Database failed to initialize within timeout');
        return [];
      }
    }
    try {
      const snapshot = await this.app2.firestore.collection(FirebaseConstants.agents).get();
      const agentNames = snapshot.docs.map(doc => doc.data().name);
      //if it is instance 2, also check the outside.
      let additionalAgentNames = [];
      if (this.customerNumber === 100001 || this.customerNumber === 100002) {
        //get additional agents from outside of accounts
        const additionalAgentsSnapshot = await this.baseApp2.firestore.collection(FirebaseConstants.monariAgents).get();
        additionalAgentNames = additionalAgentsSnapshot.docs.map(doc => doc.data().name);
      }
      const monariSnapshot = await this.app2.firestore.collection(FirebaseConstants.monariAgents).get();
      const monariAgentNames = monariSnapshot.docs.map(doc => doc.data().name);
      return [...agentNames, ...monariAgentNames, ...additionalAgentNames];
    } catch (error) {
      console.error('Error getting agent names:', error);
      return [];
    }
  }


  async getAllowedTools(): Promise<string[]> {
    // Since all tools are allowed, directly return all available tools from local mapping
    try {
      const toolInfosMapping = await import('../mona-agent-builder/tool_infos_mapping.json');
      const toolInfos = toolInfosMapping.default || toolInfosMapping;
      const allToolNames = Object.values(toolInfos).map((tool: any) => tool.name);
      console.log("Loading all available tools:", allToolNames);
      return allToolNames;
    } catch (error) {
      console.error("Failed to load tools from local mapping:", error);

      // Hardcoded fallback with all known tools
      const defaultTools = [
        'DB_QUERY_TOOL',
        'CV_PARSING_TOOL',
        'INDEX_SEARCH_TOOL',
        'MATCHING_TOOL',
        'SMS_TOOL',
        'PHONE_TOOL',
        'SMTP_TOOL',
        'CALENDAR_TOOL',
        'KNOWLEDGE_RETRIEVER_TOOL',
        'DOCUMENT_FILL_TOOL',
        'EXTERNAL_SERVICE_TOOL',
        'CREATE_PROFILE_TOOL',
        'URL_PARSER_TOOL',
        'COMMUNICATION_SCHEDULER_TOOL',
        'GATHER_COMPANY_INFO_TOOL',
        'DB_UPDATE_TOOL'
      ];

      console.log("Using hardcoded fallback tools:", defaultTools);
      return defaultTools;
    }
  }

  async getToolsInfo() {
    try {
      const toolInfoSnap = await this.app2.firestore.collection(FirebaseConstants.systemConfig).doc("tool_infos_mapping").get();

      if (toolInfoSnap.exists) {
        const toolInfos = toolInfoSnap.data();
        const toolInfosData = Object.values(toolInfos);
        return toolInfosData;
      } else {
        console.warn("Tool info mapping document does not exist in Firebase, using local fallback");
      }
    } catch (error) {
      console.error("Failed to fetch tool info from Firebase:", error);
      console.log("Using local fallback tool_infos_mapping.json");
    }

    // Fallback to local JSON file
    try {
      const toolInfosMapping = await import('../mona-agent-builder/tool_infos_mapping.json');
      const toolInfosData = Object.values(toolInfosMapping.default || toolInfosMapping);
      console.log("Successfully loaded tool info from local fallback");
      return toolInfosData;
    } catch (fallbackError) {
      console.error("Failed to load local tool_infos_mapping.json:", fallbackError);
      return null;
    }
  }

  // General agent creation method using unified endpoint
  // async createAgent(agentData: any): Promise<any> {
  //   const apiKey = await this.getApiKey();
  //   const uid = this.returnUserId();
  //   // Convert tool names to tool IDs
  //   const toolIds = this.convertToolNamesToIds(agentData.agentConfig?.tools || []);

  //   const payload = {
  //     apiKey: apiKey,
  //     uid: uid,
  //     permission: "pushAgents",
  //     name: agentData.name,
  //     description: agentData.description,
  //     tools: toolIds,
  //     icon: agentData.icon || '',  // Include icon field for custom agents
  //     image: agentData.icon || agentData.image || '',  // Also include image for consistency
  //     agentData: agentData
  //   };

  //   console.log("createAgent payload", payload);

  //   try {
  //     const response: any = await this.http.post('https://api.mona-ai.cloud/agent/createAgent', payload, {
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     }).toPromise();
  //     return response;
  //   } catch (error) {
  //     console.error('Error creating agent:', error);
  //     throw error;
  //   }
  // }

  async createCustomAgent(name: string, description?: string, toolIds?: number[], agentData?: any): Promise<any> {
    const apiKey = await this.getApiKey();
    const uid = this.returnUserId();

    let finalDescription = description || '';
    if (finalDescription.length < 100) {
      finalDescription = finalDescription.padEnd(100, ' ');
    }
    if (finalDescription.length > 1000) {
      finalDescription = finalDescription.substring(0, 1000);
    }

    const payload: any = {
      endpoint: "createCustomAgent",
      uid: uid,
      permission: "pushAgents",
      apiKey: apiKey,
      name: name,
      description: finalDescription
    };

    if (toolIds && toolIds.length > 0) {
      payload.tools = toolIds;
    }

    console.log("createCustomAgent payload", payload);

    try {
      const response: any = await this.http.post('https://api.mona-ai.cloud/agent/createCustomAgent', payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiKey}`
        }
      }).toPromise();
      try { await this.enableAllToolsInBranding(); } catch (e) { console.warn('Failed to enable all tools in branding after custom agent creation:', e); }

      if (agentData && response && (response.id || response.docId || response.agentId)) {
        const createdId = response.id || response.docId || response.agentId;
        try {
          await this.updateAgentFirestore({
            id: createdId,
            icon: agentData.icon,
            viewerRights: agentData.viewerRights
          });
        } catch (e) { console.warn('Failed to update agent Firestore data:', e); }
      }

      return response;
    } catch (error) {
      console.error('Error creating custom agent:', error);
      throw error;
    }
  }

  private async enableAllToolsInBranding(): Promise<void> {
    try {
      const db = this.app2 && this.app2.firestore;
      if (!db) { return; }
      const snap = await db.collection('branding').limit(1).get();

      const allToolKeys = [
        'DB_QUERY_TOOL',
        'CV_PARSING_TOOL',
        'INDEX_SEARCH_TOOL',
        'CREATE_JOB_OFFER_TOOL',
        'PHONE_TOOL',
        'MATCHING_TOOL',
        'DB_UPDATE_TOOL',
        'EMAIL_TOOL',
        'KNOWLEDGE_RETRIEVER_TOOL',
        'DOCUMENT_FIELDS_EXTRACTOR_TOOL',
        'DOCUMENT_FILL_TOOL',
        'EXTERNAL_SERVICE_TOOL',
        'CREATE_PROFILE_TOOL',
        'URL_PARSER_TOOL',
        'EMAIL_ATTACHMENT_TOOL',
        'SMTP_TOOL',
        'CALENDAR_TOOL',
        'COMMUNICATION_SCHEDULER_TOOL',
        'SMS_TOOL',
        'BROWSER_USE_TOOL',
        'CODEACT_DOC_GENERATOR_TOOL',
        'ENRICHMENT_PEOPLE_SEARCH_TOOL',
        'ENRICHMENT_ORGANIZATION_SEARCH_TOOL'
      ];
      const enableMap: any = {};
      allToolKeys.forEach(k => enableMap[k] = true);

      if (snap.empty) {
        await db.collection('branding').add({ allowed_tools: enableMap });
      } else {
        const ref = snap.docs[0].ref;
        const data: any = snap.docs[0].data() || {};
        const current: any = data.allowed_tools || {};
        const merged = { ...(Array.isArray(current) ? {} : current) };
        allToolKeys.forEach(k => { merged[k] = true; });
        await ref.update({ allowed_tools: merged });
      }
    } catch (err) {
      console.error('enableAllToolsInBranding failed:', err);
    }
  }

  // Create Monari agent using specific endpoint
  async createMonariAgent(agentData: any): Promise<any> {
    // The API key is minted for the auth user, so the payload uid has to match it
    const uid = this.returnUserId() || this.authService.returnUserId();
    agentData = agentData || {};
    const name = String(agentData?.name || 'Agent').trim() || 'Agent';
    const greeting = String(
      agentData?.greeting_message
      || agentData?.agentConfig?.greeting_message
      || agentData?.language?.greeting_message
      || agentData?.language?.de?.greeting_message
      || agentData?.language?.en?.greeting_message
      || ''
    ).trim() || `Hello! I am ${name}.`;
    const role = agentData?.specialty || 'AI Assistant';
    const locale = (block: any) => {
      const row = (block && typeof block === 'object' && !Array.isArray(block)) ? { ...block } : {};
      row.greeting_message = String(row.greeting_message || '').trim() || greeting;
      if (!row.role) { row.role = role; }
      if (!Array.isArray(row.prompt_suggestions)) { row.prompt_suggestions = []; }
      return row;
    };
    const incoming = (agentData?.language && typeof agentData.language === 'object')
      ? { ...agentData.language }
      : {};
    const language: any = {
      ...incoming,
      greeting_message: greeting,
      de: locale(incoming.de),
      en: locale(incoming.en)
    };
    const payload: any = {
      uid: uid,
      permission: "pushAgents",
      collection_type: "monari_agents",
      name,
      image: agentData.icon || agentData.image || agentData.avatar || '',
      icon: agentData.icon || '',
      expertise_areas: agentData.agentConfig?.expertise_areas || agentData.expertise_areas || [],
      greeting_message: greeting,
      system_prompt: agentData.agentConfig?.instructions || agentData.system_prompt || '',
      specialty: role,
      gradient_from: agentData.gradient_from || '#4F46E5',
      gradient_to: agentData.gradient_to || '#7C3AED',
      tools: agentData.tools || agentData.agentConfig?.tools || [],
      userId: agentData.userId || uid,
      language
    };
    // Do not default id to the display name: that path instantiates a prebuilt template and
    // rejects a missing language.greeting_message even when greeting_message is set.
    if (agentData.id) { payload.id = agentData.id; }
    if (agentData.templateId) { payload.templateId = agentData.templateId; }

    console.log("createMonariAgent payload", payload);

    // A freshly minted key is not always accepted immediately, so retry with a
    // refreshed key whenever the API rejects the current one.
    let key = await this.getApiKey();
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const response: any = await this.http.post('https://api.mona-ai.cloud/agent/createMonariAgent', payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${key}`
          }
        }).toPromise();
        return response;
      } catch (error) {
        const msg = String(error?.error?.message || error?.message || '').toLowerCase();
        const shouldRefresh = error?.status === 401 || msg.includes('unauthorized') || msg.includes('api key');
        if (!shouldRefresh || attempt === 2) {
          console.error('Error creating Monari agent:', error);
          throw error;
        }
        key = await this.generateFreshApiKey();
        await new Promise(resolve => setTimeout(resolve, attempt === 0 ? 1000 : 2000));
      }
    }
  }

  async createAgent(agentData: any): Promise<any> {
    if (agentData.typeOfAgent === 'monari') {
      return this.createMonariAgent(agentData);
    } else {
      const name = agentData.name;
      const description = agentData.description || agentData.agentConfig?.instructions || '';
      const toolNames = agentData.agentConfig?.tools || [];
      const toolIds = this.convertToolNamesToIds(toolNames);
      return this.createCustomAgent(name, description, toolIds, agentData);
    }
  }


  private convertToolNamesToIds(toolNames: string[]): number[] {
    const toolIds: number[] = [];

    try {
      const toolNameToIdMap: { [key: string]: number } = {
        'DB_QUERY_TOOL': 1,
        'CV_PARSING_TOOL': 2,
        'INDEX_SEARCH_TOOL': 3,
        'CREATE_JOB_OFFER_TOOL': 4,
        'PHONE_TOOL': 5,
        'MATCHING_TOOL': 6,
        'DB_UPDATE_TOOL': 7,
        'EMAIL_TOOL': 8,
        'KNOWLEDGE_RETRIEVER_TOOL': 9,
        'DOCUMENT_FIELDS_EXTRACTOR_TOOL': 10,
        'DOCUMENT_FILL_TOOL': 11,
        'EXTERNAL_SERVICE_TOOL': 12,
        'CREATE_PROFILE_TOOL': 13,
        'URL_PARSER_TOOL': 14,
        'EMAIL_ATTACHMENT_TOOL': 15,
        'SMTP_TOOL': 16,
        'CALENDAR_TOOL': 17,
        'COMMUNICATION_SCHEDULER_TOOL': 18,
        'SMS_TOOL': 19,
        'BROWSER_USE_TOOL': 20,
        'CODEACT_DOC_GENERATOR_TOOL': 21,
        'ENRICHMENT_PEOPLE_SEARCH_TOOL': 22,
        'ENRICHMENT_ORGANIZATION_SEARCH_TOOL': 23,
        'GATHER_COMPANY_INFO_TOOL': 24
      };

      const aliasToCanonical: { [key: string]: string } = {
        'PHONE_CALL_TOOL': 'PHONE_TOOL',
        'CALL_TOOL': 'PHONE_TOOL',
        'PHONE': 'PHONE_TOOL',
        'CALL': 'PHONE_TOOL',
        'EMAIL': 'EMAIL_TOOL',
        'MAIL_TOOL': 'EMAIL_TOOL',
        'MAIL': 'EMAIL_TOOL',
        'SMTP': 'SMTP_TOOL',
        'SMS': 'SMS_TOOL',
        'TEXT_TOOL': 'SMS_TOOL',
        'TEXT': 'SMS_TOOL',
        // Database variations
        'DB_TOOL': 'DB_QUERY_TOOL',
        'DATABASE_TOOL': 'DB_QUERY_TOOL',
        'QUERY_TOOL': 'DB_QUERY_TOOL',
        'DB': 'DB_QUERY_TOOL',
        'DATABASE': 'DB_QUERY_TOOL',
        // Update tool variations
        'UPDATE_TOOL': 'DB_UPDATE_TOOL',
        'DATABASE_UPDATE_TOOL': 'DB_UPDATE_TOOL',
        'DB_UPDATE': 'DB_UPDATE_TOOL',
        // CV/Resume variations
        'CV_TOOL': 'CV_PARSING_TOOL',
        'CV_PARSER': 'CV_PARSING_TOOL',
        'RESUME_TOOL': 'CV_PARSING_TOOL',
        'RESUME_PARSER': 'CV_PARSING_TOOL',
        'CV': 'CV_PARSING_TOOL',
        // Index/Search variations
        'INDEX_TOOL': 'INDEX_SEARCH_TOOL',
        'SEARCH_TOOL': 'INDEX_SEARCH_TOOL',
        'JOB_SEARCH_TOOL': 'INDEX_SEARCH_TOOL',
        'INDEX': 'INDEX_SEARCH_TOOL',
        // Knowledge variations
        'KNOWLEDGE_TOOL': 'KNOWLEDGE_RETRIEVER_TOOL',
        'KNOWLEDGE': 'KNOWLEDGE_RETRIEVER_TOOL',
        'KB_TOOL': 'KNOWLEDGE_RETRIEVER_TOOL',
        // Document variations
        'DOCUMENT_TOOL': 'DOCUMENT_FILL_TOOL',
        'DOC_FILL_TOOL': 'DOCUMENT_FILL_TOOL',
        'DOCX_TOOL': 'DOCUMENT_FILL_TOOL',
        'DOCUMENT': 'DOCUMENT_FILL_TOOL',
        // External service variations
        'EXTERNAL_TOOL': 'EXTERNAL_SERVICE_TOOL',
        'SERVICE_TOOL': 'EXTERNAL_SERVICE_TOOL',
        'API_TOOL': 'EXTERNAL_SERVICE_TOOL',
        // Profile variations
        'PROFILE_TOOL': 'CREATE_PROFILE_TOOL',
        'PROFILE': 'CREATE_PROFILE_TOOL',
        // URL variations
        'URL_TOOL': 'URL_PARSER_TOOL',
        'URL': 'URL_PARSER_TOOL',
        'LINK_PARSER': 'URL_PARSER_TOOL',
        // Calendar variations
        'CALENDAR': 'CALENDAR_TOOL',
        'MEETING_TOOL': 'CALENDAR_TOOL',
        'APPOINTMENT_TOOL': 'CALENDAR_TOOL',
        // Scheduler variations
        'SCHEDULER_TOOL': 'COMMUNICATION_SCHEDULER_TOOL',
        'SCHEDULE_TOOL': 'COMMUNICATION_SCHEDULER_TOOL',
        'COMM_SCHEDULER': 'COMMUNICATION_SCHEDULER_TOOL',
        // Company info variations
        'COMPANY_TOOL': 'GATHER_COMPANY_INFO_TOOL',
        'COMPANY_INFO_TOOL': 'GATHER_COMPANY_INFO_TOOL',
        'COMPANY_INFO': 'GATHER_COMPANY_INFO_TOOL',
        // Apollo variations
        'APOLLO_PEOPLE': 'ENRICHMENT_PEOPLE_SEARCH_TOOL',
        'PEOPLE_SEARCH': 'ENRICHMENT_PEOPLE_SEARCH_TOOL',
        'APOLLO_PERSON': 'ENRICHMENT_PEOPLE_SEARCH_TOOL',
        'APOLLO_ORG': 'ENRICHMENT_ORGANIZATION_SEARCH_TOOL',
        'APOLLO_COMPANY': 'ENRICHMENT_ORGANIZATION_SEARCH_TOOL',
        'ORG_SEARCH': 'ENRICHMENT_ORGANIZATION_SEARCH_TOOL',
        // Browser variations
        'BROWSER_TOOL': 'BROWSER_USE_TOOL',
        'BROWSER': 'BROWSER_USE_TOOL',
        'WEB_TOOL': 'BROWSER_USE_TOOL',
        'AUTOMATION_TOOL': 'BROWSER_USE_TOOL',
        // CodeAct variations
        'E2B_TOOL': 'CODEACT_DOC_GENERATOR_TOOL',
        'E2B': 'CODEACT_DOC_GENERATOR_TOOL',
        'CODEACT_TOOL': 'CODEACT_DOC_GENERATOR_TOOL',
        'CODEACT': 'CODEACT_DOC_GENERATOR_TOOL',
        'DOC_GENERATOR': 'CODEACT_DOC_GENERATOR_TOOL',
        // Matching variations
        'MATCH_TOOL': 'MATCHING_TOOL',
        'MATCHER': 'MATCHING_TOOL',
        'MATCH': 'MATCHING_TOOL',
        // Email attachment variations
        'ATTACHMENT_TOOL': 'EMAIL_ATTACHMENT_TOOL',
        'FILE_TOOL': 'EMAIL_ATTACHMENT_TOOL',
        'ATTACH_TOOL': 'EMAIL_ATTACHMENT_TOOL',
        // Document extractor variations
        'EXTRACTOR_TOOL': 'DOCUMENT_FIELDS_EXTRACTOR_TOOL',
        'FIELD_EXTRACTOR': 'DOCUMENT_FIELDS_EXTRACTOR_TOOL',
        'EXTRACT_TOOL': 'DOCUMENT_FIELDS_EXTRACTOR_TOOL',
        // Job offer variations
        'JOB_TOOL': 'CREATE_JOB_OFFER_TOOL',
        'JOB_OFFER': 'CREATE_JOB_OFFER_TOOL',
        'JOB_CREATE': 'CREATE_JOB_OFFER_TOOL'
      };

      toolNames.forEach(toolName => {
        // Normalize tool name (convert spaces to underscores, uppercase)
        const normalizedName = toolName.toUpperCase().replace(/\s+/g, '_');
        const canonical = aliasToCanonical[normalizedName] || normalizedName;
        const toolId = toolNameToIdMap[canonical];

        if (toolId) {
          toolIds.push(toolId);
        } else {
          console.warn(`Tool ID not found for tool: ${toolName} (normalized: ${normalizedName}, canonical: ${canonical})`);
        }
      });
    } catch (error) {
      console.error('Error converting tool names to IDs:', error);
    }

    return toolIds;
  }

  async executeAgentTool(tool: string, payload: any): Promise<any> {
    const requestPayload = {
      tool: tool,
      payload: payload
    };

    console.log("executeAgentTool payload", requestPayload);

    try {
      const response: any = await this.http.post('https://api.mona-ai.cloud/agent/tool_execution', requestPayload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).toPromise();
      return response;
    } catch (error) {
      console.error('Error executing agent tool:', error);
      throw error;
    }
  }

  async loadAPIKeys(retryCount = 0, maxRetries = 3) {
    try {
      const firebaseService = this.getFirebaseService();
      const snap = await firebaseService.loadAPIKeys();
      console.log("snap", snap);

      const apiKeys = [];
      if (snap && snap.docs) {
        snap.docs.forEach((doc) => {
          const item = doc.data();
          item.id = doc.id;
          item.hashedKey = item.hashedKey || "";
          item.apiKey = item.apiKey || "";
          item.permissions = item.permissions || "";
          item.active = item.active || false;
          item.createdAt = item.createdAt || "";
          apiKeys.push(item);
        });
      }
      apiKeys.sort((a, b) => {
        const aTime = a.createdAt?.toDate ? a.createdAt.toDate().getTime() : new Date(a.createdAt || 0).getTime();
        const bTime = b.createdAt?.toDate ? b.createdAt.toDate().getTime() : new Date(b.createdAt || 0).getTime();
        return bTime - aTime;
      });
      return apiKeys.slice(0, 10);
    } catch (error) {
      console.error('Error loading API keys:', error);

      if (retryCount < maxRetries && error.message?.includes('not a function')) {
        console.log(`Retrying loadAPIKeys (attempt ${retryCount + 1}/${maxRetries})...`);
        await new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)));
        return this.loadAPIKeys(retryCount + 1, maxRetries);
      }

      return [];
    }
  }

  async getApiKey(): Promise<string> {
    // First check if we have a locally cached API key - but only while it is still inside its
    // server-issued lifetime. This in-memory copy is a SECOND cache in front of AuthService's, so
    // without the freshness gate it would hand back a dead key for the life of the tab and defeat
    // the expiry check entirely.
    if (this.localApiKey) {
      if (this.authService.isApiKeyFresh()) {
        return this.localApiKey;
      }
      this.clearCachedApiKey();
    }

    // Check if AuthService has a cached API key from login
    const authApiKey = await this.authService.returnApiKey();
    if (authApiKey) {
      console.log('Using API key from auth service');
      this.setLocalApiKey(authApiKey);
      return authApiKey;
    }

    // If all retries failed, try to generate a new API key
    console.log('All retries failed, generating new API key');
    try {
      let apiKey = await this.generateApiKeyForUser();
      return apiKey;
    } catch (error) {
      console.error('Failed to generate API key:', error);
      // reroute to login page
      this.router.navigate(['/login']);
      throw new Error('Unable to obtain API key: ' + error.message);
    }
  }

  // Public method to generate fresh API key (used during login)
  async generateFreshApiKey(): Promise<string> {
    return this.generateApiKeyForUser();
  }

  private async generateApiKeyForUser(): Promise<string> {
    if (isPartnerLaunch()) {
      this.authService.clearApiKey();
      const partnerKey = await this.authService.returnApiKey();
      if (!partnerKey) throw new Error('Partner session key unavailable');
      this.setLocalApiKey(partnerKey);
      return partnerKey;
    }
    console.log("[generateApiKeyForUser] Starting API key generation");
    const maxRetries = 3;
    let lastError: any = null;

    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        const uid = this.authService.returnUserId();
        if (!uid) {
          throw new Error('User not authenticated');
        }

        const idToken = await this.authService.getIdToken();
        if (!idToken) {
          console.warn('[generateApiKeyForUser] No Firebase ID token available, attempt', attempt + 1);
          if (attempt < maxRetries - 1) {
            await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
            continue;
          }
        }

        const payload = {
          uid: uid,
          readApplicants: true,
          pushApplicants: true,
          readJobOffers: true,
          pushJobOffers: true,
          readAgents: true,
          pushAgents: true,
          readData: true,
          pushData: true,
          executeAgents: true,
          executeWorkflow: true,
          viewWorkflow: true,
          manageWorkflow: true,
          readTools: true,
          manageTools: true,
          readMatching: true,
          createMatching: true,
          parsing: true
        };

        console.log('[generateApiKeyForUser] Generating API key, attempt', attempt + 1);

        const headers: any = { 'Content-Type': 'application/json' };
        if (idToken) {
          headers['Authorization'] = `Bearer ${idToken}`;
        }

        const response: any = await this.http.post(`${environment.CLOUD_URL_BASE}/api/generateApiKey`, payload, {
          headers
        }).toPromise();

        if (response && response.apiKey) {
          console.log('[generateApiKeyForUser] API key generated, expires', response.expiresAt || 'unknown');
          this.setLocalApiKey(response.apiKey);
          // Carry the server's expiry through - dropping it here is what made a stale key
          // indistinguishable from a live one.
          this.authService.saveApiKey(response.apiKey, response.expiresAt);
          return response.apiKey;
        }
        throw new Error('Failed to generate API key - no apiKey in response');
      } catch (error) {
        lastError = error;
        console.error('[generateApiKeyForUser] Error on attempt', attempt + 1, ':', error?.status || error?.message || error);

        if (error.status === 403) {
          this.presentError("Email address must be verified");
          this.authService.logOut();
          await new Promise(resolve => setTimeout(resolve, 1000));
          this.router.navigateByUrl('login');
          throw error;
        }

        if (error.status === 0 || !error.status) {
          console.warn('[generateApiKeyForUser] Network error (CORS/connection), retrying...');
        }

        if (attempt < maxRetries - 1) {
          const delay = 1000 * Math.pow(2, attempt);
          console.log(`[generateApiKeyForUser] Retrying in ${delay}ms...`);
          await new Promise(r => setTimeout(r, delay));
        }
      }
    }

    console.error('[generateApiKeyForUser] All retries failed:', lastError);
    throw lastError || new Error('Failed to generate API key after retries');
  }

  presentError(message: string) {
    this.toastService.create({
      message: message,
      duration: 120000,
      position: 'top',
      color: 'danger',
      cssClass: 'login-failed-toast',
    }).then((toast) => {
      toast.present();
    });
  }

  public async postRequest(url: string, body: any, options?: any): Promise<any> {
    try {
      return await this.http.post(url, body, options).toPromise();
    } catch (error) {
      console.error('HTTP POST request failed:', error);
      throw error;
    }
  }

  async storeProfileTemplate(templateData: any) {
    return this.app2.firestore
      .collection(FirebaseConstants.profileTemplates)
      .add({
        ...templateData,
        customerNumber: this.getCustomerNumber(),
        created: new Date(),
        createdISO: new Date().toISOString()
      });
  }

  async getProfileTemplates() {
    const snapshot = await this.app2.firestore
      .collection(FirebaseConstants.profileTemplates)
      .where('customerNumber', '==', this.getCustomerNumber())
      .orderBy('created', 'desc')
      .get();

    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  }

  async updateProfileTemplate(templateId: string, templateData: any) {
    return this.app2.firestore
      .collection(FirebaseConstants.profileTemplates)
      .doc(templateId)
      .update({
        ...templateData,
        updated: new Date(),
        updatedISO: new Date().toISOString()
      });
  }

  async deleteProfileTemplate(templateId: string) {
    return this.app2.firestore
      .collection(FirebaseConstants.profileTemplates)
      .doc(templateId)
      .delete();
  }

  async getAgentInfo(agentId: string): Promise<any> {
    const uid = this.returnUserId();
    const payload = { uid: uid, permission: "readAgents", agentId: agentId };

    let key = await this.getApiKey();
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const response: any = await this.http.post('https://api.mona-ai.cloud/agent/getAgentInfo', payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${key}`
          }
        }).toPromise();
        return response;
      } catch (error) {
        const msg = String(error?.error?.message || error?.message || '').toLowerCase();
        const shouldRefresh = error?.status === 401 || msg.includes('unauthorized') || msg.includes('api key');
        if (!shouldRefresh || attempt === 2) {
          throw error;
        }
        key = await this.generateFreshApiKey();
        const delay = attempt === 0 ? 500 : 1000;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }

  // Get agent info directly from Firebase database (no API call)
  async getAgentInfoFromDatabase(agentName: string): Promise<any> {
    if (!this.isDatabaseReady()) {
      throw new Error('Database not initialized yet. Please wait for connection.');
    }
    if (!agentName) return;

    try {
      const snapshot = await this.app2.firestore
        .collection(FirebaseConstants.agents)
        .where('name', '==', agentName)
        .get();

      if (snapshot.empty) {
        console.log(`No agent found with name: ${agentName}`);
        return null;
      }

      // Return the first matching agent data
      const agentDoc = snapshot.docs[0];
      const agentData = agentDoc.data();

      return {
        id: agentDoc.id,
        name: agentData.name,
        description: agentData.description,
        typeOfAgent: agentData.typeOfAgent,
        active: agentData.active !== false,
        icon: agentData.icon,
        agentConfig: agentData.agentConfig,
        ...agentData // Include any additional fields
      };
    } catch (error) {
      console.error(`Error fetching agent info for ${agentName}:`, error);
      throw error;
    }
  }

  setTutorialDone() {
    console.log(this.userId)
    this.coolStore.firestore.collection("customers").doc(this.userId).update({
      isTutorialDone: true
    });
  }


  saveCompanyKnowledgeStructure(structure) {
    return this.app2.firestore.collection("users").doc(this.userId).update({
      structure: structure
    });
  }
  private companyKnowledgeStructure: BehaviorSubject<any[]> = new BehaviorSubject<any>([]);
  public companyKnowledgeStructure$ = this.companyKnowledgeStructure.asObservable();

  getCompanyKnowledgeStructure() {
    return this.app2.firestore.collection("users").doc(this.userId).get().then((snap) => {
      if (snap.exists) {
        const data = snap.data();
        if (data && data.structure) {
          this.companyKnowledgeStructure.next(data.structure);
        }
      }
    });
  }

  deleteFileFromStorage(path: string) {
    // return; //todo
    const fileRef = this.customerStorage.ref(path);
    return fileRef.delete();
  }

  private _chosenAgents: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public chosenAgents$ = this._chosenAgents.asObservable();
  getChosenAgents() {
    console.log('CustomerdatabaseService: Fetching chosen agents...');
    this.app2.firestore.collection("users").doc(this.userId).get().then((snap) => {
      if (snap.exists) {
        const chosenAgentsData = snap.data()?.chosenAgents ?? [];
        console.log('CustomerdatabaseService: Fetched chosen agents:', chosenAgentsData);
        this._chosenAgents.next(chosenAgentsData);
      } else {
        console.log('CustomerdatabaseService: User document does not exist, no chosen agents.');
        this._chosenAgents.next([]);
      }
    }).catch(error => {
      console.error('CustomerdatabaseService: Error fetching chosen agents:', error);
      this._chosenAgents.next([]);
    });
  }

  updateChosenAgents(agent: string, checked: boolean) {
    let chosenAgents = this._chosenAgents.getValue();
    if (checked) {
      chosenAgents.push(agent);
    } else {
      chosenAgents = chosenAgents.filter(a => a !== agent);
    }
    this._chosenAgents.next(chosenAgents);
    if (!this.userId || this.userId === '') {
      return;
    }
    this.app2.firestore.collection("users").doc(this.userId).update({
      chosenAgents: chosenAgents
    });
  }


  private _chosenWorkflows: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public chosenWorkflows$ = this._chosenWorkflows.asObservable();
  getChosenWorkflows() {
    return this.app2.firestore.collection("users").doc(this.userId).get().then((snap) => {
      this._chosenWorkflows.next(snap.data()?.chosenWorkflows ?? []);
    })
  }

  updateChosenWorkflow(workflow: string, checked: boolean) {
    let chosenWorkflows = this._chosenWorkflows.getValue();
    if (checked) {
      chosenWorkflows.push(workflow);
    } else {
      chosenWorkflows = chosenWorkflows.filter(a => a !== workflow);
    }
    this._chosenWorkflows.next(chosenWorkflows);
    if (!this.userId || this.userId === '') {
      return;
    }
    this.app2.firestore.collection("users").doc(this.userId).update({
      chosenWorkflows: chosenWorkflows
    });
  }


  updateUserPhotoURL(photoURL: string): Promise<void> {
    return this.app2.firestore.collection("users").doc(this.userId).update(
      {
        photoURL: photoURL,
      }
    )
  }

  updateUserName(name: string): Promise<void> {
    return this.app2.firestore.collection("users").doc(this.userId).update(
      {
        nickname: name,
      })
  }

  private _photoUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public photoUrl$ = this._photoUrl.asObservable();
  getUserPhotoURL() {
    if (!this.userId || this.userId === '') {
      return;
    }
    this.app2.firestore.collection("users").doc(this.userId).get().then((snap) => {
      const data = snap.data();
      this._photoUrl.next(data?.photoURL || '');
    });
  }

  private _nickname: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public nickname$ = this._nickname.asObservable();
  getUserName() {
    if (!this.userId || this.userId === '') {
      return;
    }
    this.app2.firestore.collection("users").doc(this.userId).get().then((snap) => {
      const data = snap.data();
      this._nickname.next(data?.nickname || '');
    })
  }

  private _userSettings: BehaviorSubject<{ language: string, businessCasual: string, messageLength: string, webSearchEnabled: boolean }>
    = new BehaviorSubject<{ language: string, businessCasual: string, messageLength: string, webSearchEnabled: boolean }>({
      language: 'DE',
      businessCasual: 'Friendly',
      messageLength: 'short',
      webSearchEnabled: false
    });
  public userSettings$ = this._userSettings.asObservable();
  getUserSettings() {
    if (!this.userId || this.userId === '') {
      return;
    }
    this.app2.firestore.collection("users").doc(this.userId).get().then((snap) => {
      const data = snap.data();
      this._userSettings.next(data?.userSettings ?? { language: 'DE', businessCasual: 'Friendly', messageLength: 'short', webSearchEnabled: false });
    })
  }

  saveUserSettings(language: string, businessCasual: string, messageLength: string, webSearchEnabled: boolean): Promise<void> {
    if (!this.userId || this.userId === '') {
      return Promise.reject('User ID is not set');
    }
    return this.app2.firestore.collection("users").doc(this.userId).update({
      userSettings: {
        language: language,
        businessCasual: businessCasual,
        messageLength: messageLength,
        webSearchEnabled: webSearchEnabled
      }
    })
  }

  private _agentsList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public agentsList$ = this._agentsList.asObservable();

  getAgentsList() {
    // Load agents from both collections
    const promises = [
      this.app2.firestore.collection('monari_agents').get(),
      this.app2.firestore.collection('agents').get()
    ];

    return Promise.all(promises).then(([monariSnap, agentsSnap]) => {
      const allAgents = [];

      // Add monari_agents
      if (monariSnap.docs.length > 0) {
        const monariAgents = monariSnap.docs.map(doc => ({
          ...doc.data(),
          id: doc.id,
          source: 'monari_agents'
        }));
        allAgents.push(...monariAgents);
      }

      // Add agents
      if (agentsSnap.docs.length > 0) {
        const agents = agentsSnap.docs.map(doc => ({
          ...doc.data(),
          id: doc.id,
          source: 'agents'
        }));
        allAgents.push(...agents);
      }

      this._agentsList.next(allAgents);
      return allAgents;
    });
  }

  getMonariAgentsCollection() {
    return this.app2.firestore.collection('monari_agents');
  }

  getMonariAgentDocument(agentId: string) {
    return this.app2.firestore.collection('monari_agents').doc(agentId);
  }

  getMonariAgentsChatHistory(agentId: string) {
    return this.app2.firestore.collection('monari_chat_history_frontend').doc(agentId).collection(this.authService.returnUserId());
  }

  // Get agent documents from the agentDocuments collection
  async getAgentDocuments(agentId: string): Promise<string[]> {
    try {
      const userId = this.returnUserId();
      console.log('Getting agent documents for:', agentId, 'with userId:', userId);
      console.log('Using exact same path structure as uploadContextCache');

      // Use exact same path structure as uploadContextCache
      const docRef = this.app2.firestore
        .collection('users')
        .doc(userId)
        .collection('agentDocuments')
        .doc(agentId);

      const docSnap = await docRef.get();

      if (docSnap.exists) {
        const data = docSnap.data();
        console.log('Agent documents found for', agentId, ':', data?.files?.length || 0, 'files');
        console.log('Raw document data:', data);
        return data?.files || [];
      } else {
        console.log('No agent documents found for:', agentId);
      }
      return [];
    } catch (error) {
      console.error('Error fetching agent documents for', agentId, ':', error);
      return [];
    }
  }

  // Get all agent documents for all agents
  async getAllAgentDocuments(): Promise<{ [agentId: string]: string[] }> {
    try {
      const userId = this.returnUserId();
      console.log('Getting all agent documents for userId:', userId);
      console.log('Using exact same path structure as uploadContextCache');

      // Use exact same path structure as uploadContextCache
      const collectionRef = this.app2.firestore
        .collection('users')
        .doc(userId)
        .collection('agentDocuments');

      const querySnap = await collectionRef.get();
      const allDocuments: { [agentId: string]: string[] } = {};

      console.log('Found', querySnap.size, 'agent document collections in agentDocuments');
      console.log('Collection empty?', querySnap.empty);

      querySnap.forEach(doc => {
        const data = doc.data();
        console.log(`Agent ${doc.id} has`, data?.files?.length || 0, 'files');
        console.log(`Raw data for ${doc.id}:`, data);

        allDocuments[doc.id] = data?.files || [];

        if (data?.files && data.files.length > 0) {
          console.log(`Files for agent ${doc.id}:`, data.files);
        }
      });

      console.log('Final allDocuments result:', allDocuments);
      return allDocuments;
    } catch (error) {
      console.error('Error fetching all agent documents:', error);
      return {};
    }
  }

  // Org charts storage
  getOrgChartsCollection() {
    return this.app2 && this.app2.firestore ? this.app2.firestore.collection('org_charts') : firebase.firestore().collection('org_charts');
  }

  async saveOrgChart(payload: any) {
    const accountId = this.getAccountId() || '';
    const data = {
      ...payload,
      ownerAccountId: accountId,
      updated: new Date(),
      updatedISO: new Date().toISOString(),
    };
    if (payload.id) {
      await this.getOrgChartsCollection().doc(payload.id).set(data, { merge: true });
      return payload.id;
    } else {
      const doc = await this.getOrgChartsCollection().add({
        ...data,
        created: new Date(),
        createdISO: new Date().toISOString(),
      });
      return doc.id;
    }
  }

  async listOrgChartsByOwner() {
    const accountId = this.getAccountId() || '';
    const query = accountId ? this.getOrgChartsCollection().where('ownerAccountId', '==', accountId) : this.getOrgChartsCollection();
    const snap = await query.get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  }

  async getOrgChart(id: string) {
    const doc = await this.getOrgChartsCollection().doc(id).get();
    return doc.exists ? { id: doc.id, ...doc.data() } : null;
  }

  async deleteOrgChart(id: string) {
    await this.getOrgChartsCollection().doc(id).delete();
  }

  saveOnboardingData(data) {
    if (!this.userId || this.userId === '') {
      return Promise.reject('User ID is not set');
    }
    //auto update nickname
    if (data.nickname) {
      this._nickname.next(data.nickname);
    }
    return this.app2.firestore.collection("users").doc(this.userId).update({
      nickname: data.nickname.trim() ?? '',
      website: data.websites.trim() ?? '',
      companySize: data.company_size ?? '',
      jobTitle: data.job_title.trim() ?? '',
      industry: data.industry.trim() ?? '',
      goals: data.goals.trim() ?? '',
    });
  }

  // Agent pinning methods
  async saveAgentPinnedState(agentId: string, pinned: boolean): Promise<void> {
    if (!this.userId || this.userId === '') {
      console.error('No user ID available for saving pinned state');
      throw new Error('No user ID');
    }

    try {
      const userPinnedAgentsRef = this.app2.firestore
        .collection('pinnedAgents')
        .doc(agentId);

      if (pinned) {
        await userPinnedAgentsRef.set({
          agentId: agentId,
          pinned: true,
          pinnedAt: new Date()
        });
        console.log(`Agent ${agentId} pinned successfully`);
      } else {
        await userPinnedAgentsRef.delete();
        console.log(`Agent ${agentId} unpinned successfully`);
      }
    } catch (error) {
      console.error('Error saving agent pinned state:', error);
      throw error;
    }
  }

  async getPinnedAgents(): Promise<string[]> {
    if (!this.userId || this.userId === '') {
      console.error('No user ID available for loading pinned agents');
      return [];
    }

    try {
      const pinnedSnapshot = await this.app2.firestore
        .collection('pinnedAgents')
        .get();

      const pinnedAgentIds = pinnedSnapshot.docs.map(doc => doc.data().agentId);
      console.log('Loaded pinned agents from database:', pinnedAgentIds);
      return pinnedAgentIds;
    } catch (error) {
      console.error('Error loading pinned agents:', error);
      return [];
    }
  }

  saveRecommendedAgents(agentsList: string[]) {
    if (!this.userId || this.userId === '') {
      return;
    }
    console.log("saveRecommendedAgents", agentsList);
    this._chosenAgents.next(agentsList);
    return this.app2.firestore.collection("users").doc(this.userId).update({
      chosenAgents: agentsList
    });

  }

  createEmailBasedOnOnboarding(onboardingData: any) {
    if (!this.userId || this.userId === '') {
      return;
    }
    if (this.customerNumber !== 100001) {
      return; // Only create email for customer 100001
    }
    try {
      this.app2.firestore.collection("branding").doc(this.userId).get().then((snap) => {
        if (snap && snap.exists) {
          const data = snap.data();
          if (data && data.smtpEmail) {
            return;
          } else {
            this._createEmailFromOnboardingInternal(onboardingData);
          }
        } else {
          this._createEmailFromOnboardingInternal(onboardingData);
        }
      });
      return;
    } catch { }
    console.log("onboardingData", onboardingData);
    this.generateEmail(onboardingData).then((result) => {
      const email = result.email;
      const password = result.password;
      console.log("Generated Email:", email);
      this.app2.firestore.collection("branding").doc(this.userId).set({
        smtpEmail: email,
        smtpHost: 'mail.mona-ai.online',
        smtpPort: 465,
        smtpPassword: password,
      }, { merge: true }).then(() => {
        console.log("Email updated successfully");
      }).catch((error) => {
        console.error("Error updating email:", error);
      });
    })
  }

  private _createEmailFromOnboardingInternal(onboardingData: any) {
    console.log("onboardingData", onboardingData);
    this.generateEmail(onboardingData).then((result) => {
      const email = result.email;
      const password = result.password;
      console.log("Generated Email:", email);
      this.app2.firestore.collection("branding").doc(this.userId).set({
        smtpEmail: email,
        smtpHost: '7e6e417.online-server.cloud:8443',
        smtpPort: 465,
        smtpPassword: password,
      }, { merge: true }).then(() => {
        console.log("Email updated successfully");
      }).catch((error) => {
        console.error("Error updating email:", error);
      });
    })
  }

  private generateEmail(onboardingData): Promise<{ email: string, password: string }> {
    let nickname = onboardingData.nickname?.trim()?.toLowerCase().replace(/ +/g, '.') ?? Math.random().toString(36).substring(2, 8)
    if (nickname.length < 3) {
      nickname = Math.random().toString(36).substring(2, 8); // Generate a random nickname if too short
    }
    let industry = '';
    switch (onboardingData.industry) {
      case 'other':
        industry = '';
        break;
      default:
        industry = onboardingData.industry?.trim()?.toLowerCase().replace(/ +/g, '.');
        break;
    }
    return this.sendRequestToCreateEmail(nickname, industry);
  }

  sendRequestToCreateEmail(nickname, industry): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        if (this.userId && this.userId !== '') {
          const snap = await this.app2.firestore.collection("branding").doc(this.userId).get();
          if (snap && snap.exists) {
            const data = snap.data();
            if (data && data.smtpEmail) {
              resolve({ email: data.smtpEmail, password: data.smtpPassword || '' });
              return;
            }
          }
        }
      } catch { }
      const randomToken = Math.random().toString(36).substring(2, 8); // Generate a random token
      const emailName = `${nickname}.${industry}.${randomToken}`;
      const sanitizeEmail = this.sanitizeEmail(emailName);
      const password = this.generateRandomPassword(16);

      const body = { email: sanitizeEmail, password: password };

      this.http.post('https://europe-west3-mona-test1.cloudfunctions.net/create_email_customer', body).toPromise().then((response) => {

        console.log("Email creation request sent successfully", response);
        resolve({ email: sanitizeEmail, password: password });
      }).catch((error) => {
        console.error("Error sending email creation request", error);
        if (error.status === 400) {
          this.sendRequestToCreateEmail(nickname, industry); // Retry on error
        } else {
          //another error, sleep first, then retry
          setTimeout(() => {
            this.sendRequestToCreateEmail(nickname, industry);
          }, 5000)
        }
      });
    });
  }

  sanitizeEmail(input: string): string {
    // Allow only safe characters in local part
    const local = input.replace(/[^a-zA-Z0-9._%+-]/g, '');
    const cleanedMultipleDots = local.replace(/\.+/g, '.'); // replace multiple dots with a single dot
    const cleanedDotsStartAndEnd = cleanedMultipleDots.replace(/^\.|\.$/g, "");

    return `${cleanedDotsStartAndEnd}@mona-ai.online`;
  }
  generateRandomPassword(length: number): string {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  }

  checkIfUserHasOnboardingData(): Promise<boolean> {
    if (!this.userId || this.userId === '') {
      return Promise.resolve(false);
    }
    return new Promise((resolve) => {
      this.app2.firestore.collection("users").doc(this.userId).get().then((snap) => {
        if (snap.exists) {
          const data = snap.data();
          if (data.nickname && data.website && data.companySize && data.jobTitle && data.industry && data.goals) {
            resolve(true);
          }
        }
        resolve(false);
      }).catch((err) => {
        console.error("Error checking onboarding data:", err);
        resolve(false);
      });
    });
  }

  checkIfUserHasCustomEmail() {
    return new Promise((resolve) => {
      this.app2.firestore.collection("branding").get().then((snap) => {
        if (snap.docs.length > 0) {
          const data = snap.docs[0].data();
          if (data.smtpEmail && data.smtpHost && data.smtpPort && data.smtpPassword) {
            resolve(true);
          }
        }
        resolve(false);
      }).catch((err) => {
        resolve(false);
      })
    })
  }

  checkIfUserHasRecommendedAgents(): Promise<boolean> {
    let dataExists = false;
    return new Promise((resolve) => {
      this.app2.firestore.collection("users").doc(this.userId).get().then((snap) => {
        if (snap.exists) {
          const data = snap.data();
          if (data.chosenAgents && data.chosenAgents.length > 0) {
            dataExists = true;
          }
        }
        resolve(dataExists);
      }).catch((err) => {
        resolve(false)
      })
    });
  }

  async getFile(fileUri): Promise<string> {
    if (!fileUri) {
      throw new Error("Invalid file URI");
    }

    try {
      const url = await this.customerStorage.ref(fileUri).getDownloadURL().toPromise();
      return url;
    } catch (err) {
      console.error("Error getting file:", err);
      throw err;
    }
  }

  async generateLongLivedApiKey(duration: 30 | 60 | 90 | 180 | 365 | 3650): Promise<{ apiKey: string; expiresAt: string; duration: number; permissions: any; }> {
    const existingKey = await this.authService.returnApiKey();
    if (!existingKey) {
      throw new Error('No existing API key available');
    }
    const url = `${environment.CLOUD_URL_BASE}/api/generateLongLivedApiKey`;
    const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${existingKey}` };
    const body = { duration };
    const resp: any = await this.http.post(url, body, { headers }).toPromise();
    if (!resp || !resp.success || !resp.apiKey) {
      throw new Error(resp?.message || 'Failed to generate long-lived API key');
    }
    return { apiKey: resp.apiKey, expiresAt: resp.expiresAt, duration: resp.duration, permissions: resp.permissions };
  }

  async updateWfIdImapArray(wfId, emailAdress) {
    return this.app2.firestore.collection(FirebaseConstants.branding).get().then((snap) => {
      snap.forEach((doc) => {
        const imapArray = doc.data().imapArray || [];
        for (const mail of imapArray) {
          if (mail.email == emailAdress) {
            mail.workflowId = wfId;
            doc.ref.update({ imapArray }).then(() => {
              return Promise.resolve(true);
            })
          }
        }
      });
      return Promise.resolve(false);
    });
  }

  async saveTeamConnection(connection: any): Promise<void> {
    return this.app2.firestore.collection('teamConnections').doc(connection.id).set(connection);
  }

  async getTeamConnection(connectionId: string): Promise<any> {
    const doc = await this.app2.firestore.collection('teamConnections').doc(connectionId).get();
    return doc.exists ? { id: doc.id, ...doc.data() } : null;
  }

  async updateTeamConnection(connectionId: string, data: any): Promise<void> {
    return this.app2.firestore.collection('teamConnections').doc(connectionId).update(data);
  }

  async saveEntityConnection(connection: any): Promise<void> {
    return this.app2.firestore.collection('entityConnections').doc(connection.id).set(connection);
  }

  async getEntityConnections(): Promise<any[]> {
    const snap = await this.app2.firestore.collection('entityConnections').get();
    return snap.docs.map((d: any) => ({ id: d.id, ...d.data() }));
  }

  async deleteEntityConnection(connectionId: string): Promise<void> {
    return this.app2.firestore.collection('entityConnections').doc(connectionId).delete();
  }

  async saveTeamTrigger(trigger: any): Promise<void> {
    return this.app2.firestore.collection('teamTriggers').doc(trigger.id).set(trigger);
  }

  async getTeam(teamId: string): Promise<any> {
    const doc = await this.app2.firestore.collection('teams').doc(teamId).get();
    return doc.exists ? { id: doc.id, ...doc.data() } : null;
  }

  subscribeToCollection(collectionName: string, filters: any[], callback: (docs: any[]) => void): any {
    let query: any = this.app2.firestore.collection(collectionName);

    for (const filter of filters) {
      query = query.where(filter[0], filter[1], filter[2]);
    }

    return query.onSnapshot((snapshot: any) => {
      const docs = snapshot.docs.map((doc: any) => ({
        id: doc.id,
        ...doc.data()
      }));
      callback(docs);
    });
  }

  async callExternalAPI(endpoint: string, data: any): Promise<any> {
    try {
      const response = await this.http.post(endpoint, data).toPromise();
      return response;
    } catch (error) {
      console.error('Error calling external API:', error);
    }
  }

  async updateAgent(agentData: any): Promise<any> {
    const apiKey = await this.getApiKey();
    const uid = this.returnUserId();

    const payload = {
      apiKey: apiKey,
      uid: uid,
      permission: "updateAgents",
      agentId: agentData.id,
      agentData: agentData
    };

    try {
      const response: any = await this.http.post('https://api.mona-ai.cloud/agent/updateAgent', payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).toPromise();
      return response;
    } catch (error) {
      console.error('Error updating agent:', error);
      throw error;
    }
  }

  async sendEmail(options: any): Promise<any> {
    // Use existing email sending functionality
    const url = `${this.cloudFunctionURL}/sendEmail`;
    return this.http.post(url, options).toPromise();
  }

  async sendSMS(options: any): Promise<any> {
    // Use existing SMS sending functionality
    const url = `${this.cloudFunctionURL}/sendSMS`;
    return this.http.post(url, options).toPromise();
  }

  async sendTeamsMessage(options: any): Promise<any> {
    const url = `${this.cloudFunctionURL}/sendTeamsMessage`;
    return this.http.post(url, options).toPromise();
  }

  async sendWhatsAppMessage(options: any): Promise<any> {
    const url = `${this.cloudFunctionURL}/sendWhatsAppMessage`;
    return this.http.post(url, options).toPromise();
  }


  getFileStoragePath(partialPath: string) {
    let fileStoragePath = ''
    if (this.accountId) {
      fileStoragePath = `accounts/${this.accountId}/`;
    }
    fileStoragePath += `users/${this.userId}/${partialPath}`;
    return fileStoragePath;
  }

  putCustomerUploadTask(fileStoragePath, file) {
    const fullStoragePath = this.getFileStoragePath(fileStoragePath);
    try {
      return this.getCustomerUploadTask(fullStoragePath, file).then((task) => {
        const ref = this.customerStorage.ref(fullStoragePath);
        return ref.getDownloadURL().toPromise()
      })
    } catch (error) {
      console.error('Error putting customer upload task:', error);
    }
  }
  async logOutFromCustDb() {
    this._isAuthenticatedOnCustDb.next(false);
    this.app2.auth.signOut();
    this.secondApp.auth.signOut();
    this.baseApp2.auth.signOut();

  }

  setLocations(locations: any[]) {
    this._locations.next(locations);
  }

  getLocations() {
    return this._locations.asObservable();
  }

  async saveWorkspaceTabs(tabs: any[], activeTabId: string): Promise<void> {
    if (this.app2 == undefined || !this.app2.firestore || !this.userId) {
      console.warn('[CustomerdatabaseService] saveWorkspaceTabs skipped: app2 not ready or no userId');
      return;
    }
    try {
      const sanitizedTabs = JSON.parse(JSON.stringify(tabs, (_, v) => v === undefined ? null : v));
      const payload = {
        tabs: sanitizedTabs,
        activeTabId: activeTabId,
        updatedAt: new Date().toISOString()
      };
      await this.app2.firestore
        .collection('users').doc(this.userId)
        .collection('workspaceTabs').doc('state')
        .set(payload, { merge: true });
      console.log('[CustomerdatabaseService] Saved', tabs.length, 'workspace tabs to Firestore for user', this.userId);
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to save workspace tabs:', e);
    }
  }

  async loadWorkspaceTabs(): Promise<{ tabs: any[]; activeTabId: string } | null> {
    if (this.app2 == undefined || !this.app2.firestore || !this.userId) {
      console.warn('[CustomerdatabaseService] loadWorkspaceTabs skipped: app2 not ready or no userId');
      return null;
    }
    try {
      const doc = await this.app2.firestore
        .collection('users').doc(this.userId)
        .collection('workspaceTabs').doc('state')
        .get();
      if (doc.exists) {
        const data = doc.data();
        console.log('[CustomerdatabaseService] Loaded workspace tabs from Firestore:', data.tabs?.length || 0, 'tabs for user', this.userId);
        return {
          tabs: data.tabs || [],
          activeTabId: data.activeTabId || ''
        };
      }
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to load workspace tabs:', e);
    }
    return null;
  }

  async saveAutoSearchResults(type: 'generalPool' | 'linkedin', data: any): Promise<void> {
    if (this.app2 == undefined || !this.app2.firestore || !this.userId) {
      console.warn('[CustomerdatabaseService] saveAutoSearchResults skipped: app2 not ready or no userId');
      return;
    }
    try {
      const sanitized = JSON.parse(JSON.stringify(data, (_, v) => v === undefined ? null : v));
      await this.app2.firestore
        .collection('users').doc(this.userId)
        .collection('autoSearchResults').doc(type)
        .set(sanitized, { merge: true });
      console.log('[CustomerdatabaseService] Saved autoSearchResults/', type, 'for user', this.userId);
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to save autoSearchResults/' + type + ':', e);
    }
  }

  async loadAutoSearchResults(type: 'generalPool' | 'linkedin'): Promise<any> {
    if (this.app2 == undefined || !this.app2.firestore || !this.userId) {
      return null;
    }
    try {
      const doc = await this.app2.firestore
        .collection('users').doc(this.userId)
        .collection('autoSearchResults').doc(type)
        .get();
      if (doc.exists) {
        return doc.data();
      }
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to load autoSearchResults/' + type + ':', e);
    }
    return null;
  }

  async getDailyTodos(dateStr: string): Promise<{ todos: any[]; generatedAt: string } | null> {
    if (!this.app2) return null;
    try {
      const snap = await this.app2.firestore.collection('dailyTodos')
        .where('date', '==', dateStr)
        .limit(1)
        .get();
      if (!snap.empty) {
        const data = snap.docs[0].data();
        return { todos: data.todos || [], generatedAt: data.generatedAt || '' };
      }
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to load daily todos:', e);
    }
    return null;
  }

  async saveDailyTodos(dateStr: string, todos: any[]): Promise<void> {
    if (!this.app2) return;
    try {
      const col = this.app2.firestore.collection('dailyTodos');
      const snap = await col.where('date', '==', dateStr).limit(1).get();
      const payload = { date: dateStr, todos, updatedAt: new Date().toISOString() };
      if (!snap.empty) {
        await snap.docs[0].ref.update(payload);
      } else {
        await col.add({ ...payload, generatedAt: new Date().toISOString() });
      }
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to save daily todos:', e);
    }
  }

  async updateTodoStatus(dateStr: string, todoId: string, done: boolean): Promise<void> {
    if (!this.app2) return;
    try {
      const snap = await this.app2.firestore.collection('dailyTodos')
        .where('date', '==', dateStr)
        .limit(1)
        .get();
      if (!snap.empty) {
        const doc = snap.docs[0];
        const todos: any[] = doc.data().todos || [];
        const idx = todos.findIndex(t => t.id === todoId);
        if (idx !== -1) {
          todos[idx].done = done;
          await doc.ref.update({ todos, updatedAt: new Date().toISOString() });
        }
      }
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to update todo status:', e);
    }
  }

  getExternalJobOffers(): firebase.firestore.CollectionReference {
    if (!this.app2) return null;
    return this.app2.firestore.collection(FirebaseConstants.externalJobOffers);
  }

  async addExternalJobOffer(data: any): Promise<any> {
    if (!this.app2) return null;
    data.created = new Date();
    data.createdISO = new Date().toISOString();
    return this.app2.firestore.collection(FirebaseConstants.externalJobOffers).add(data);
  }

  /**
   * Returns how many offers were actually committed. Returning silently when
   * Firestore is unavailable used to let the caller report a successful import
   * while nothing had been written.
   */
  async addExternalJobOffersBatch(offers: any[]): Promise<number> {
    if (!this.app2) {
      throw new Error('Firestore is not available, external job offers were not saved');
    }
    if (!offers || offers.length === 0) {
      return 0;
    }
    const BATCH_LIMIT = 499;
    let written = 0;
    for (let i = 0; i < offers.length; i += BATCH_LIMIT) {
      const chunk = offers.slice(i, i + BATCH_LIMIT);
      const batch = (this.app2.firestore.firestore || this.app2.firestore).batch();
      for (const offer of chunk) {
        const ref = this.app2.firestore.collection(FirebaseConstants.externalJobOffers).doc();
        offer.created = new Date();
        offer.createdISO = new Date().toISOString();
        batch.set(ref, offer);
      }
      await batch.commit();
      written += chunk.length;
    }
    return written;
  }

  async bulkImportExternalJobOffers(rawContent: string, contentType: string): Promise<any> {
    const apiKey = await this.getApiKey();
    const uid = this.authService.returnUserId();
    const payload = {
      apiKey: apiKey,
      uid: uid,
      rawContent: rawContent,
      contentType: contentType,
      permission: 'executeAgents'
    };
    try {
      const response: any = await this.http.post(
        environment.CLOUD_URL_BASE + '/agent/bulkImportExternalJobOffers',
        payload,
        { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${apiKey}` } }
      ).toPromise();
      return response;
    } catch (error) {
      console.error('Error bulk importing external job offers:', error);
      throw error;
    }
  }

  /**
   * Imports applicants so the agents get enriched data. Pushes into the
   * emailapplicants collection, which fires the CV enrichment trigger
   * (FirestoreTriggerEmailApplicantWithCV). That trigger parses extractedText
   * and writes the fully enriched applicant into the applicants collection.
   */
  async importApplicantsForEnrichment(applicants: any[]): Promise<any> {
    if (!applicants || applicants.length === 0) {
      return { count: 0, ids: [] };
    }
    const apiKey = await this.getApiKey();
    const uid = this.authService.returnUserId();
    const mapped = applicants.map((profil) => buildApplicantImportDoc(profil));
    const requestBody = {
      endpoint: 'pushApplicantsToEmailApplicants',
      apiKey: apiKey,
      uid: uid,
      platform: 'MONA',
      applicants: mapped
    };
    const response: any = await this.http.post(this.API_URL, requestBody, {
      headers: { 'Content-Type': 'application/json' }
    }).toPromise();
    if (response && response.success === false) {
      throw new Error(response.message || 'pushApplicantsToEmailApplicants rejected the import');
    }
    return response;
  }

  getExternalJobOfferDetail(id: string): firebase.firestore.DocumentReference {
    if (!this.app2) return null;
    return this.app2.firestore.collection(FirebaseConstants.externalJobOffers).doc(id);
  }

  async addExternalJobOffersFromScraper(jobs: any[], sourceUrl: string): Promise<string[]> {
    if (!this.app2) return [];
    
    const existingSnap = await this.app2.firestore
      .collection(FirebaseConstants.externalJobOffers)
      .get();
    const existingJobs = new Set<string>();
    existingSnap.docs.forEach(doc => {
      const data = doc.data();
      const key = this.generateJobDedupeKey(data.title || data.jobTitle, data.location, data.sourceUrl);
      existingJobs.add(key);
    });

    const ids: string[] = [];
    let skipped = 0;
    for (const job of jobs) {
      const key = this.generateJobDedupeKey(job.title, job.location, sourceUrl);
      if (existingJobs.has(key)) {
        skipped++;
        continue;
      }
      existingJobs.add(key);

      const doc = await this.app2.firestore.collection(FirebaseConstants.externalJobOffers).add({
        jobTitle: job.title || '',
        description: job.description || '',
        tasks: job.tasks || '',
        qualifications: job.qualifications || '',
        benefits: job.benefits || '',
        requirements: job.requirements || [],
        location: job.location || '',
        type: job.type || '',
        department: job.department || '',
        applicationUrl: job.application_url || '',
        company: job.company || '',
        sourceUrl: sourceUrl,
        syncUrl: sourceUrl,
        created: new Date(),
        createdISO: new Date().toISOString()
      });
      ids.push(doc.id);
    }
    if (skipped > 0) {
      console.log('[CustomerdatabaseService] Skipped', skipped, 'duplicate jobs during import');
    }
    return ids;
  }

  async deleteExternalJobOffer(id: string): Promise<void> {
    if (!this.app2) return;
    await this.app2.firestore.collection(FirebaseConstants.externalJobOffers).doc(id).delete();
  }

  async deleteAllExternalJobOffers(): Promise<void> {
    if (!this.app2) return;
    const snap = await this.app2.firestore.collection(FirebaseConstants.externalJobOffers).get();
    const BATCH_LIMIT = 499;
    const docs = snap.docs;
    for (let i = 0; i < docs.length; i += BATCH_LIMIT) {
      const batch = (this.app2.firestore.firestore || this.app2.firestore).batch();
      docs.slice(i, i + BATCH_LIMIT).forEach(doc => batch.delete(doc.ref));
      await batch.commit();
    }
  }

  async updateExternalJobOffer(id: string, data: any): Promise<void> {
    if (!this.app2) return;
    data.updated = new Date();
    await this.app2.firestore.collection(FirebaseConstants.externalJobOffers).doc(id).update(data);
  }

  async updateBrandingCompanyData(updateData: any): Promise<void> {
    const snap = await this.getProfile().get();
    if (snap.docs.length > 0) {
      const docId = snap.docs[0].id;
      await this.app2.firestore
        .collection(FirebaseConstants.branding)
        .doc(docId)
        .update(updateData);
    }
  }

  listenAllAppointments(cb: (docs: any[]) => void): () => void {
    if (!this.app2) return () => {};
    try {
      return this.app2.firestore
        .collection('appointments')
        .orderBy('start_time', 'asc')
        .onSnapshot((snap: any) => cb(snap.docs.map((d: any) => ({ id: d.id, ...d.data() }))));
    } catch (err) {
      console.error('[ARS] listenAllAppointments error:', err);
      return () => {};
    }
  }

  async updateAppointmentStatus(appointmentId: string, status: string): Promise<void> {
    if (!this.app2) return;
    await this.app2.firestore.collection('appointments').doc(appointmentId).update({ status });
  }

  async getArsMatchingApplicantById(matchingId: string, applicantId: string): Promise<any> {
    if (!this.app2) return null;
    try {
      const doc = await this.app2.firestore
        .collection('ars_matchings').doc(matchingId)
        .collection('applicants').doc(applicantId)
        .get();
      return doc.exists ? { id: doc.id, ...doc.data() } : null;
    } catch (err) {
      console.error('[ARS] getArsMatchingApplicantById error:', err);
      return null;
    }
  }

  async getArsSchedulingUpdates(matchingId: string): Promise<any[]> {
    if (!this.app2) return [];
    try {
      const snap = await this.app2.firestore
        .collection('scheduling_updates')
        .where('matching_id', '==', matchingId)
        .get();
      return snap.docs
        .map((d: any) => ({ id: d.id, ...d.data() }))
        .sort((a: any, b: any) => (a.timestampISO || '').localeCompare(b.timestampISO || ''));
    } catch (err) {
      console.error('[ARS] getArsSchedulingUpdates error:', err);
      return [];
    }
  }

  async getArsWaitlistByMatching(matchingId: string): Promise<any[]> {
    if (!this.app2) return [];
    try {
      const snap = await this.app2.firestore
        .collection('candidateWaitlist')
        .where('matching_id', '==', matchingId)
        .get();
      return snap.docs.map((d: any) => ({ id: d.id, ...d.data() }));
    } catch (err) {
      console.error('[ARS] getArsWaitlistByMatching error:', err);
      return [];
    }
  }

  listenArsSchedulingUpdates(matchingId: string, cb: (docs: any[]) => void): () => void {
    if (!this.app2) return () => {};
    try {
      return this.app2.firestore
        .collection('scheduling_updates')
        .where('matching_id', '==', matchingId)
        .onSnapshot((snap: any) => {
          const docs = snap.docs
            .map((d: any) => ({ id: d.id, ...d.data() }))
            .sort((a: any, b: any) => (a.timestampISO || '').localeCompare(b.timestampISO || ''));
          cb(docs);
        });
    } catch (err) {
      console.error('[ARS] listenArsSchedulingUpdates error:', err);
      return () => {};
    }
  }

  listenArsAppointments(matchingId: string, cb: (docs: any[]) => void): () => void {
    if (!this.app2) return () => {};
    try {
      return this.app2.firestore
        .collection('appointments')
        .where('matching_id', '==', matchingId)
        .onSnapshot((snap: any) => {
          const docs = snap.docs
            .map((d: any) => ({ id: d.id, ...d.data() }))
            .sort((a: any, b: any) => (a.start_time || '').localeCompare(b.start_time || ''));
          cb(docs);
        });
    } catch (err) {
      console.error('[ARS] listenArsAppointments error:', err);
      return () => {};
    }
  }

  listenArsWaitlist(matchingId: string, cb: (docs: any[]) => void): () => void {
    if (!this.app2) return () => {};
    try {
      return this.app2.firestore
        .collection('candidateWaitlist')
        .where('matching_id', '==', matchingId)
        .onSnapshot((snap: any) => cb(snap.docs.map((d: any) => ({ id: d.id, ...d.data() }))));
    } catch (err) {
      console.error('[ARS] listenArsWaitlist error:', err);
      return () => {};
    }
  }

  async getArsMatches(): Promise<any[]> {
    if (this.app2 == undefined) return [];
    try {
      const snap = await this.app2.firestore
        .collection('ars_matches')
        .orderBy('timestamp', 'desc')
        .limit(30)
        .get();
      if (snap.empty) return [];
      return snap.docs.map((doc: any) => ({ id: doc.id, ...doc.data() }));
    } catch (err) {
      console.error('[ARS] getArsMatches error:', err);
      return [];
    }
  }

  async getArsMatchings(): Promise<any[]> {
    if (this.app2 == undefined) return [];
    try {
      const snap = await this.app2.firestore
        .collection('ars_matchings')
        .limit(20)
        .get();
      if (snap.empty) return [];
      return snap.docs
        .map((doc: any) => ({ id: doc.id, ...doc.data() }))
        .sort((a: any, b: any) => (b.createdISO || '').localeCompare(a.createdISO || ''));
    } catch (err) {
      console.error('[ARS] getArsMatchings error:', err);
      return [];
    }
  }

  async getArsMatchingApplicants(matchingId: string): Promise<any[]> {
    if (this.app2 == undefined) return [];
    try {
      const snap = await this.app2.firestore
        .collection('ars_matchings')
        .doc(matchingId)
        .collection('applicants')
        .orderBy('score', 'desc')
        .get();
      if (snap.empty) return [];
      return snap.docs.map((doc: any) => ({ id: doc.id, ...doc.data() }));
    } catch (err) {
      console.error('[ARS] getArsMatchingApplicants error:', err);
      return [];
    }
  }

  async getTeamMembers(): Promise<{ email: string; name: string | null }[]> {
    if (this.app2 == undefined) return [];
    try {
      const snap = await this.app2.firestore.collection('teammembers').get();
      if (snap.empty) return [];
      return snap.docs.map((doc: any) => {
        const data = doc.data();
        const name = data?.googleProfile?.name || data?.name || null;
        return { email: data.email, name };
      }).filter((m: any) => !!m.email);
    } catch (err) {
      console.error('[ARS] getTeamMembers error:', err);
      return [];
    }
  }

  async getCalendarStatus(): Promise<{ connected: boolean; service: 'google' | 'microsoft' | null; email: string | null }> {
    if (this.app2 == undefined) return { connected: false, service: null, email: null };
    try {
      const tmSnap = await this.getTeammembers().get();
      const own = pickOwnCalendar(tmSnap.docs.map((doc: any) => doc.data()), this.authService.returnUser());
      if (own) return { connected: true, service: own.service, email: own.email };

      const snap = await this.getProfile().get();
      if (snap.empty) return { connected: false, service: null, email: null };
      const data = snap.docs[0].data();

      if (data?.microsoftRefreshToken) {
        return {
          connected: true,
          service: 'microsoft',
          email: data.microsoftProfile?.mail || data.microsoftProfile?.userPrincipalName || null
        };
      }
      if (data?.googleRefreshToken) {
        return {
          connected: true,
          service: 'google',
          email: data.googleProfile?.email || null
        };
      }
      return { connected: false, service: null, email: null };
    } catch (err) {
      console.error('[ARS] getCalendarStatus error:', err);
      return { connected: false, service: null, email: null };
    }
  }

  async syncAgentCalendarPreference(): Promise<ConnectedCalendar | null> {
    try {
      if (!(await this.waitForCustomerDbReady())) return null;
      const uid = this.authService.returnUserId();
      const loginEmail = this.authService.returnUser();
      if (!uid || !loginEmail) return null;

      const tmSnap = await this.getTeammembers().get();
      const members = tmSnap.docs.map((doc: any) => doc.data());
      const calendar = pickOwnCalendar(members, loginEmail);
      if (!calendar) return null;

      const preferences = this.app2.firestore.collection(FirebaseConstants.preferences);
      for (const key of AGENT_CALENDAR_PREFERENCE_KEYS) {
        const ref = preferences.doc(agentPreferenceDocId(uid, key));
        const current = await ref.get();
        if (!preferenceNeedsUpdate(current.exists ? current.data()?.value : null, members, calendar)) continue;
        await ref.set({
          user_id: uid,
          account_id: this.accountId || null,
          key,
          value: calendar.email,
          confidence: 'explicit',
          evidence_count: 1,
          last_updated: firebase.firestore.FieldValue.serverTimestamp(),
        });
      }
      return calendar;
    } catch (err) {
      console.error('[ARS] syncAgentCalendarPreference error:', err);
      return null;
    }
  }

  async ensureTeammemberHasCalendarTokens(): Promise<void> {
    if (this.app2 == undefined) return;
    try {
      const profileSnap = await this.getProfile().get();
      if (profileSnap.empty) return;
      const branding = profileSnap.docs[0].data();

      const hasMicrosoft = !!branding?.microsoftRefreshToken;
      const hasGoogle = !!branding?.googleRefreshToken;
      if (!hasMicrosoft && !hasGoogle) return;

      const email = hasMicrosoft
        ? (branding.microsoftProfile?.mail || branding.microsoftProfile?.userPrincipalName)
        : branding.googleProfile?.email;
      if (!email) return;

      const tmSnap = await this.app2.firestore
        .collection('teammembers')
        .where('email', '==', email)
        .limit(1)
        .get();

      if (!tmSnap.empty) {
        const doc = tmSnap.docs[0];
        const existing = doc.data();
        const needsUpdate: any = {};

        if (hasMicrosoft && !existing.microsoftRefreshToken) {
          needsUpdate.microsoftAccessToken = branding.microsoftAccessToken;
          needsUpdate.microsoftRefreshToken = branding.microsoftRefreshToken;
          needsUpdate.microsoftProfile = branding.microsoftProfile;
        }
        if (hasGoogle && !existing.googleRefreshToken) {
          needsUpdate.googleAccessToken = branding.googleAccessToken;
          needsUpdate.googleRefreshToken = branding.googleRefreshToken;
          needsUpdate.googleProfile = branding.googleProfile;
        }

        if (Object.keys(needsUpdate).length > 0) {
          await this.app2.firestore.collection('teammembers').doc(doc.id).update(needsUpdate);
        }
      } else {
        const newDoc: any = { email, created: new Date(), createdIso: new Date().toISOString().split('T')[0] };
        if (hasMicrosoft) {
          newDoc.microsoftAccessToken = branding.microsoftAccessToken;
          newDoc.microsoftRefreshToken = branding.microsoftRefreshToken;
          newDoc.microsoftProfile = branding.microsoftProfile;
        }
        if (hasGoogle) {
          newDoc.googleAccessToken = branding.googleAccessToken;
          newDoc.googleRefreshToken = branding.googleRefreshToken;
          newDoc.googleProfile = branding.googleProfile;
        }
        await this.app2.firestore.collection('teammembers').add(newDoc);
      }
    } catch (err) {
      console.error('[ARS] ensureTeammemberHasCalendarTokens error:', err);
    }
  }

  async generateTestApplicant(): Promise<string> {
    const firstNames = [
      'Jane', 'Max', 'Anna', 'Lukas', 'Sophie', 'Tim', 'Laura', 'Felix', 'Marie', 'Jonas',
      'Sarah', 'Tobias', 'Lena', 'Markus', 'Julia', 'Sebastian', 'Katharina', 'Daniel', 'Nina', 'Philipp',
      'Elena', 'Christian', 'Claudia', 'Stefan', 'Melanie', 'Andreas', 'Franziska', 'Jan', 'Sabine', 'Patrick'
    ];
    const lastNames = [
      'Muster', 'Beispiel', 'Schmidt', 'Fischer', 'Weber', 'Meyer', 'Wagner', 'Becker', 'Schulz', 'Hoffmann',
      'Koch', 'Richter', 'Klein', 'Wolf', 'Schröder', 'Neumann', 'Schwarz', 'Zimmermann', 'Braun', 'Hartmann',
      'Krüger', 'Lange', 'Werner', 'Lehmann', 'Köhler', 'Maier', 'Hermann', 'König', 'Huber', 'Kaiser'
    ];
    const cities = [
      'Berlin', 'München', 'Hamburg', 'Köln', 'Frankfurt', 'Stuttgart', 'Düsseldorf', 'Leipzig', 'Dresden', 'Nürnberg',
      'Hannover', 'Bremen', 'Essen', 'Dortmund', 'Bonn', 'Mannheim', 'Karlsruhe', 'Augsburg', 'Wiesbaden', 'Potsdam'
    ];
    const zipMap = {
      'Berlin': '10115', 'München': '80331', 'Hamburg': '20095', 'Köln': '50667', 'Frankfurt': '60311',
      'Stuttgart': '70173', 'Düsseldorf': '40213', 'Leipzig': '04109', 'Dresden': '01067', 'Nürnberg': '90402',
      'Hannover': '30159', 'Bremen': '28195', 'Essen': '45127', 'Dortmund': '44135', 'Bonn': '53111',
      'Mannheim': '68159', 'Karlsruhe': '76131', 'Augsburg': '86150', 'Wiesbaden': '65183', 'Potsdam': '14467'
    };
    const streets = [
      'Musterstraße', 'Hauptstraße', 'Bahnhofstraße', 'Berliner Straße', 'Gartenweg', 'Ringstraße',
      'Schillerstraße', 'Goethestraße', 'Mozartstraße', 'Lindenallee', 'Parkstraße', 'Waldweg',
      'Am Markt', 'Kirchgasse', 'Rosenweg', 'Friedrichstraße', 'Bismarckstraße', 'Industriestraße'
    ];
    const jobTitles = [
      'Softwareentwickler', 'Projektmanager', 'Buchhalter', 'Vertriebsmitarbeiter', 'Marketingmanager',
      'Personalreferent', 'IT-Administrator', 'Grafikdesigner', 'Kundenbetreuer', 'Einkäufer',
      'Logistikkoordinator', 'Produktionsleiter', 'Qualitätsmanager', 'Elektriker', 'Mechatroniker',
      'Bürokauffrau', 'Einzelhandelskaufmann', 'Lagermitarbeiter', 'Pflegehelferin', 'Koch',
      'Empfangsmitarbeiter', 'Finanzbuchhalter', 'Controller', 'Data Analyst', 'DevOps Engineer',
      'Full Stack Developer', 'Backend Entwickler', 'Frontend Entwickler', 'Scrum Master', 'UX Designer',
      'Helferin in der Produktion', 'Mechaniker', 'Schweißer', 'CNC-Fräser', 'Schreiner'
    ];
    const companies = [
      'Siemens AG', 'Bosch GmbH', 'Deutsche Telekom', 'SAP SE', 'BMW Group',
      'Allianz SE', 'BASF SE', 'Continental AG', 'Daimler AG', 'Bayer AG',
      'TechVision GmbH', 'DataFlow Solutions', 'CloudFirst AG', 'FinanzPlus GmbH', 'MediCare Services',
      'LogiTrans GmbH', 'BauPlan AG', 'GreenEnergy Solutions', 'SmartFactory GmbH', 'DigiMarketing AG',
      'AutoParts GmbH', 'FoodService Deutschland', 'SecureIT Solutions', 'BioTech Innovations', 'RetailPro GmbH'
    ];
    const positions = [
      'Software Engineer', 'Senior Developer', 'Junior Entwickler', 'Teamleiter', 'Abteilungsleiter',
      'Sachbearbeiter', 'Projektassistent', 'Werkstudent', 'Praktikant', 'Trainee',
      'Account Manager', 'Sales Representative', 'Marketing Specialist', 'HR Business Partner', 'Recruiter',
      'System Administrator', 'DevOps Ingenieur', 'Datenbank Administrator', 'Netzwerktechniker', 'IT Support',
      'Produktionsmitarbeiter', 'Lagerhelferin', 'Aushilfe', 'Schichtleiter', 'Meister',
      'Buchhalter', 'Controller', 'Einkaufsleiter', 'Qualitätsprüfer', 'Kundenberater'
    ];
    const degrees = ['Hauptschulabschluss', 'Realschulabschluss', 'Abitur', 'Fachabitur', 'Bachelor of Science', 'Bachelor of Arts', 'Master of Science', 'Master of Arts', 'Diplom', 'Promotion'];
    const institutions = [
      'TU München', 'TU Berlin', 'Universität Hamburg', 'RWTH Aachen', 'Universität Köln',
      'FU Berlin', 'Humboldt-Universität', 'Universität Stuttgart', 'LMU München', 'Universität Frankfurt',
      'Hochschule Mannheim', 'FH Dortmund', 'Berufsschule Zentrum', 'Handelsschule Hamburg',
      'Realschule am Park', 'Gymnasium Musterstadt', 'Gesamtschule Nordstadt', 'Berufskolleg Süd'
    ];
    const certNames = [
      'Gabelstaplerschein', 'Erste-Hilfe-Kurs', 'Schweißerschein', 'Führerschein Klasse C', 'SAP Grundkurs',
      'AWS Cloud Practitioner', 'Scrum Master Zertifikat', 'ITIL Foundation', 'PMP Zertifikat', 'Six Sigma Green Belt',
      'Google Analytics Zertifikat', 'Microsoft Azure Fundamentals', 'Datenschutzbeauftragter', 'Brandschutzhelfer'
    ];
    const skills = [
      'JavaScript', 'TypeScript', 'Python', 'Java', 'C#', 'SQL', 'HTML/CSS', 'React', 'Angular', 'Node.js',
      'SAP', 'Excel', 'PowerPoint', 'Salesforce', 'Jira', 'Git', 'Docker', 'Kubernetes', 'AWS', 'Azure',
      'Projektmanagement', 'Teamführung', 'Verhandlung', 'Buchhaltung', 'Controlling', 'Einkauf',
      'Kundenbetreuung', 'Qualitätsmanagement', 'Lean Management', 'Scrum', 'Kanban', 'Agile',
      'Schweißen', 'CNC-Programmierung', 'Elektrotechnik', 'Maschinenbau', 'Logistik', 'Lagerverwaltung',
      'Pflege', 'Kochen', 'Reinigung', 'Montage', 'Verpackung', 'Kommissionierung'
    ];
    const nationalities = ['Deutsch', 'Österreichisch', 'Schweizerisch', 'Türkisch', 'Polnisch', 'Italienisch', 'Kroatisch', 'Rumänisch', 'Griechisch', 'Spanisch'];
    const thirdLanguages = ['Französisch', 'Spanisch', 'Türkisch', 'Polnisch', 'Italienisch', 'Russisch', 'Arabisch', 'Portugiesisch', 'Chinesisch', 'Japanisch'];
    const proficiencies = ['Grundkenntnisse', 'Gut', 'Fließend', 'Muttersprachlich'];

    const rand = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)];
    const randNum = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
    const randSubset = (arr: string[], min: number, max: number) => {
      const n = randNum(min, max);
      const shuffled = [...arr].sort(() => Math.random() - 0.5);
      return shuffled.slice(0, n);
    };

    const firstName = rand(firstNames);
    const lastName = rand(lastNames);
    const city = rand(cities);
    const zipCode = zipMap[city] || String(randNum(10000, 99999));
    const street = rand(streets);
    const houseNumber = String(randNum(1, 150)) + (Math.random() > 0.8 ? ['a', 'b', 'c', ' B', ' A'][randNum(0, 4)] : '');
    const jobTitle = rand(jobTitles);
    const phone = '+491' + String(randNum(5000000000, 9999999999));
    const emailAddr = `${firstName.toLowerCase()}.${lastName.toLowerCase()}${randNum(1, 999)}@mona-ai.de`;
    const birthYear = randNum(1965, 2002);
    const birthDate = `${String(randNum(1, 28)).padStart(2, '0')}.${String(randNum(1, 12)).padStart(2, '0')}.${birthYear}`;

    const numJobs = randNum(1, 5);
    const berufserfahrung = [];
    const jobExpTitles = [];
    const jobExpTitlesLower = [];
    let currentYear = new Date().getFullYear();
    for (let i = 0; i < numJobs; i++) {
      const endY = i === 0 ? 'heute' : String(randNum(Math.max(currentYear - 3, 2005), currentYear));
      const startM = String(randNum(1, 12)).padStart(2, '0');
      const duration = randNum(1, 6);
      const startY = String(Math.max(parseInt(String(currentYear)) - duration, 2000));
      const company = rand(companies);
      const position = rand(positions);
      const beschreibung = Math.random() > 0.4
        ? randSubset([
            'Verantwortlich für Teamleitung und Projektkoordination',
            'Entwicklung und Wartung von Softwarelösungen',
            'Kundenbetreuung und Beratung',
            'Bearbeitung von Aufträgen und Rechnungen',
            'Planung und Durchführung von Marketingkampagnen',
            'Qualitätskontrolle und Prozessoptimierung',
            'Logistik und Lagerverwaltung',
            'Pflege und Betreuung von Patienten',
            'Erstellung von Reports und Analysen',
            'Budgetplanung und Kostenkontrolle'
          ], 1, 3).join('. ')
        : '';
      berufserfahrung.push({
        Beschreibung: beschreibung,
        NameOfCompany: company,
        NameOfPosition: position,
        endDate: endY,
        startDate: `${startM}/${startY}`
      });
      const title = `${position} at ${company} from ${startM}/${startY} to ${endY} - ${beschreibung}`.trim();
      jobExpTitles.push(title);
      jobExpTitlesLower.push(title.toLowerCase());
      currentYear = parseInt(startY) - 1;
    }

    const numEdu = randNum(1, 3);
    const ausbildung = [];
    const eduTitles = [];
    const eduTitlesLower = [];
    const emptyLocation = { city: '', country: '', state: '', street: '', zipCode: '' };
    for (let i = 0; i < numEdu; i++) {
      const isCert = i === 0 && Math.random() > 0.5;
      const degreeName = isCert ? rand(certNames) : rand(degrees);
      const degreeType = isCert ? 'Zertifikat' : 'Abschluss';
      const inst = isCert ? '' : rand(institutions);
      const instType = isCert ? '' : (inst.includes('Universität') || inst.includes('TU ') || inst.includes('FU ') || inst.includes('LMU') || inst.includes('RWTH') ? 'Universität' : inst.includes('Hochschule') || inst.includes('FH ') ? 'Fachhochschule' : 'Schule');
      const endDate = String(randNum(2000, 2024));
      const loc = isCert ? emptyLocation : { city: rand(cities), country: 'Deutschland', state: '', street: '', zipCode: '' };
      const major = !isCert && Math.random() > 0.5 ? rand(['Informatik', 'BWL', 'Maschinenbau', 'Elektrotechnik', 'Medizin', 'Jura', 'Wirtschaftsinformatik', 'Psychologie', 'Medien', 'Sozialwissenschaften']) : '';
      ausbildung.push({
        activitiesAndSocieties: [],
        advisor: '',
        certificationsReceived: [],
        degreeName,
        degreeType,
        description: '',
        endDate,
        gpa: Math.random() > 0.7 ? String(parseFloat((Math.random() * 2 + 1).toFixed(1))) : '',
        gradingScale: '',
        honors: [],
        institution: inst,
        institutionType: instType,
        location: loc,
        major,
        minor: '',
        projectsCompleted: [],
        relevantCoursework: [],
        startDate: major ? String(parseInt(endDate) - randNum(2, 5)) : '',
        thesisTitle: '',
        website: ''
      });
      const title = `${degreeName}${major ? ' in ' + major : ''} - ${inst}`;
      eduTitles.push(title);
      eduTitlesLower.push(title.toLowerCase());
    }

    const langSkills = [
      { certification: '', language: 'Deutsch', proficiency: rand(['Muttersprachlich', 'Fließend']) },
      { certification: '', language: 'Englisch', proficiency: rand(proficiencies) }
    ];
    const langs = ['Deutsch', 'Englisch'];
    if (Math.random() > 0.5) {
      const third = rand(thirdLanguages);
      langSkills.push({ certification: '', language: third, proficiency: rand(['Grundkenntnisse', 'Gut']) });
      langs.push(third);
    }

    const applicantSkills = randSubset(skills, 2, 8);

    const now = new Date();
    const createdISO = now.toISOString().replace('Z', '+00:00Z');

    const applicantData: any = {
      Ausbildung: ausbildung,
      Berufserfahrung: berufserfahrung,
      anonymousId: this.generateRandomId(20),
      city,
      country: 'Deutschland',
      createdISO,
      cv: 'https://storage.googleapis.com/mona-test1.appspot.com/tempTestFolder/Jane_Muster_Helfer_lebenslauf.pdf',
      educationTitles: eduTitles,
      educationTitles_lower: eduTitlesLower,
      email: emailAddr,
      email_lower: emailAddr.toLowerCase(),
      firstName,
      firstName_lower: firstName.toLowerCase(),
      geburtsdatum: birthDate,
      geburtsstadt: rand(cities),
      hausnummer: houseNumber,
      jobExperienceTitles: jobExpTitles,
      jobExperienceTitles_lower: jobExpTitlesLower,
      jobTitle,
      jobTitle_lower: jobTitle.toLowerCase(),
      languageSkills: langSkills,
      languages: langs,
      languages_lower: langs.map(l => l.toLowerCase()),
      lastName,
      lastName_lower: lastName.toLowerCase(),
      mobilnummer: '',
      nachname: lastName,
      nationality: rand(nationalities),
      nationality_lower: rand(nationalities).toLowerCase(),
      phoneNumber: phone,
      postleitzahl: zipCode,
      residence: {
        city,
        city_lower: city.toLowerCase(),
        continent: 'Europe',
        country: 'Deutschland',
        countryAlpha2: 'DE',
        country_lower: 'deutschland',
        houseNumber,
        houseNumber_lower: houseNumber.toLowerCase(),
        streetName: street,
        streetName_lower: street.toLowerCase(),
        zipCode,
        zipCode_lower: zipCode
      },
      skills: applicantSkills,
      skills_lower: applicantSkills.map(s => s.toLowerCase()),
      strasse: street,
      telefonnummer: phone,
      vorname: firstName
    };

    const docRef = await this.app2.firestore
      .collection(FirebaseConstants.applicants)
      .add(applicantData);

    return docRef.id;
  }

  private generateRandomId(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  async saveExternalJobOffers(jobs: any[], sourceUrl?: string): Promise<void> {
    if (this.app2 == undefined || !this.app2.firestore) {
      console.warn('[CustomerdatabaseService] saveExternalJobOffers skipped: app2 not ready');
      return;
    }
    if (!jobs || jobs.length === 0) {
      console.warn('[CustomerdatabaseService] saveExternalJobOffers skipped: empty job set (avoiding wipe on transient failure)');
      return;
    }
    try {
      const normalizedSource = this.normalizeSyncWebsite(sourceUrl);
      const existingSnap = await this.app2.firestore
        .collection(FirebaseConstants.externalJobOffers)
        .get();

      const staleDocs: any[] = [];
      existingSnap.docs.forEach(doc => {
        const data = doc.data();
        const isMonitorOwned = data.syncSource === 'job-monitor' || !!data.importedAt;
        if (isMonitorOwned) {
          staleDocs.push(doc.ref);
        }
      });

      const BATCH_LIMIT = 499;
      const now = new Date();
      const nowISO = now.toISOString();

      for (let i = 0; i < staleDocs.length; i += BATCH_LIMIT) {
        const chunk = staleDocs.slice(i, i + BATCH_LIMIT);
        const batch = (this.app2.firestore.firestore || this.app2.firestore).batch();
        chunk.forEach(ref => batch.delete(ref));
        await batch.commit();
      }

      for (let i = 0; i < jobs.length; i += BATCH_LIMIT) {
        const chunk = jobs.slice(i, i + BATCH_LIMIT);
        const batch = (this.app2.firestore.firestore || this.app2.firestore).batch();
        for (const job of chunk) {
          const ref = this.app2.firestore.collection(FirebaseConstants.externalJobOffers).doc();
          const jobData = {
            ...job,
            jobTitle: job.title || job.jobTitle || '',
            sourceUrl: sourceUrl || job.sourceUrl || '',
            syncSource: 'job-monitor',
            syncWebsite: normalizedSource,
            importedAt: job.importedAt || nowISO,
            created: now,
            createdISO: nowISO,
            status: job.status || 'active'
          };
          batch.set(ref, jobData);
        }
        await batch.commit();
      }
      console.log('[CustomerdatabaseService] Synced external job offers for', normalizedSource, ': inserted', jobs.length, ', removed', staleDocs.length, 'previous monitor jobs');
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to save external job offers:', e);
    }
  }

  private normalizeSyncWebsite(url: string): string {
    return (url || '')
      .toLowerCase()
      .trim()
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .replace(/\/+$/, '');
  }

  private generateJobDedupeKey(title: string, location: string, sourceUrl: string): string {
    const normalizedTitle = (title || '').toLowerCase().trim().replace(/\s+/g, ' ');
    const normalizedLocation = (location || '').toLowerCase().trim().replace(/\s+/g, ' ');
    const normalizedUrl = (sourceUrl || '').toLowerCase().trim();
    return `${normalizedTitle}|${normalizedLocation}|${normalizedUrl}`;
  }

  async loadExternalJobOffers(): Promise<any[]> {
    if (this.app2 == undefined || !this.app2.firestore) {
      return [];
    }
    try {
      // Ordering inside the query silently drops documents that have no
      // "created" field, which hid imported and backend-written job offers.
      const snap = await this.app2.firestore
        .collection(FirebaseConstants.externalJobOffers)
        .get();
      return snap.docs
        .map(doc => ({ id: doc.id, ...doc.data(), docId: doc.id } as any))
        .sort((a: any, b: any) => this.externalJobSortValue(b) - this.externalJobSortValue(a));
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to load external job offers:', e);
      return [];
    }
  }

  private externalJobSortValue(data: any): number {
    for (const value of [data?.created, data?.createdISO, data?.importedAt, data?.updatedAt]) {
      if (!value) continue;
      if (typeof value?.toDate === 'function') return value.toDate().getTime();
      const parsed = new Date(value).getTime();
      if (!isNaN(parsed)) return parsed;
    }
    return 0;
  }

  async getPubSubConnections(): Promise<any[]> {
    if (this.app2 == undefined || !this.app2.firestore) {
      return [];
    }
    try {
      const snap = await this.app2.firestore
        .collection('pubSubConnections')
        .orderBy('monaPubSubConnectionName', 'asc')
        .get();
      return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to load PubSub connections:', e);
      return [];
    }
  }

  async savePubSubConnection(connection: any): Promise<void> {
    if (this.app2 == undefined || !this.app2.firestore) {
      throw new Error('Firestore not initialized');
    }
    try {
      const data = { ...connection };
      delete data.isNew;
      data.updatedAt = new Date().toISOString();

      if (connection.isNew || connection.id?.startsWith('new_')) {
        data.createdAt = new Date().toISOString();
        const docRef = await this.app2.firestore
          .collection('pubSubConnections')
          .add(data);
        connection.id = docRef.id;
      } else {
        await this.app2.firestore
          .collection('pubSubConnections')
          .doc(connection.id)
          .set(data, { merge: true });
      }
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to save PubSub connection:', e);
      throw e;
    }
  }

  async deletePubSubConnection(connectionId: string): Promise<void> {
    if (this.app2 == undefined || !this.app2.firestore) {
      throw new Error('Firestore not initialized');
    }
    try {
      await this.app2.firestore
        .collection('pubSubConnections')
        .doc(connectionId)
        .delete();
    } catch (e) {
      console.error('[CustomerdatabaseService] Failed to delete PubSub connection:', e);
      throw e;
    }
  }

}
